/**
 * Utils
 * @deps jQuery, CT Bootstrap, Underscore
 * @desc This file contains utility methods only - methods that DO NOT modify DOM or perform complex DOM operations. They are meant to be applied on standard arrays, primitives and objects
 *       The functions/methods here are all bound to CT, $ or _ namespace
 *       To add new methods:
 *              CT.utils.<property> = <value>
 *                      or
 *              $.extend($, {<property> : <value>})
 *                      or
 *              $.fn.extend($.fn, {<property> : <value>})
 *                      or
 *              _.mixin({
 *                  <methodName> : <value>
 *              })
 *
 * Use whatever namespace makes sense!
 *
 */




/* ========================= Utils in jQuery ($) namespace =========================== */
// Be the FIRST to add something here :)
//to solve Security issue regarding XSS
if (window.location.href.split('/')[3] === 'hotels') {
  window.addEventListener("load", function () {
      var inputArray = document.querySelectorAll("input")
      for (var i = 0; i < inputArray.length; i++) {
          inputArray[i].addEventListener("blur", function (e) {
              var escapeXml = (function () {
                  var doc = document.implementation.createDocument("", "", null)
                  var el = doc.createElement("temp");
                  el.textContent = "temp";
                  el = el.firstChild;
                  var ser = new XMLSerializer();
                  return function (text) {
                      el.nodeValue = text;
                      return ser.serializeToString(el);
                  };
              })();
              var currentValue = e.target.value
              e.target.value = escapeXml(currentValue)
          });
      }
  });
}










/* ========================= Utils in Cleartrip (CT.utils) namespace =========================== */
window.CT = window.CT || {};
CT.utils = CT.utils || {};
CT.utils = $.extend(CT.utils, {

  fasterDOMInsert: function (html, ele, toAppend) {
      var frag = document.createDocumentFragment(), div = document.createElement('div'), c;
      div.innerHTML = html;
      while (c = div.firstChild) frag.appendChild(c);
      if (ele) {
          if (!toAppend) (ele.get ? ele.get(0) : ele).innerHTML = "";
          ele.appendChild(frag);
      }
      frag = null;
  },

  travelStats: function() {
      var indianDomains = ["qa2.cleartrip.com", "www.cleartrip.com"];
      if (indianDomains.indexOf(window.location.hostname) > -1) {
          var domain = "ct.com";
      } else {
          var domain = "ct.ae";
      }
      // var domain = window.location.hostname.indexOf("ae") > -1 ? "ct.ae" : "ct.com";
      var url = "/node/flight/travelsafe/stats?domain=" + domain;
      $.ajax({
          url: url,
          type: 'GET',
          success: function (travelSafeData) {
              var timestamp = "Travel stats on ";
              var flightTookOffCount = travelSafeData["flightsTookOff"]["count"];
              var isFlightIncrease = travelSafeData["flightsTookOff"]["increase"] != "" ? true : false;
              var flightsTookOffPercentage = isFlightIncrease ? travelSafeData["flightsTookOff"]["increase"] : travelSafeData["flightsTookOff"]["decrease"];
              var passengerCount = travelSafeData["passengersFlew"]["count"];
              var passengerIncrease = travelSafeData["passengersFlew"]["increase"] != "" ? true : false;
              var passengerPercentage = passengerIncrease ? travelSafeData["passengersFlew"]["increase"] : travelSafeData["passengersFlew"]["decrease"];
              var bookingsMade = travelSafeData["bookingMade"];
              timestamp = timestamp.concat(travelSafeData["timeStamp"]);
              var flightColor = isFlightIncrease ? "#46991A" : "#FF3C2B";
              var flightSign = isFlightIncrease ?  " &#8593" : " &#8595";
              var passengerColor = passengerIncrease ? "#46991A" : "#FF3C2B";
              var passengerSign = passengerIncrease ?  " &#8593" : " &#8595;";
              var timeStampElement = document.getElementById("travelsafeStatsTimestamp");
              timeStampElement.className = "";
              timeStampElement.innerHTML = timestamp;

              var bookingsMadeElement = document.getElementById("travelsafeStatsBookingsMade");
              bookingsMadeElement.className = "";
              bookingsMadeElement.innerHTML = bookingsMade;

              var flightNumberElement = document.getElementById("travelsafeStatsFlightsTookOffNumber");
              flightNumberElement.className = "";
              flightNumberElement.innerHTML = flightTookOffCount;                

              if(flightsTookOffPercentage != "") {
                  var flightPercentageElement = document.getElementById("travelsafeStatsFlightsTookOffPercentage");
                  flightPercentageElement.innerHTML = flightsTookOffPercentage.concat(flightSign);
                  flightPercentageElement.style["background"] = flightColor;
              }

              var passengerNumberElement = document.getElementById("travelsafeStatsPassengerNumber");
              passengerNumberElement.className = "";
              passengerNumberElement.innerHTML = passengerCount;
              if(passengerPercentage != ""){
                  var passengerPercentageElement = document.getElementById("travelsafeStatsPassengerPercentage");
                  passengerPercentageElement.style["background"] = passengerColor;
                  passengerPercentageElement.innerHTML = passengerPercentage.concat(passengerSign);
              }
          },
          error: function (error) {
              console.log("Error fetching config from node layer for stats", error);
          }
      });
  },


  abTest: function () {

      /*
      try{
          var cokkie = function (val, key) {
              var ABcookie = CT.utils.cookies.read("ct-ab");
              if(ABcookie){
                  ABcookie  = JSON.parse(unescape(ABcookie));
              }else{
                  ABcookie = {};
              }
              ABcookie[key] = val;
              CT.utils.cookies.create("ct-ab", escape(JSON.stringify(ABcookie)));
          }

          cokkie(window.rhabtest?"A":"B", "air_intl_routehappy");
          cokkie(window.domofferabtest?"b":"a" , "dom_offer_ab");
      }catch(e){}*/


      var $body = $("body");


      if (($body.hasClass("air") || $body.hasClass("hotel")) && ($body.hasClass("home") || $body.hasClass("srp"))) {
          $.ajax({
              url: '/source/abtest/getabtestconfig',
              type: 'GET',
              success: function () {




              },
              error: function () { }
          })
      }


  },

  abTestNames:{
      "flshtl":"fsl"
      ,"Hotels_Desktop_PriceFilter":"hdpf"
      ,"errorEvent":"ferev"
      ,"ptb":"fptb"
      ,"ptb_AE_B2C_intl":"fptbabi"
      ,"ptb_BH_B2C_intl":"fptbbbi"
      ,"ptb_IN_B2C_intl":"fptbibi"
      ,"ptb_KW_B2C_intl":"fptbkbi"
      ,"ptb_OM_B2C_intl":"fptbobi"
      ,"ptb_QA_B2C_intl":"fptbqbi"
      ,"ptb_SA_B2C_intl":"fptbsbi"
      ,"sortorder":"sto"
      ,"sortordermobile":"stom"
      ,"creativePricingAB":"hcp"
      ,"hotels_srp_cta":"hrcta"
      ,"hotels_stp_price":"hsp"
      ,"modify_search":"hms"
      ,"room_category_details_page":"hrcd"

      /*
      ,"ct_fsrn":"fsrn"
      ,"flt_results_type":"fflrt" // non ui
      ,"plm":"fplm"
      ,"sorting":"st"
      ,"trains_pwa":"tpwa"
      */
  },

  convertToShortAbTestNames: function(abJSONString){
      try{
          var shortAbJSONString = "", shortAbJSON  = {};
          var abJSON;
          var abTestNames = CT.utils.abTestNames;

          if(typeof abJSONString == "string"){
              abJSON = JSON.parse(abJSONString)
          }


          _.each(abJSON, function(value , key){
              shortAbJSON[abTestNames[key] ||key] = value;
          })

          shortAbJSONString = JSON.stringify(shortAbJSON);
          return shortAbJSONString;
      }catch(e){
          return abJSONString
      }
  },

  getAbTestCookie: function (key) {
      try {
          var newABTestNameMap = CT.utils.abTestNames ;

          var ct_ab = CT.utils.cookies.read("ct-ab");
          var ct_ab_test_value;

          if (ct_ab) {
              ct_ab = JSON.parse(decodeURIComponent(ct_ab));
              if(key){
                  ct_ab_test_value = ct_ab[key] || ((newABTestNameMap[key])?ct_ab[newABTestNameMap[key]]:null);
              }
          }

      } catch (e) {
          var ct_ab = null;
          var ct_ab_test_value = null;
      }


      if(key){
          return ct_ab_test_value;
      }else{
          return ct_ab
      }

  },
  /*
      A method for safely parsing a json strigified object, returns object if it is already an object
  */
  safeJsonParser: function (/* JSON as a string*/item) {
      if (typeof (item) == "object")
          return item
      else if (typeof (item) == "string") {
          try {
              JSON.parse(item)
          }
          catch (e) {
              return {}
          }
          return JSON.parse(item)
      }
  },
  reset: function (/* Any */obj, /* Array */exceptions) {
      var _typeof = Object.prototype.toString
      exceptions = exceptions || []
      if (_typeof.call(obj) === "[object Array]") obj.length = 0
      else if (_typeof.call(obj) === "[object Object]") _.each(obj, function (val, key) { if (obj.hasOwnProperty(key) && exceptions.indexOf(key) === -1) delete obj[key] })
      return obj
  },


  getRetinaImage: (function () {
      CT.retinaSupported = window.devicePixelRatio > 1;
      return function (imgName) { return CT.retinaSupported ? imgName + "2x" : imgName; }
  })(),


  getRandomNumberArray: function () {
      var arr = []
      while (arr.length < 8) {
          var randomnumber = Math.ceil(Math.random() * 8)
          var found = false;
          for (var i = 0; i < arr.length; i++) {
              if (arr[i] == randomnumber) { found = true; break }
          }
          if (!found) arr[arr.length] = randomnumber;
      }
      return arr;
  },


  createCollectionsUpSell: function (type, $node, settings) {
      var _settings = $.extend({ limit: 4 }, (settings || {}));
      if (type != "static") {
          var $node = $node || $("#collectionUpsellSection");
          if (!$node[0]) {
              return false;
          }

          $.ajax({
              url: "/smallworld/random_collections"
          }).done(function (resp) {
              try {
                  var upsells = JSON.parse(resp),
                      $list = $node.find(".collectionAssets"),
                      listStr = "";

                  for (var i = 0; i < _settings.limit; i++) {
                      var upsellObj = upsells[i];

                      if (document.location.href.indexOf("collections") != -1) {
                          listStr += '<li class="col ' + ((_settings.limit == 4) ? 'col6' : 'col8') + '"><a href="' + upsellObj.url + '" onclick="CT.utils.helperFunctions.trackGAEvent(\'collections_referral\', \'Collections\', \'' + upsellObj.url + '\');" ><h2 class="theSans">' + upsellObj.name + '</h2><img src="' + upsellObj.image + '"></a></li>';
                      } else {


                          listStr += '<li class="col ' + ((_settings.limit == 4) ? 'col6' : 'col8') + '"><a href="' + upsellObj.url + '" onclick="CT.utils.helperFunctions.trackGAEvent(\'collections_referral\', \'account\', \'' + upsellObj.url + '\');" ><h2 class="theSans">' + upsellObj.name + '</h2><img src="' + upsellObj.image + '"></a></li>';
                      }
                  }

                  $list.html(listStr);
                  $node.show();
              } catch (e) {

              }

          });



      } else if (type == "static") {
          var colectionUpsell = ''
              + '<div class="collectionUpsell" style="display:none;">'
              + '<h3>Wondering where to go?<small> Get inspired by Collections </small></h3>'
              + '<a href="' + (window.productCode == "CP" ? 'http://www.cleartrip.com/collections' : '/collections') + '" onclick= "CT.utils.helperFunctions.trackGAEvent(\'collections_referral\', \'account \', \'' + window.location.protocol + '//' + window.location.host + '\/collections\');" target="_blank">'
              + '<span class="collectionUpsellPoweredby"></span>'
              + ' <ul id="collectionUpsellTileList" ></ul>'
              + '</a>'
              + '</div>';

          var randNumArr = this.getRandomNumberArray();
          var liHtml = '';
          _.each(randNumArr, function (num) {
              liHtml += '<li><img src="//ui.cltpstatic/images/collections/assets/' + num + '.jpg"></li>';
          });

          if (!$node.find(".collectionUpsell")[0])
              $node.append(colectionUpsell);
          $node.find(".collectionUpsell").find("#collectionUpsellTileList").html(liHtml).end().show();

          $("#collectionUpsellTileList li").each(function (index, value) {
              var r1 = Math.random() - 0.5;
              var r2 = Math.random() - 0.5;
              $(value).css({ "top": (r1 * 30), "left": (r2 * 30) })
                  .addClass("animateTile")
                  .bind('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function (e) {
                      $(this).css("margin-top", "0");
                  });



          });
      }


  },

  wallet: {
      getUserWalletBallance: function (options, successCallback, errorCallback) {
          try {
              var deferred = $.Deferred();
              $.ajax({
                  url: '/effectivePricingDetails',
                  data: { intl: options.intl },
                  type: 'get',
                  timeout: options.timeout || 10000,
                  dataType: 'json',
                  success: function (data) {
                      CT.cache.userWalletBalance = 0;
                      CT.cache.showUserWalletBalanceBanner = false;
                      if (data.enabled) {
                          if (data.isLoggedIn && data.wallet_balance >= 1) {
                              CT.cache.userWalletBalanceInDisableState = data.wallet_balance;
                              CT.cache.userWalletBalance = data.wallet_balance;
                              if (data.show === false) {
                                  delete CT.cache.userWalletBalance;
                              }
                          } else if (!data.isLoggedIn && data.hasBalance && data.wallet_balance >= 1) {
                              CT.cache.showUserWalletBalanceBannerInDisableState = data.hasBalance;
                              CT.cache.showUserWalletBalanceBanner = data.hasBalance;
                              if (data.show === false) {
                                  delete CT.cache.showUserWalletBalanceBanner;
                              }
                          }
                      }
                      successCallback(data);
                  },
                  error: function (error) {
                      errorCallback ? errorCallback(error) : false;
                  }
              }).always(function (data) {
                  deferred.resolve();
              });
              return deferred;
          } catch (e) {
              errorCallback(e);
              return $.Deferred().resolve();
          }
      },
      applyWalletBalance: function (price, balance) {
          if (!balance)
              return 0;
          return price - balance < 0 ? price : balance;
      },
      //Get wallet balance local function
      setWalletObject: function (wallet, callback) {
          //var wallet = {};
          this.getUserWalletBallance({}, function (response) {
              wallet.progress = false;
              //Merge default wallet object with response from API
              wallet = $.extend(wallet, response);
              //Enable only if there is some amount in user's wallet
              wallet.enabled = wallet.enabled && (wallet.hasBalance || CT.cache.userWalletBalance > 0);
              wallet.hasBalance = CT.cache.userWalletBalance > 0;
              callback ? callback(wallet) : false;
          }, function (error) {
              wallet.progress = false;
              callback ? callback(wallet) : false;
          });
      },
      debitWalletBalance: function (total, discount, wallet, isPerRoomPerNight, totRoomNight) {
          var remainingWalletBalance = 0;
          var walletEnabled = wallet && wallet.hasBalance && wallet.enabled;
          var hideSaving = true;
          if (walletEnabled) {
              var wallet_balance = wallet.wallet_balance;
              if (isPerRoomPerNight && totRoomNight) {
                  wallet_balance = wallet_balance / (totRoomNight);
              }
              if (total > wallet_balance) {
                  total = total - wallet_balance;
                  //This will result in mis match with respect to STP and discount price, we have to live with it.
                  if (wallet.wallet_balance <= 450) {
                      hideSaving = false;
                  }
                  discount = discount + wallet_balance;
                  remainingWalletBalance = 0;
              } else if (total <= wallet_balance) {
                  if (wallet.wallet_balance <= 450) {
                      hideSaving = false;
                  }
                  discount = discount + total;
                  remainingWalletBalance = wallet_balance - total;
                  total = 0;
              }
          }
          return { "total": total, "discount": discount, "remainingWalletBalance": remainingWalletBalance, "walletEnabled": walletEnabled, "hideSaving": hideSaving };
      },
      createWalletMarkup: function (wallet, isSRP) {

          if (wallet && wallet.enabled && wallet.isLoggedIn) {
              if (!wallet.hidePopup) {
                  var html = CT.to_html('walletBannerTpl', wallet);
                  $('body').prepend(html);
                  setTimeout(function () {
                      $('.js-walletSideBanner').toggleClass('is-showing');
                  }, 1000);
                  $('.walletBanner__close').on('click', function (e) {
                      wallet.hidePopup = true;
                      $('.js-walletSideBanner').remove();
                  });
              }
          } else {
              if (isSRP) {
                  var html = CT.to_html('walletBannerTpl', wallet);
                  var eleLi = $('.hotelsList ul li.listItem');
                  //If only one hotel is on SRP then show tag after first else after second
                  if (eleLi.length === 1) {
                      $(eleLi[0]).after(html);
                  } else {
                      $(eleLi[1]).after(html);
                  }
              }
          }
      }
  },
  serviceWorker: {
      init: function (resolve, message) {
          if ('serviceWorker' in navigator) {
              navigator.serviceWorker.ready.then(function (data) {
                  window.__serviceWorkerInitialized = true;
                  resolve(CT.utils.serviceWorker.sendMessageToServiceWorker(message));
              });
          }
      },
      sendMessageToServiceWorker: function (message) {
          if (!window.__serviceWorkerInitialized) {
              if (window.Promise) {
                  return new Promise(function (resolve, reject) {
                      CT.utils.serviceWorker.init(resolve, message);
                  });
              }
          } else {
              return sendMessage(message);
          }
          function sendMessage(message) {
              return new Promise(function (resolve, reject) {
                  var messageChannel = new MessageChannel();
                  messageChannel.port1.onmessage = function (event) {
                      if (event.data.error) {
                          reject(event.data.error);
                      } else {
                          resolve(event.data);
                      }
                  };
                  if (navigator.serviceWorker.controller) {
                      navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2]);
                  } else {
                      console.warn("Unable to pre-cache");
                  }
              });
          }
      }

  },
  helperFunctions: {

      isB2CFlow: function (){
          var hostUrl = document.location.host.split(".");
          var isB2C = false;

          if(hostUrl.length >= 3 && hostUrl[1] === "cleartrip"){
              if(hostUrl[0] == "www"
              && ["ae","me","eu","sa","com","co","za","pl","qa"].indexOf(hostUrl[2])!=-1){
                  isB2C = true;
              }
              if(["om","bh","qa","kw","me","qa2" , "l"].indexOf(hostUrl[0])!=-1
              && (["ae","sa","me","eu","com","co","za","pl","qa"].indexOf(hostUrl[2])!=-1)){
                  isB2C = true;
              }
          }

          return isB2C;
      },

      // Author: Bhimsen S K.
      // el can be either element name or a valid css selector expression.
      isLocalStorageNameSupported: function () {
          var testKey = 'test', storage = window.sessionStorage;
          try {
              storage.setItem(testKey, '1');
              storage.removeItem(testKey);
              return true;//localStorageName in win && win[localStorageName];
          }
          catch (error) {
              return false;
          }
      },
      disableRightClickOnElement: function (el) {
          if (el !== undefined) {
              if (!(el instanceof jQuery)) {
                  el = $(el);
              }
              el.bind("contextmenu", function (e) {
                  return false;
              });
          }
      },

      displayBanners: function (opts) {
          CT.getScript(opts.url, function () {
              try {
                  var bannerData = window.b2c_banners;
                  switch (opts.page) {
                      case "home":
                          var footerBanner = bannerData.Footer;
                          var $el = $(".rewardsUpsellBannerHome .content");
                          $el.empty();
                          var homePageBannerHtml = '<a href=' + footerBanner.IMGLINK + ' target="_blank"><img src=' + footerBanner.IMGSOURCE + ' class="homeFooterBanner" width="1140" height="115" /></a>';
                          $el.html(homePageBannerHtml);
                          if ((new Date()).getMonth() === 11) {
                              $('#homeUpsellBanner').show();
                          }
                          break;
                      case "srp":
                          var middleBanner = bannerData.Middle;
                          if ((new Date()).getMonth() === 11) {
                              var srpBannerHtml = '<a href=' + middleBanner.IMGLINK + ' target="_blank"><img src=' + middleBanner.IMGSOURCE + ' class="srpMiddleBanner"/></a>';
                              var $upsellBanner = $("#srpUpsellBanner");
                              $el = $("#srpUpsellBanner .rewardsUpsellBanner .content");
                              $el.empty();
                              $el.html(srpBannerHtml);
                          }
                          if (!$upsellBanner[0])
                              return false;
                          var bannerIndex = 5;
                          var $resultContainer = $('#ResultContainer_' + CT.settings.currentTab);
                          var $existingBanner = $resultContainer.find('#srpUpsellBanner');
                          var $listItems;
                          var $referenceItem;
                          if ($existingBanner.length == 0) {
                              bannerIndex = $upsellBanner.attr("banner-index") || bannerIndex;
                              $listItems = $resultContainer.find(".listItem");
                              $referenceItem = $($listItems[bannerIndex - 1]);
                              if ($referenceItem.next().hasClass('auxiliary')) {
                                  $referenceItem = $referenceItem.next();
                              }
                              $upsellBanner.clone(true).insertAfter($referenceItem).show();
                          }
                          break;
                  }
              } catch (e) { }
          });
      },
      exactAge: function (dateOfBirthObj) {
          var today = moment();
          var age = today.year() - dateOfBirthObj.year;
          age += ((today.month() > dateOfBirthObj.month) ||
              (today.month() == dateOfBirthObj.month && today.date() >= dateOfBirthObj.day)) ? 1 : 0;
          return age;
      },
      trackScroll: function () {
          if (window.mixpanel && ($scroll_count != 0)) {
              var mixpanelevent = "";
              if (window.location.pathname.indexOf("/results") != -1) {
                  // mixpanelevent="H_SRP_Scrolled";
              } else if (window.location.pathname.indexOf("/details") != -1) {
                  mixpanelevent = "H_Details_Scrolled";
              } else if (window.location.pathname.indexOf("/itinerary") != -1) {
                  // mixpanelevent="H_Itinerary_Scrolled";
              } else if (window.location.pathname.indexOf("/confirmation") != -1) {
                  mixpanelevent = "H_Confirmation_Scrolled";
              } else {
                  mixpanelevent = "Hotel_HomePage_Scrolled";
              }
              CT.utils.helperFunctions.trackMixpanelEvent(mixpanelevent, { 'timesScrolled': $scroll_count });
              $scroll_count = 0;
          }
          if (false)
              return;
      },
      queryToObj: function (queryString) {
          var qparams = unescape(queryString);
          var a = qparams.split('&');
          var obj = {};
          var ab;

          try {
              for (ab in a) {
                  if (a[ab]) {
                      if (a[ab].split('=')) {
                          var c = a[ab].split('=');
                          if (c[0]) obj[c[0]] = c[1];
                      }
                  }
              }
          } catch (e) { }
          return (obj);
      },
      disableForm: function (disable, field) {
          if (field) {
              var form = field.form;
              $(form.elements).each(function (i, ele) {
                  if (disable == true) {
                      ele.ctEnableState = ele.disabled;
                      ele.disabled = true;
                  } else {
                      ele.disabled = ele.ctEnableState;
                  }
              });
          }

      },
      urlContainsScriptTag: function () {
          return new RegExp(/<script>/).test(decodeURIComponent(window.location.href));

      },
      loadHeapTracking: function () {
          window.heap = window.heap || [],
              heap.load = function (t, e) { window.heap.appid = t, window.heap.config = e; var a = document.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = ("https:" === document.location.protocol ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + t + ".js"; var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(a, n); for (var o = function (t) { return function () { heap.push([t].concat(Array.prototype.slice.call(arguments, 0))) } }, p = ["clearEventProperties", "identify", "setEventProperties", "track", "unsetEventProperty"], c = 0; c < p.length; c++)heap[p[c]] = o(p[c]) };
          //heap.load("1394282863");
      },
      animateTotalFare: function (elementToAnimate, fare, expression, options) {
          function animate() {
              //payback changes block starts
              /*if(window.payback && window.payback.earnConversionFactor){
                  var paybackAmt=window.payback.converted?fare+window.payback.converted:fare;
                  $('#payBackPAD #topLabel').html("Redeem existing points &bullet; Also earn " +Math.floor((paybackAmt*window.payback.earnConversionFactor)/100) + " Payback points with this booking");
              }*/
              //payback changes block ends
              if ($(elementToAnimate).length > 0) {
                  var amountElem = $(elementToAnimate).find("span#counter");
                  if (expression /* true */) {
                      amountElem.each(function (index) {
                          var totalObj = $(this)[0];
                          if (isNaN(totalObj.innerHTML) || totalObj.innerHTML == " " || $.trim(totalObj.innerHTML) == '') {
                              totalObj.innerHTML = 0;
                          }
                          totalFx = new CashRegister(totalObj, options);
                          totalFx.start(fare);
                      });
                      amountElem.addClass("highlightMe");
                      setTimeout(function () {
                          if (amountElem.hasClass("highlightMe")) {
                              amountElem.removeClass("highlightMe")
                          }
                      }, 1000);
                  } else {
                      amountElem.html(CT.stringFormatting.formatForCurrency(fare, '', true));
                  }
              }
              if (CT.utils.helperFunctions.convertCurrency)
                  CT.utils.helperFunctions.convertCurrency(fare);
          }

          //if(eventType == "couponApplied")
          animate();
      },

      imageToDiv: function (parentEl, imgEl, props, cssAttr, size) {
          var divEl = $("<div></div>"),
              imgEl = $(imgEl),
              parentEl = $(parentEl);

          if (!size) {
              size = {};
              size.width = imgEl.width();
              size.height = imgEl.height();
          }

          for (var i = 0, len = props.length; i < len; i++) {
              divEl.attr(props[i], imgEl.attr(props[i]));
          }
          /*for(var i = 0, len = cssAttr.length; i < len; i++){
              divEl.css(cssAttr[i], imgEl.css(cssAttr[i]));
          }*/
          var imageName = imgEl.attr("src").replace("(", "\\(").replace(")", "\\)");
          divEl.css({
              'background-image': 'url(' + imageName + ')'
          });
          divEl.addClass("imgPlaceHolder");

          //CT.utils.helperFunctions.disableRightClickOnElement(divEl);
          parentEl.append(divEl);
          imgEl.remove();
          divEl.css('opacity', 0).animate({ opacity: 1, visibility: 'visible' }, 0.5);
      },

      isLoggedInUser:function(){
          var isLoggedIn = false;

          if(CT.utils.cookies.read("usermisc")
              && (unescape(CT.utils.cookies.read("usermisc")).split("|")[0] == "SIGNED_IN")){
                  isLoggedIn = true;
          }

          return isLoggedIn;
      },

      setupBoldChatOnLoad: function () {
          window._bcvma = window._bcvma || [];
          _bcvma.push(["setAccountID", "172076787582913969"]);
          _bcvma.push(["setParameter", "WebsiteID", "171271469539519529"]);
          _bcvma.push(["setParameter", "InvitationID", "171271469951842927"]);
          _bcvma.push(["pageViewed", document.location.href, document.referrer]);
          var bcLoad = function () {
              if (window.bcLoaded) return; window.bcLoaded = true;
              var vms = document.createElement("script"); vms.type = "text/javascript"; vms.async = true;
              vms.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + "vmss.boldchat.com/aid/172076787582913969/bc.vms4/vms.js";
              var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);
          };
          if (window.pageViewer && pageViewer.load) pageViewer.load();
          else if (document.readyState == "complete") bcLoad();
          else if (window.addEventListener) window.addEventListener('load', bcLoad, false);
          else window.attachEvent('onload', bcLoad);
      },
      calTimeDiff: function (dateArr, timeArr) {
          var returnTimeString = {};
          function getFinalTime(dateArr, timeArr) {
              var finalTime = new Date();
              // set date.
              // if dateArr does not contain enough elements, flashSale tag will be hidden.
              finalTime.setDate(dateArr[0] || 1);
              finalTime.setMonth(parseInt(dateArr[1]) - 1 || 1);
              finalTime.setYear(dateArr[2] || 1910);

              // set time, default is 0:0:0(midnight)
              finalTime.setHours(timeArr[0] || 0);
              finalTime.setMinutes(timeArr[1] || 0);
              finalTime.setSeconds(timeArr[2] || 0);

              return finalTime;
          }

          // get current time.
          var currentTime = new Date().getTime();

          // get final time.
          var finalTime = getFinalTime(dateArr, timeArr);
          var diffSeconds = (finalTime.getTime() - currentTime) / 1000;

          // has time expired ?
          if (diffSeconds > 0) {
              var min = diffSeconds / 60;
              var hours = min / 60;
              var rstring = '';
              // if hours is more than 24 hours, format $$d $$h left.
              if (hours >= 24) {
                  var days = hours / 24;
                  var hoursLeft = (days - Math.floor(days)) * 24;
                  if (Math.floor(hoursLeft * 60) != 0) {
                      rstring = Math.floor(hours / 24) + 'd ';
                      if (hoursLeft < 1)
                          rstring += Math.floor(hoursLeft * 60) + 'min';
                      else {
                          // use floor to avoid situations where hoursleft = 59.678
                          // using round funtion will make it 60 min, which is absurd.
                          rstring += Math.floor(hoursLeft) + 'h ';
                      }
                  }
                  else
                      rstring = Math.floor(days) + 'd ';
              }
              else {
                  // use floor to avoid situations where minsLeft = 59.678
                  // using round funtion will make it 60 min, which is absurd.
                  var minsLeft = Math.floor((hours - Math.floor(hours)) * 60);
                  if (hours < 1)
                      rstring = minsLeft + 'min';
                  else if (minsLeft != 0)
                      rstring = Math.floor(hours) + 'h ' + minsLeft + 'min';
                  else
                      rstring = Math.floor(hours) + 'h ';
              }
              window.shwFlashSaletag = true;
              returnTimeString.rstring = rstring;
          }
          return returnTimeString;
      },
      showFlashSaleTag: function () {
          var flashSaleTag = $('#flashSaleEl');
          var random_number_one_to_six = parseInt(window.random_number_one_to_six);
          var otherTrustMarkers = '<i class="trustMarkers trust' + window.random_number_one_to_six + '"></i>'

          if (flashSaleTag.length > 0 && flashSaleTag.attr('data-date') != "") {
              var link = flashSaleTag.attr("href");
              var flashSaleTrustMarker = '<a href=' + link + ' target="_blank"><i class="trustMarkers thrillingThursdays"></i></a>'
              var datetime = flashSaleTag.attr('data-date').split(',');
              var dateArr = datetime[0].split('/');
              var timeArr = datetime[1].split(':');
              var weekDay = new Date().getDay()
              var shwFlashSale = CT.utils.helperFunctions.calTimeDiff(dateArr, timeArr);

              if (shwFlashSale && shwFlashSale.rstring) {
                  flashSaleTag.find('small').html(shwFlashSale.rstring);
                  flashSaleTag.find('small').show();
                  flashSaleTag.show();
                  if (CT && CT.app && CT.app == 'hotel' && window.countryCode == 'in' && weekDay == "4") {
                      $("#Home .searchForm").prepend(flashSaleTrustMarker)
                  } else if (CT && CT.app && CT.app == 'hotel' && window.countryCode == 'in') {
                      $("#Home .searchForm").prepend(otherTrustMarkers)
                  }
              } else {
                  // if time has expired, hide the flashSale tag.
                  flashSaleTag.removeClass('tagWithTime');
                  flashSaleTag.hide();
                  if (CT && CT.app && CT.app == 'hotel' && window.countryCode == 'in') {
                      $("#Home .searchForm").prepend(otherTrustMarkers)
                  }
              }
          } else if (flashSaleTag.length > 0) {
              flashSaleTag.removeClass('tagWithTime');
              flashSaleTag.show();
          } else {
              if (CT && CT.app && CT.app == 'hotel' && window.countryCode == 'in') {
                  $("#Home .searchForm").prepend(otherTrustMarkers)
              }
          }
      },

      showFlashSaleTag_v2: function (offer) {
          var flashSaleEnabled = offer.FLASHSALEACTIVE == 'Y';
          var product = offer.PRODUCT && offer.PRODUCT.toLowerCase();
          var flashSaleTag = $('#flashSaleEl-' + product);
          var $flashSaleHomePage = $('#flightsHomeFlashSaleBanner');
          var $travelsafeBanner = $('#travelsafeBanner');

          if (offer.OFFERTEXT && CT.app == product && flashSaleEnabled && $flashSaleHomePage.length && $travelsafeBanner.length == 0) {
              $flashSaleHomePage
                  .html(offer.OFFERTEXT)
                  .parent().show();

              if (offer.OFFERURL) {
                  $flashSaleHomePage.prop("href", offer.OFFERURL);
              }
              return;
          }

          var random_number_one_to_six = parseInt(window.random_number_one_to_six);
          var trustMarkers = '<i class="trustMarkers trust' + window.random_number_one_to_six + '"></i>';

          if (flashSaleTag.length > 0 && flashSaleEnabled) {
              var flashSaleTrustMarker = '<a href=' + offer.OFFERURL + ' target="_blank"><i class="trustMarkers thrillingThursdays"></i></a>';
              var weekDay = new Date().getDay();

              flashSaleTag.attr('href', offer.OFFERURL);

              flashSaleTag.show();
              if (CT && CT.app && CT.app == 'hotel' && CT.app == product && window.countryCode == 'in' && weekDay == "4") {
                  trustMarkers = flashSaleTrustMarker;
              }
          }
          else if (!flashSaleEnabled) {
              flashSaleTag.removeClass('tagWithTime');
              flashSaleTag.hide();
          }

          if (CT && CT.app && CT.app == 'hotel') {
              $('#Home .searchForm .trustMarkers').remove();
              $("#Home .searchForm").prepend(trustMarkers);
          }
      },

      setUrlParamsInView: function (paramsHash) {
          paramsHash = paramsHash || CT.cache[CT.settings.currentTab].searchParams.all;

          L('updating classes - in seturlparamsinview function of helperfunctions');
          if (paramsHash.view && paramsHash.view == 'map') {
              $('body').addClass('mapView disablePageScroll');
              $('html').addClass('disablePageScroll');
          } else {
              $('body').removeClass('mapView disablePageScroll');
              $('html').removeClass('disablePageScroll');
          }
      },
      addQueryParamsToURL: function (uri, key, value, atStart) {
          var i = uri.indexOf('#');
          var hash = i === -1 ? '' : uri.substr(i);
          uri = i === -1 ? uri : uri.substr(0, i);

          var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
          var separator = uri.indexOf('?') !== -1 ? "&" : "?";
          if (uri.match(re)) {
              uri = uri.replace(re, '$1' + key + "=" + value + '$2');
          } else {
              uri = uri + separator + key + "=" + value;
          }
          return uri + hash;  // finally append the hash as well
      },
      isTouchDevice: function () {
          return 'ontouchstart' in window // works on most browsers
              || 'onmsgesturechange' in window; // works on ie10
      },

      trackMixpanelEvent: function (action, mixpanelproperties) {
          if (window.mixpanelswitch && window.mixpanel) {
              var mixpanelproperties = $.extend({}, CT.utils.trackers.mixpanelTrackingData, mixpanelproperties);
              mixpanel.track(action, mixpanelproperties);
          }
      },

      trackClaverTapEvtHotel: function (category, props) {
          if (window.cleverTapEnabled && window.cleverTapAccId) {
              var claverTapProps = $.extend({}, CT.utils.trackers.clevertapGlobleData, props);
              CT.utils.helperFunctions.tpTrack({
                  tp: 'clevertap',//Important,
                  category: category,
                  values: claverTapProps
              })
          }
      },

      trackCleverTapEvtFlights: function(category, props) {
          if(window.cleverTapEnabled && window.cleverTapAccId) {
              var cleverTapProps = $.extend({}, CT.utils.trackers.clevertapGlobleData, props);
              CT.utils.helperFunctions.tpTrack({
                  tp: 'clevertap',
                  category : category,
                  values: cleverTapProps
              })
          }
      },

      trackGAEvent: function (category, action, label, timeout, freq) {
          var _ctLogUiEventLength = (Number(window.ctLogUiEventLength) || 5);
          parseInt(timeout, 10);

          timer = timeout || 3000;
          //setTimeout(function() {
          //if(!window.loadSegmentIOJS)
          try {
              _gaq.push(['_trackEvent', category, action, label]);
          } catch (e) { }
          //else{
          if (window.product != "B2B"
              && (CT.app == 'hotel' || CT.app == 'air')) {
              if (window.loadSegmentIOJS) {
                  if (action && window.analytics) {
                      analytics.track(action, {
                          'category': category,
                          'label': label
                      });
                  } else {
                      //console.log('segment IO ')
                  }
              }

              if (!CT.utils.postParams) {
                  var ctproduct = window.location.pathname.indexOf("hotels") != -1 ? "hotel" : CT.app == "hotel" ? "hotel" : "flight";
                  CT.utils.postParams = {
                      "emailID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]) : "N/A",
                      "product": ctproduct,
                      "eventType": "normal",
                      "userID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|").slice(-1).pop()) : "N/A",
                      //window.peopleId?String(window.peopleId):"N/A",
                      "apacheCookie": CT.utils.cookies.read('Apache') ? CT.utils.cookies.read('Apache') : "N/A",
                      "searchInstance": CT.cache && CT.settings && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].sid ? CT.cache[CT.settings.currentTab].sid : window.ctsid ? window.ctsid : "N/A",
                      "category": category,
                      "events": []
                  };
              }

              if (category && CT.utils.postParams.category != category && CT.utils.postParams.events.length >= 0) {
                  if (CT.utils.postParams.events.length > 0)
                      CT.utils.helperFunctions.postAnalyticsDataViaAJAX();
                  CT.utils.postParams.category = category;
                  CT.utils.postParams.emailID = CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]) : "N/A"
              }

              if (!CT.utils.postParams.searchInstance || CT.utils.postParams.searchInstance == "N/A") {
                  CT.utils.postParams.searchInstance = (CT.cache && CT.settings && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].sid) ? CT.cache[CT.settings.currentTab].sid : (window.ctsid ? window.ctsid : "N/A");
              }

              if (action && label && action !== "" && label !== "") {
                  CT.utils.postParams.events.push({
                      "action": action,
                      "element": "" + label, // make sure its a string.
                      "time": new Date().getTime()
                  });
              }
              if (typeof (window.navigator.sendBeacon) != "function") {
                  CT.utils.helperFunctions.postAnalyticsDataViaAJAX();
              }
              else {
                  if (CT.utils.postParams.events.length >= _ctLogUiEventLength || (freq == 'instant')) {
                      CT.utils.helperFunctions.postAnalyticsDataViaAJAX();
                  }
              }
              //}
          }
          //}//,timer);
      },
      trackGAUrl: function (url, timeout) {
          timer = timeout || 3000;
          setTimeout(function () {
              try {
                  _gaq.push(['_trackEvent', url]);
              } catch (e) { }
          }, timer);
      },

      postAnalyticsDataViaAJAX: function (unsentEvents) {
          var dataToBeSent = "";
          var timeOutVal = window.logUiEvtTimeOut ? parseInt(window.logUiEvtTimeOut) : 1000;
          if (!unsentEvents && CT.utils.postParams && CT.utils.postParams.events.length > 0) {
              dataToBeSent = JSON.stringify(CT.utils.postParams);
              CT.utils.postParams.events = [];
          }
          else {
              if (unsentEvents && JSON.parse(unsentEvents).category != "Bus")
                  dataToBeSent = unsentEvents;
          }
          _.extend(dataToBeSent, {
              "domain": window.domainType || (window.countryCode || "N/A").toUpperCase(),
              "deviceType": 'Desktop',
              "flightType": (window.isInternational || window.isinternational || (CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].searchType && CT.cache[CT.settings.currentTab].searchType.isIntl)) ? 'INTL' : 'DOM'
          })
          var analyticsHost = window.analyticsHost ? window.analyticsHost : "";
          var explorerAnalyticsSwitch = window.explorerAnalyticsSwitch == "true" ? true : false;
          var headers = { "Content-type": "application/json", "dataType": "json" };
          if (analyticsHost) {
              headers = { "Content-Type": "application/x-www-form-urlencoded" };
          }
          if (dataToBeSent) {
              //Tracking for loguievent internal call
              if (explorerAnalyticsSwitch && analyticsHost && $.browser.msie && window.XDomainRequest && ($.browser.version === "9.0" || $.browser.version === "8.0")) {
                  // Use Microsoft XDR for IE - 8,9 support
                  var xdr = new XDomainRequest();
                  xdr.open("post", analyticsHost + "/sink/loguievent");
                  xdr.onload = function () { };
                  xdr.onprogress = function () { };
                  xdr.ontimeout = function () { };
                  xdr.onerror = function () { };
                  xdr.timeout = timeOutVal;
                  setTimeout(function () {
                      xdr.send(dataToBeSent);
                  }, 0);
              } else {
                  $.ajax({
                      url: analyticsHost + "/sink/loguievent",
                      type: 'POST',
                      headers: headers,
                      data: dataToBeSent,
                      success: function (data) { },
                      error: function () { },
                      timeout: timeOutVal
                  });
              }
          }
      },

      postAnalyticsDataViaImage: function () {
          if (CT.utils.postParams && CT.utils.postParams.events.length > 0) {
              var img = new Image();
              img.src = "/sink/loguievent?events=" + encodeURIComponent(JSON.stringify(CT.utils.postParams));
          }
          CT.utils.postParams.events = [];
      },

      postAnalyticsDataViaBeacon: function () {
          var analyticsHost = window.analyticsHost ? window.analyticsHost : "";
          var url = analyticsHost + "/sink/loguievent";
          if (CT.utils.postParams && CT.utils.postParams.events.length > 0 && window.navigator.sendBeacon) {
              window.navigator.sendBeacon(url, JSON.stringify(CT.utils.postParams));
          }
          CT.utils.postParams.events = [];
      },
      postAnalyticsErrorDataViaAJAX: function (dataToBeSent) {
          var timeOutVal = window.logUiEvtTimeOut ? parseInt(window.logUiEvtTimeOut) : 1000;
          var analyticsHost = window.analyticsHost ? window.analyticsHost : "";
          _.extend(dataToBeSent, {
              "domain": window.domainType || (window.countryCode || "N/A").toUpperCase(),
              "deviceType": 'Desktop',
              "flightType": (window.isInternational || window.isinternational || (CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab].searchType && CT.cache[CT.settings.currentTab].searchType.isIntl)) ? 'INTL' : 'DOM'
          })
          var analyticsHost = window.analyticsHost ? window.analyticsHost : "";
          var headers = { "Content-type": "application/json", "dataType": "json" };
          $.ajax({
              url: analyticsHost + "/sinkext/errorevent",
              type: 'POST',
              headers: headers,
              data: dataToBeSent,
              success: function (data) { },
              error: function () { },
              timeout: timeOutVal
          });
      },
      trackNanigan: function (params) {
          var payload = "", userId = "", url = "";
          var protocol = window.location.protocol;
          for (var key in params) {
              payload += key + "=" + params[key] + "&";
          }
          payload = payload.replace(/&$/, '');
          userId = CT.utils.cookies.read('userid');
          if (userId !== null)
              userId = userId.split("||")[2];
          if (userId) {
              url = protocol + "//api.nanigans.com/event.php?app_id=90781&user_id=" + userId + "&";
          }
          else {
              url = protocol + "//api.nanigans.com/event.php?app_id=90781&";
          }
          var img = new Image();
          img.src = url + payload + '&_=' + (new Date().getTime());
          img.onload = function () { };
      },

      adjustHeight: function () {
          var asideLeftHeight = $('#Home').find('aside').first().outerHeight(),
              asideRightHeight = $('#Home').find('aside').last().outerHeight(),
              windowHeight = $(window).outerHeight(),
              appBannerHeight = $('#homeUpsellBanner').outerHeight(),
              appBannerHeight = appBannerHeight ? appBannerHeight : '0';

          var height = Math.max(asideLeftHeight, asideRightHeight, windowHeight - 100 - appBannerHeight);

          $('.viewController').css('min-height', height + 'px');
      },

      paidAffiliateTracker: function (urlHash) {
          //var affiliateutmExpiryDays = window.affiliateutmExpiryDays ? parseInt(window.affiliateutmExpiryDays) : 30;
          //var _lastStepAttribution = window.lastStepAttribution;
          var affiliateutmExpiryDays = 1;
          var _lastStepAttribution = true;
          if ((CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab]) || urlHash) {

              var params = urlHash ? urlHash : CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab] ? CT.cache[CT.settings.currentTab].searchParams.all : {},
                  utmSource = params['tduid'] ? params['tduid'] : params['utm_source'],
                  utmCampaign = params['utm_campaign'],
                  utmMedium = params['utm_medium'],
                  utmTerm = params['utm_term'],
                  utmUid = params['uid'];

              //extract expiryDate of cookie
              var affiliateutmExpiryDate = CT.utils.cookies.read('affiliate_expdate');
              if (!affiliateutmExpiryDate) {
                  storeAffiliateInformation();
                  CT.utils.cookies.create('affiliate_expdate', (new Date()).toDateString(), affiliateutmExpiryDays);
              } else {
                  if (_lastStepAttribution) {
                      storeAffiliateInformation();
                  }
              }
              function storeAffiliateInformation() {
                  if (utmSource && utmSource != 'undefined') {
                      CT.utils.cookies.create('source_affiliatefirstsource', utmSource, affiliateutmExpiryDays);
                      //Hard coded as requirement comes from marketing to add one cookie for 30 days -
                      // CON-123 - Cookie settings - Meta channels
                      CT.utils.cookies.create('source_Meta', utmSource, 30);
                  }
                  if (utmCampaign)
                      CT.utils.cookies.create('campaign_affiliatefirstsource', utmCampaign, affiliateutmExpiryDays);
                  if (utmMedium)
                      CT.utils.cookies.create('medium_affiliatefirstsource', utmMedium, affiliateutmExpiryDays);
                  if (utmTerm)
                      CT.utils.cookies.create('term_affiliatefirstsource', utmTerm, affiliateutmExpiryDays);
                  if (utmUid)
                      CT.utils.cookies.create('uid_affiliatefirstsource', utmUid, affiliateutmExpiryDays);
              }
          }
      },

      paidChannelTracker: function (urlHash) {
          /* PRM-13044. capture the values if it comes from paid channels.
           * utm_* is present only on paid channels.
           */
          var atag = document.createElement('a');
          atag.href = parent.document.referrer;

          //(atag.host.indexOf('cleartrip') == -1) && ; commented this check; as we are not getting referer infomation;
          if ((CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab]) || urlHash) {
              var params = urlHash || CT.cache[CT.settings.currentTab].searchParams.all,
                  utmSource = params['utm_source'],
                  utmCampaign = params['utm_campaign'],
                  utmMedium = params['utm_medium'],
                  utmContent = params['utm_content'],
                  utmTerm = params['utm_term'],
                  utmUid = params['utm_uid'],
                  _cookies = ['source_firstpaidsource', 'medium_firstpaidsource', 'campaign_firstpaidsource', 'content_firstpaidsource', 'term_firstpaidsource', 'uid_firstpaidsource', 'lastchannel'];
              //changing first paid to last paid

              // extract source_firstpaid cookie.
              //var sourceFirstPaid = CT.utils.cookies.read('source_firstsource');

              // if doesn't exist, either its first time or 30day window has elapsed.
              //if(!sourceFirstPaid) {
              // first_source
              if (utmSource)
                  CT.utils.cookies.create('source_firstsource', utmSource, 30);
              if (utmCampaign)
                  CT.utils.cookies.create('campaign_firstsource', utmCampaign, 30);
              if (utmMedium)
                  CT.utils.cookies.create('medium_firstsource', utmMedium, 30);
              if (utmContent)
                  CT.utils.cookies.create('content_firstsource', utmContent, 30);
              if (utmTerm)
                  CT.utils.cookies.create('term_firstsource', utmTerm, 30);
              if (utmUid)
                  CT.utils.cookies.create('uid_firstsource', utmUid, 30);

              if (utmSource || utmCampaign || utmMedium || utmContent || utmTerm || utmUid) {
                  for (var i = 0; i < _cookies.length; i++)
                      CT.utils.cookies.erase(_cookies[i]);
              }
              //}

              // regular cookie setting.
              // firstpaid_source
              if (utmSource)
                  CT.utils.cookies.create('source_firstpaidsource', utmSource);
              if (utmMedium)
                  CT.utils.cookies.create('medium_firstpaidsource', utmMedium);
              if (utmCampaign)
                  CT.utils.cookies.create('campaign_firstpaidsource', utmCampaign);
              if (utmContent)
                  CT.utils.cookies.create('content_firstpaidsource', utmContent);
              if (utmTerm)
                  CT.utils.cookies.create('term_firstpaidsource', utmTerm);
              if (utmUid)
                  CT.utils.cookies.create('uid_firstpaidsource', utmUid);

              CT.utils.cookies.create('noncleartrip', 'true');
          }
          else {
              if (!CT.utils.cookies.read('noncleartrip'))
                  CT.utils.cookies.create('noncleartrip', 'false');
          }
      },

      newUserIdTracker: function (userId, callback) {
          userId = parseInt(userId);
          if (!isNaN(userId)) {
              $.get('/partial/account/tc/' + userId, function (response) {
                  try {
                      if (typeof response === 'string') {
                          response = JSON.parse(response);
                      }
                      var isNewUser = false;
                      var total = parseInt(response.D) + parseInt(response.I) + parseInt(response.H);

                      if (total === 0) {
                          isNewUser = true;
                          CT.utils.cookies.create('nu', 1, 0.5 / 24);
                      }
                      else {
                          CT.utils.cookies.erase('nu');
                      }
                      if (callback) {
                          callback(isNewUser);
                      }
                  }
                  catch (e) {
                      // fail gracefully.
                  }
              });
          }
      },

      store: function () {
          var __interface = {
              setItem: function (key, value) {
                  if (this.db) {
                      this.db.setItem(key, value);
                  }
                  else {
                      CT.utils.cookies.create(key, value);
                  }
              },

              getItem: function (key) {
                  if (this.db) {
                      return this.db.getItem(key);
                  }
                  else {
                      return CT.utils.cookies.read(key);
                  }
              },

              removeItem: function (key) {
                  if (this.db) {
                      this.db.removeItem(key);
                  }
                  else {
                      CT.utils.cookies.erase(key);
                  }
              },

              db: window.localStorage
          };
          return __interface;
      },

      initLogger: function (path) {
          var callbackOnUnload = function () {
              if (CT.utils.postParams && CT.utils.postParams.events.length > 0) {
                  //var store = CT.utils.helperFunctions.store;
                  //if(store) {
                  //store().setItem('events', JSON.stringify(CT.utils.postParams));
                  //}
                  CT.utils.helperFunctions.postAnalyticsDataViaBeacon();
              }
          }
          //if(!$.browser.opera && !$.browser.msie){
          //  if($.browser.mozilla){
          $(window).bind("unload", callbackOnUnload);
          //  }
          //  $(window).bind("beforeunload", callbackOnUnload);
          //}
      },
      /*
       * This function sets the GA account ID based on the domain.
       */
      setGAProperties: function () {
          //This function is invoked only for for B2C flows.

      },
      ipadCloseFilter: function (e, $currentTab) {
          $currentTab.find('.filters').removeClass('filterPopOver');
          $(".tempFiltersButton").closest("li").removeClass('current');
          $currentTab.find('.viewController').css('display', 'block');
      },
      ipadChanges: function (e, $currentTab) {
          var isIpad = navigator.userAgent.match(/iPad/i) != null;
          $(e.target.parentNode).toggleClass('current');
          $currentTab.find('.filters').toggleClass('filterPopOver');


          if ($currentTab.find('.filters').hasClass("filterPopOver") == true && isIpad == false) {
              $currentTab.find('.viewController').css('display', 'none');
          } else {
              $currentTab.find('.viewController').css('display', 'block');
          }
          //$currentTab.find('.filters').toggle();
          e.stopPropagation();
          var handler = function (event) {
              if ($(event.target).is(".filterPopOver, .filterPopOver *")) return;
              $(document).off("click", handler);
              //$currentTab.find('.filters').hide();
              $currentTab.find('.filters').removeClass('filterPopOver');
              $(".tempFiltersButton").closest("li").removeClass('current')
              $currentTab.find('.viewController').css('display', 'block');

          }
          $(document).on("click", handler);
          /*$(document).on('click', function (e) {
                if ($currentTab.find('.filterPopOver').get(0) != null ) {
                  $currentTab.find('.filters').hide();
                  $currentTab.find('.filters').removeClass('filterPopOver');
                  $(".tempFiltersButton").closest("li").removeClass('current')
              }
          });*/
      },
      includeGAjs: function () {
          /*

           //if(!window.loadSegmentIOJS){//if loadSegmentIOJS false or undefined this code will execute.
               var append=new Date().getTime();
               var script=document.createElement('script');
               script.type='text/javascript';
               var baseLink = window.staticBaseDomain || window.staticBaseLink || window.hotelBaseLink || window.airBaseLink || "//fastui.cltpstatic.com/raw/upload/resources";
               if((!window.productCode || window.productCode == "B2C") && (window.countryCode == 'in' || window.countryCode == 'ae')){
                   script.src= baseLink+"/javascripts/dc.js?v="+append;
               }else{
                   //for non b2c and other gcc sites
                   script.src= baseLink+"/javascripts/ga.js?v="+append;
               }
               $("body")[0].appendChild(script);
               window._gaq = window._gaq || [];
               CT.utils.helperFunctions.setGAProperties();


           //}else{
               if(CT.app == 'hotel'){
                   if(window.loadSegmentIOJS){
                       var analytics=analytics||[];(function(){var e=["identify","track","trackLink","trackForm","trackClick","trackSubmit","page","pageview","ab","alias","ready","group"],t=function(e){return function(){analytics.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var n=0;n<e.length;n++)analytics[e[n]]=t(e[n])})(),analytics.load=function(e){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src=("https:"===document.location.protocol?"https://":"http://")+"d2dq2ahtl5zl1z.cloudfront.net/analytics.js/v1/"+e+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)};
                       analytics.load("dreyq342iw");
                   }
               }
           */
      },
      //PRM-12261
      includeGATagManager: function () {
          // (function(w,d,s,l,i){
          //  w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          // })(window,document,'script','dataLayer','GTM-T9S432');
    var domain = window.location.hostname.split('.').pop();
          var defaultGTMID = domain == 'ae' ? 'GTM-P6JVCQ2' : 'GTM-T9S432';
          // if (window.location.host.indexOf("cleartrip.sa") > -1) {
          //     defaultGTMID = 'GTM-T96QGPF';
          // }
          (function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
              var dl = l != 'dataLayer' ? '&l=' + l : '';
              var url = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
              $.getScript(url, function () {
                  if (window.location.pathname.indexOf("/confirmation") != -1) {
                      //loging to cleartrip for gtm download success on confirmation page
                      $.ajax({
                          type: "GET",
                          url: '/googltmsuccess',
                          success: function (data) {

                          },
                          error: function (err) {

                          }
                      })
                  }
              });
          })(window, document, 'script', 'dataLayer', defaultGTMID);
      },

      // ART-484 gtm methods
      gtmMethods: {
          setDataLayer: function (object, dataLayerName) {
              this.pushDataToDataLayer({
                  'Domain': 'NA',
                  'Country': 'NA',
                  'Language': 'NA',
                  'Device Type': 'NA',
                  'Currency': 'NA',
                  'Transaction ID': 'NA',
                  'Booking date': 'NA',
                  'Full Itinerary': 'NA',
                  'First Departure Date': 'NA',
                  'Final Departure Date': 'NA',
                  'First Point of Origin': 'NA',
                  'Final Destination': 'NA',
                  'Journey Type': 'NA',
                  'Category': 'NA',
                  'Adult Count': 'NA',
                  'Child Count': 'NA',
                  'Infant Count': 'NA',
                  'Total Passengers': 'NA',
                  'Booking Class': 'NA',
                  'Booking Price': 'NA',
                  'Tax': 'NA',
                  'Discount': 'NA',
                  'Wallet Credit': 'NA',
                  'Convenience Fee': 'NA',
                  'Coupon': 'NA',
                  'Insurance Product': 'NA',
                  'Insurance Cost': 'NA',
                  'Segment Count': 'NA',
                  'Payment Type': 'NA'
              });
              this.pushDataToDataLayer(object, dataLayerName);
              return this;
          },
          // push items to the dataLayerCT, it's going to merge when captured
          // in case of bookreview we are pusing data to datalayer
          pushDataToDataLayer: function (dataObject, product) {
              var dataLayerName = product == 'air' ? 'dataLayer' : null
              if (!$.isEmptyObject((window[dataLayerName] || window.dataLayerCT)))
                  (window.dataLayerCT || window[dataLayerName]).push(dataObject)
              return this;
          },
          // trigger event on the datalayer
          triggerEvent: function (eventName, product) {
              var dataLayerName = product == 'air' ? 'dataLayer' : null
              if (!$.isEmptyObject(window[dataLayerName] || window.dataLayerCT))
                  (window.dataLayerCT || window[dataLayerName]).push({ 'event': eventName })
          }
      },

      triggerFunnelCall: function () {
          $.ajax({
              url: '/common/funnelTracking',
              success: function (data) {
              }
          });

      },

      includeComScoreTracking: function () {
          //$('body').append('<img height="1" width="1" style="border-style:none;" alt="" src="http://b.scorecardresearch.com/p?c1=2&c2=7561529&cv=2.0&cj=1" />');
          window._comscore = window._comscore || [];
          window._comscore.push({ c1: "2", c2: "7561529" });
          var s = document.createElement("script"), el = document.getElementsByTagName("script")[0];
          var baseLink = window.staticBaseDomain || window.staticBaseLink || window.hotelBaseLink || window.airBaseLink || "//fastui.cltpstatic.com/raw/upload/resources";
          s.src = baseLink + "/javascripts/trackers/comscore_beacon.js?v=1";
          el.parentNode.insertBefore(s, el);
      },
      /**
      Branch.Io for mobile web to show banners on each and every page
      **/
      inspectLetJsForBranchIo: function () {
          (function (b, r, a, n, c, h, _, s, d, k) {
              if (!b[n] || !b[n]._q) {
                  for (; s < _.length;) c(h, _[s++]);
                  d = r.createElement(a);
                  d.async = 1;
                  d.src = "https://cdn.branch.io/branch-latest.min.js";
                  k = r.getElementsByTagName(a)[0];
                  k.parentNode.insertBefore(d, k);
                  b[n] = h
              }
          })(window, document, "script", "branch", function (b, r) {
              b[r] = function () {
                  b._q.push([r, arguments])
              }
          }, {
                  _q: [],
                  _v: 1
              }, "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode".split(" "), 0);
          branch.init('key_live_cgeDODFZsneCcLhrQ9wxGomiEqkFtGo9')
      },

      inspectLetJsForRT: function () {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 2042725865]);
          (function () {
              function __ldinsp() { var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); }
              __ldinsp();
          })();
      },
      inspectLetJsForHotels: function () {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 1283069909]);
          (function () {
              function __ldinsp() { var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
              document.readyState != "complete" ? (window.attachEvent ? window.attachEvent('onload', __ldinsp) : window.addEventListener('load', __ldinsp, false)) : __ldinsp();
          })();
      },
      inspectForGoogleAnalatics: function () {
          (function (h, o, t, j, a, r) {
              h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
              h._hjSettings = { hjid: 390809, hjsv: 5 };
              a = o.getElementsByTagName('head')[0];
              r = o.createElement('script'); r.async = 1;
              r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
              a.appendChild(r);
          })(window, document, '//static.hotjar.com/c/hotjar-', '.js?sv=');

      },
      inspectLetJsForHotelsBookFlow: function () {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 680622208]);
          (function () {
              function __ldinsp() { var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
              document.readyState != "complete" ? (window.attachEvent ? window.attachEvent('onload', __ldinsp) : window.addEventListener('load', __ldinsp, false)) : __ldinsp();
          })();
      },
      inspectLetJsForCancellation: function () {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 545080575]);
          (function () {
              function ldinsp() { if (typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
              setTimeout(ldinsp, 500); document.readyState != "complete" ? (window.attachEvent ? window.attachEvent('onload', ldinsp) : window.addEventListener('load', ldinsp, false)) : ldinsp();
          })();
      },
      includeCheckmein: function () {
          try {
              if (window.productCode != "CP" && window.productCode != "AG" && window.productCode != "WL") {

                  function appendScript(src) {
                      var script = document.createElement('script');
                      script.type = 'text/javascript';
                      script.src = src
                      $("body")[0].appendChild(script);
                  }

                  appendScript("https://s3-us-west-2.amazonaws.com/cmi-static/js/jquery.jplayer.min.js");
                  appendScript("https://s3-us-west-2.amazonaws.com/cmi-static/js/6fc1383ab00f5445a0c22b961d6e71be.js");

                  $('<div id="cmi_signature_player"></div>').appendTo($("body"))

              }
          } catch (e) {

          }
      },

      /*
       * @DESC : returns hotel modal window (iframe) url
       */
      getHotelModalUrl: function (hotelId) {
          var rrArr = [], baseUrl = '/hotels/info/' + hotelId + '/modal',
              hotelJson = CT.masterJson.getHotel(hotelId);

          if (hotelJson.priceInfo) {
              _.forEach(hotelJson.priceInfo.rms, function (eachRoom) {
                  rrArr.push(eachRoom.rmtc);
              });
          }

          if (rrArr.length > 0)
              baseUrl += '?&rr=' + rrArr.join('&rr=');
          else
              baseUrl += '?';

          if (CT.app == 'hotel')
              baseUrl += '&tux=1';

          return baseUrl;

      },

      /*
       * @DESC : returns markup of hotel amenities
       */
      getHotelAmenities: function (am, roomAmenities) {
          var amenitiesTagAttrs, amenitys, amIcons;

          roomAmenities = roomAmenities || false;
          amenitiesTagAttrs = roomAmenities ? CT.settings.general.roomAmenitiesMap : (window.amenitiesMap ? window.amenitiesMap : CT.settings.general.amenitiesMap);

          amenitys = (roomAmenities ? "0000000000000" : "000000000000000000") + parseInt(am, 16).toString(2);
          amenitys = amenitys.substring(amenitys.length - (roomAmenities ? 12 : 17));
          if (!roomAmenities) {
              amenitys = amenitys.split("").reverse().join("");
          }
          amIcons = {};
          amIcons.activeAmenities = [];
          amIcons.shwName = shwName ? true : false;
          for (var j = 0; j < amenitys.length; j++) {
              var _am;
              if ($.browser.msie) _am = amenitys.split('')[j];
              else _am = amenitys[j];
              if (_am == "1") {
                  amIcons[amenitiesTagAttrs[j]["class"]] = true;
                  amIcons.activeAmenities.push(amenitiesTagAttrs[j]["title"]);
              }
          }
          return amIcons;
      },

      /*
       * @desc : general function to calculate discount percentage
       */
      calDiscountPercent: function (discAmt, discPrice) {
          return (discAmt / (discPrice + discAmt) * 100).toFixed(3);
      },





      /*
       * @DESC : this function truncates text inside an element
       * @PARAM : anchorAttrs - this object will be added to more/less anchor tag
       * @PARAM : callback - function to be called upon more/less click
       */
      truncateText: function ($element, charsLimit, anchorAttrs, callback) {
          var originalText = $element.text().trim(), attrString = '';

          charsLimit = charsLimit ? (window.Int ? Int(charsLimit) : 200) : 200;

          callback = callback || function ($thisTag) {
              if ($thisTag.attr('data-type') == 'more') {
                  $thisTag.siblings('.originalContent').show();
                  $thisTag.siblings('.displayText').hide();
                  $thisTag.attr('data-type', 'less').html('less');
              } else {
                  $thisTag.siblings('.originalContent').hide();
                  $thisTag.siblings('.displayText').show();
                  $thisTag.attr('data-type', 'more').html('more');
              }
          };

          if (anchorAttrs) {
              _.forEach(anchorAttrs, function (name, index) {
                  attrString += index + '=' + name + ' ';
              });
          }

          if (originalText.length > charsLimit) {
              originalContent = $element.html();
              displayText = originalText.substring(0, charsLimit);
              $element.html('<div class="originalContent" style="display:none">' + originalContent + '</div>');
              $element.append('<span class="displayText">' + displayText + ' ... </span>');
              $element.append('<a href="#" class="truncateToggle weak" ' + attrString + ' data-type="more">more</a>');

              $element.find('.truncateToggle').click(function (e) {
                  callback($(e.target));
              });
          }
      },



      logToServer: function (app, tag, data) {
          try {
              parameters = data || {};
              CT.ajax("trackcode" + Math.random(), "/urltrack/" + app + "_" + tag, 'get', {
                  "data": parameters, "success": function (response) {

                  }
              });
          } catch (e) { }

          try {
              _gaq.push(['_trackEvent', app, tag, Hash.toQueryParams(data || {})]);

              //pageTracker._trackEvent(app, tag, Hash.toQueryParams(data || {}));

          } catch (e) { }
      },
      getDistanceFromLatLonInKm: function (lat1, lon1, lat2, lon2) {
          if (lat1 && lon1 && lat2 && lon2) {
              var deg2rad = function (deg) { return deg * (Math.PI / 180) }
              var R = 6371; // Radius of the earth in km
              var dLat = deg2rad(lat2 - lat1);  // deg2rad above
              var dLon = deg2rad(lon2 - lon1);
              var a =
                  Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                  Math.sin(dLon / 2) * Math.sin(dLon / 2);
              var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              var d = R * c; // Distance in km
              return d;
          } else {
              return -1;
          }
      },
      setUserLocationCookie: function () {
          try {
              var geocoder;
              var userLocation = "";
              CT.getScript("//maps.googleapis.com/maps/api/js?key=AIzaSyBICejdTstEMJamaR3_1yVvohjIhLikbCM&sensor=false", function () { initialize() });
              var initialize = function () {
                  var returnCookie = returnCookie ? returnCookie : false;
                  geocoder = new google.maps.Geocoder();
                  successFunction = function (position) {
                      var lat = position.coords.latitude;
                      var lng = position.coords.longitude;
                      codeLatLng(lat, lng)
                  }
                  errorFunction = function () {
                      window.console && console.log("Geocoder failed");
                      storeUserLocationData("", "", "");
                  }
                  if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(successFunction, errorFunction);
                  }
                  var storeUserLocationData = function (userLoc, lat, lng) {
                      if (CT && CT.utils && CT.utils.cookies) {
                          if (!userLoc) userLoc = "";
                          if (!lat) lat = "";
                          if (!lng) lng = "";
                          CT.utils.cookies.create('userLatitude', lat, 1 / 24);
                          CT.utils.cookies.create('userLongitude', lng, 1 / 24);
                          CT.utils.cookies.create('userLocation', encodeURI(userLoc), 1 / 24);
                          CT.utils.cookies.create('userCity', encodeURI(userLoc), 1 / 24);
                      }
                  }
                  var codeLatLng = function (lat, lng) {
                      var latlng = new google.maps.LatLng(lat, lng);
                      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                          if (status == google.maps.GeocoderStatus.OK) {
                              window.console && console.log(results)
                              if (results[0]) {
                                  for (var i = 0; i < results[0].address_components.length; i++) {
                                      for (var b = 0; b < results[0].address_components[i].types.length; b++) {
                                          if (results[0].address_components[i].types[b] == "sublocality_level_1") {
                                              locality = results[0].address_components[i];
                                              break;
                                          }
                                      }
                                  }
                                  userLocation = locality.long_name;
                                  storeUserLocationData(userLocation, lat, lng);
                              } else {
                                  window.console && console.log("No results found");
                                  storeUserLocationData(userLocation, lat, lng);
                              }
                          } else {
                              window.console && console.log("Geocoder failed due to: " + status);
                              storeUserLocationData(userLocation, lat, lng);
                          }
                      });

                  }
              }
          } catch (e) { }
      },
      /**
        *
        * This function is similar to setUserLocationCookie, but will set a different set of cookie for HomeCity,
        * tracking of a user and post the data to data-platform.
        *
        * Hence moving out the similar logic to a different function.
        */
      setUserHomeCity: function () {
          try {
              var geocoder;

              var initialize = function () {
                  //geocoder = new google.maps.Geocoder();

                  successFunction = function (position) {
                      var lat = position.coords.latitude;
                      var lng = position.coords.longitude;
                      codeLatLngv1(lat, lng);
                  }

                  errorFunction = function (err) {
                      console.error("Geocoder failed", err.message);
                      //storeUserLocationData("", "", "");
                  }

                  if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(successFunction, errorFunction, { timeout: 10000 });
                  }

                  var storeUserLocationData = function (userObj) {
                      var latlng = userObj.lat + ',' + userObj.lng;
                      var dataObj = {};
                      userObj.lat = userObj.lat.toString();
                      userObj.lng = userObj.lng.toString();
                      dataObj['searchData'] = userObj;
                      if (CT && CT.utils && CT.utils.cookies) {
                          if (CT.utils.cookies.read('userHomeLatLng') && CT.utils.cookies.read('userHomeCity')) {
                              //Found cookie : Check if with specified range : then update.
                              var oldLatLng = CT.utils.cookies.read('userHomeLatLng');
                              var oldLat = oldLatLng.split(',')[0];
                              var oldLng = oldLatLng.split(',')[1];
                              var distance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(oldLat, oldLng, userObj.lat, userObj.lng);
                              if (distance >= 50) {
                                  CT.utils.cookies.create('userHomeLatLng', latlng, 365);
                                  CT.utils.cookies.create('userHomeCity', userObj.city, 365);
                                  if (userObj.state)
                                      CT.utils.cookies.create('userHomeState', userObj.state, 365);
                                  //category,action,element,ctobj,eventType

                                  // window.console && console.log(dataObj);
                                  CT.utils.trackers.ctanalyticsTrackingData('N/A', 'logLocation', 'location', dataObj, 'location');
                              }
                          } else {
                              //No cookie found against user : create cookie.
                              CT.utils.cookies.create('userHomeLatLng', latlng, 365);
                              CT.utils.cookies.create('userHomeCity', userObj.city, 365);
                              if (userObj.state)
                                  CT.utils.cookies.create('userHomeState', userObj.state, 365);
                              //post loguievent data;
                              CT.utils.trackers.ctanalyticsTrackingData('N/A', 'logLocation', 'location', dataObj, 'location');
                          }

                      }
                  }

                  var codeLatLngv1 = function (lat, lng) {
                      var userObj = {};
                      var url = "/local/api/v1/getCity?latitude=" + lat + "&longitude=" + lng
                      $.ajax({
                          url: url,
                          type: 'GET',
                          success: function (response) {
                              //console.log("response results : ",response);
                              if (response.hasOwnProperty('city')) {
                                  //console.log(response.city)
                                  userObj.city = response.city;
                                  userObj.state = response.state;
                                  userObj.lat = lat;
                                  userObj.lng = lng;
                                  userObj.locality = "";
                                  storeUserLocationData(userObj);
                              } else {
                                  console.error("Empty Response from getCity");
                              }
                          },
                          error: function (err) {
                              console.error(err);
                          }
                      });
                  }

                  var codeLatLng = function (lat, lng) {
                      var latlng = new google.maps.LatLng(lat, lng);
                      var userObj = {};
                      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                          if (status == google.maps.GeocoderStatus.OK) {
                              if (results[0]) {
                                  _.find(results[0].address_components, function (addressObj) {
                                      if (_.contains(addressObj.types, 'sublocality_level_1')) {
                                          userObj.locality = addressObj.long_name;
                                          return true;
                                      }
                                  });
                                  _.find(results[0].address_components, function (addressObj) {
                                      if (_.contains(addressObj.types, 'locality') || _.contains(addressObj.types, 'administrative_area_level_2')) {
                                          userObj.city = addressObj.long_name;
                                          userObj.lat = lat;
                                          userObj.lng = lng;
                                          return true;
                                      }
                                  });
                                  storeUserLocationData(userObj);
                              } else {
                                  window.console && console.log("No results found");
                                  //storeUserLocationData(userLocation, lat, lng);
                              }
                          } else {
                              window.console && console.log("Geocoder failed due to: " + status);
                              //storeUserLocationData(userLocation, lat, lng);
                          }
                          //console.log(userObj.city, userObj.latitude, userObj.longitude);
                      });
                  }
              }

              //Make sure the script is loaded once, the call initialize.
              /*
              if(!window.google){
                  CT.getScript("//maps.googleapis.com/maps/api/js?key=AIzaSyBICejdTstEMJamaR3_1yVvohjIhLikbCM", function() {initialize()});
              }else{
                  initialize();
              }*/
              initialize();
          } catch (e) { }

      },

      tpTrack: function (data) {
          //third party tracking
          try {
              function format(values) {
                  _.each(values, function (value, index) {
                      try {
                          if (value)
                              switch (index) {
                                  case 'departure_date': case 'return_date': case 'price_lock_exp_date': case 'date of journey': case 'date of return':
                                      var time = false;
                                      if (!_.isArray(value)) {
                                          value = [value];
                                      }
                                      var time = [], t = false;;
                                      _.each(value, function (date) {
                                          if (typeof date == 'string') {
                                              date = date.split('/');
                                              t = date.length == 3 ? (new Date(date[1] + '/' + date[0] + '/' + date[2]).getTime()) : false;
                                              if (t)
                                                  time.push(t);//Epoch time is not working..
                                          }
                                      })

                                      if (time.length > 0) {
                                          time.length = 1;//Only one accepeted.
                                          values[index] = new Date(time[0]);
                                      }
                                      else delete values[index];
                                      break;
                                  case 'airline':
                                      values[index] = values[index].split(':').map(function (val) { return val.split('-')[0] }).join(',');

                                      break;
                                  case 'last_event_type':
                                      if (value == -1)
                                          values[index] = window.clevertapLastEventType || (window.localStorage && window.localStorage['CLVR_LE']) || null;
                                      if (values[index] == null)
                                          delete values[index];
                                      break;
                                  case 'last_page_name':
                                      if (value == -1)
                                          values[index] = window.clevertapLastPage || (window.localStorage && window.localStorage['CLVR_LP']) || null;
                                      if (values[index] == null)
                                          delete values[index];
                                      break;
                                  default: break;
                              }
                      } catch (e) {
                          window.console && console.log(e)
                      }

                  })
              }
              if (data.tp == 'clevertap') {
                  if (!window.cleverTapEnabled) return window.console && console.warn('CleverTap Not Enabled');
                  CT.utils.initCleverTap();
                  if (data.logout) {
                      window.clevertap.clear();
                      window.clevertap.logout();
                      return;
                  }
                  var clevertapProfile = {};
                  if (CT.utils.cookies.read('userid')) {
                      var id = decodeURIComponent(CT.utils.cookies.read('userid'));
                      id = id.split('|');
                      if (!window.__clevertapProfileEmailPassed || !clevertap.profile.getAttribute || clevertap.profile.getAttribute("Email") !== id[0]) {
                          clevertapProfile = {
                              "Email": id[0],
                              "Identity": id[4],
                              "Name": (window.userFullName ? window.userFullName : '') + (id[1] ? ' (' + id[1] + ')' : '')
                          };
                          if (id[2] == 'M' || id[2] == 'F')
                              clevertapProfile.Gender = id[2];
                          if (id[3] && id[3] != '')
                              clevertapProfile.Photo = 'https://' + window.location.host + '/profile/photos/' + id[3];

                          if (window.FB && FB.api) {
                              FB.api('/me', { fields: 'id,name,email,birthday,gender,education,work' }, function (userData) {
                                  clevertap.profile.push({ "Facebook": userData });
                              });
                          }
                          window.__clevertapProfileEmailPassed = true;
                      }
                  }
                  var apacheCookie = CT.utils.cookies.read('Apache');
                  if (!clevertap.profile.getAttribute || clevertap.profile.getAttribute("apache_cookie") !== apacheCookie) {
                      clevertapProfile.apache_cookie = apacheCookie;
                  }
                  var abCookie = CT.utils.cookies.read("ct-ab");
                  if (!window.__clevertapABTestPassed && abCookie) {
                      var abValues = {}
                      if (abCookie) {
                          abCookie = JSON.parse(unescape(abCookie));
                          if (typeof abCookie == 'object') {
                              _.each(abCookie, function (value, key) {
                                  abValues['ab_' + key] = value;
                              })
                          }
                      }
                      clevertapProfile = _.extend((clevertapProfile || {}), abValues);
                      window.__clevertapABTestPassed = true;
                  }

                  if (_.keys(clevertapProfile) && _.keys(clevertapProfile).length) {
                      clevertap.profile.push({
                          "Site": clevertapProfile
                      });
                  }

                  if (data.values && CT.app != "hotel") {
                      data.values.domain = window.location.host;
                      data.values.language = (window.CT.langUrlPrefix) ? window.CT.langUrlPrefix.substr(1) : "en";
                  } else if (data.values && CT.app === "hotel") {
                      data.values.domainName = window.location.host;
                  }

                  format(data.values);
                  window.clevertapLastEventType = data.category;
                  if (window.localStorage) {
                      window.localStorage.CLVR_LE = data.category;
                      if (data.values && data.values.page_name) {
                          window.localStorage.CLVR_LP = data.values.page_name;
                          window.clevertapLastPage = data.values.page_name;
                      }
                  }
                  window.clevertap.event.push(data.category, data.values);
              }

              if (data.tp == "moengage") {
                  if (!window.moengageEnabled) { return window.console && console.warn('Moengage not Enabled') };
                  if (!window.moengageId) { return window.console && console.warn('Moengage id not available') };
                  if (window.moengageEnabled && window.moengageId) {
                      function initMoengage() {
                          window.Moengage = moe({ app_id: window.moengageId, debug_logs: window.moengageDebugLogs ? window.moengageDebugLogs : 0 });
                      };
                      if (!window.Moengage) { initMoengage(); }
                      if (data.logout) {
                          Moengage.destroy_session();
                          return;
                      }
                      if (window.CT && window.CT.utils && window.CT.utils.cookies && window.CT.utils.cookies.read("usermisc") && window.CT.utils.cookies.read("usermisc").match("SIGNED_IN")) {
                          var id = decodeURIComponent(CT.utils.cookies.read('userid'));
                          id = id.split('|');
                          //Moengage.USER_ATTRIBUTE_USER_NAME(window.userFullName ? window.userFullName : id[1] ? id[1] : '');
                          Moengage.add_unique_user_id(id[4]);
                          Moengage.add_email(id[0]);
                          Moengage.add_gender(id[2]);
                      }
                      if (data.category && data.values) Moengage.track_event(data.category, data.values);
                  }
              }

              if (data.tp == 'fb' && window.B2cProductEnabled) {
                  function fbInit(callback) {
                      if (!window._fbqInit) {
                          !function (f, b, e, v, n, t, s) {
                              if (f.fbq) return; n = f.fbq = function () {
                                  n.callMethod ?
                                  n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                              }; if (!f._fbq) f._fbq = n;
                              n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
                              t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
                          }(window,
                              document, 'script', '//connect.facebook.net/en_US/fbevents.js');

                          fbq('init', '288042424732696');
                          window._fbqInit = true;
                      }
                      if (typeof (callback) == "function") callback();
                  }
                  fbInit(function () {

                      fbq('track', data.category, data.values || null);
                  });

              }
          } catch (e) {
              window.console && console.log(e)
          }

      },

      /**
       * This method logs the link click to Google Analytics.
       * @param {Boolean} this object of the link.
       * trackerCategory,tracker attributes should be set.
       */
      trackLinkClick: function (thisObj) {
          try {
              _gaq.push(['_trackEvent', thisObj.attr("trackerCategory"), 'click', thisObj.attr("tracker")]);

              //pageTracker._trackEvent(thisObj.attr("trackerCategory"), 'click', thisObj.attr("tracker"));
          } catch (err) { }
      },

      trackViewsRender: function (trackCat, trackName) {
          try {
              _gaq.push(['_trackEvent', trackCat, 'render', trackName]);

              // pageTracker._trackEvent(trackCat, 'render', trackName);
          } catch (err) { }
      },

      forceHttpsLinks: function ($node) {
          try {
              $node = $node || $(document.body);
              var accountPage = window.location.pathname.indexOf("/account") == 0


              if (document.location.protocol === "https:") {
                  $node.find("a.forceHttp").each(function (index, link) {
                      if (!accountPage || !$(link).attr("appref"))
                          this.href = this.href.replace("https:", "http:");
                  });

                  $node.find("form.forceHttp").each(function (index, form) {
                      this.action = this.action.replace("https:", "http:");
                  });
              }
              if (document.location.protocol === "http:") {
                  $node.find("a.forceHttps").each(function (index, link) {
                      if (!accountPage || !$(link).attr("appref"))
                          this.href = this.href.replace("http:", "https:");
                  });


                  $node.find("form.forceHttps").each(function (index, form) {
                      this.action = this.action.replace("http:", "https:");
                  });
              }
          } catch (e) {
              // error.
          }
      },

      forceLanguagePrefix: function ($node) {
          try {

              function getLangPrefixed(url, langUrlPrefix) {
                  var returnUrl = url;
                  if (returnUrl.split("/")[0] != langUrlPrefix) {
                      returnUrl = langUrlPrefix + url;
                  }
                  return returnUrl;
              };

              function diffDomain(url) {
                  try {
                      var urlObj = new URL(url);
                      if (urlObj.hostname != window.location.hostname) {
                          return true;
                      } else {
                          return false;
                      }
                  } catch (e) {
                      return false;
                  }
              };

              function alreadyContainsLang(url) {
                  return url.indexOf(window.CT.langUrlPrefix + "/") != -1;
              };

              var langUrlPrefix;
              var elementsToProcess = [{ "tag": "a", "attr": "pathname" },
              { "tag": "form", "attr": "action" }];

              langUrlPrefix = window.CT.langUrlPrefix;
              $node = $node || $(document.body);

              if (langUrlPrefix) {
                  var elementsToProcessLength = elementsToProcess.length;
                  for (var i = 0; i < elementsToProcessLength; i++) {
                      var elementToProcess = elementsToProcess[i];
                      var elements = $node.find(elementToProcess.tag);
                      var elementsLength = elements.length;
                      var diffDomainChkAttr = elementToProcess.tag == "a" ? "href" : "action";
                      for (var j = 0; j < elementsLength; j++) {
                          var element = elements[j];
                          var $element = $(element);
                          var pathname = "";

                          if (element[elementToProcess.attr] != "javascript:void(0)"
                              && element[elementToProcess.attr] != "#"
                              && element[elementToProcess.attr] != ""
                              && !diffDomain(element[diffDomainChkAttr])
                              && !alreadyContainsLang(element[elementToProcess.attr])
                              && $element.attr("langlink") != "true") {
                              pathname = (elementToProcess.attr == "pathname") ? (element[elementToProcess.attr]) : (new URL(element[elementToProcess.attr]).pathname);
                              element[elementToProcess.attr] = getLangPrefixed(pathname, langUrlPrefix);
                          }

                      }
                  }

              }

          } catch (e) {
              // error.
              window.console && console.log("Error in executing Fn:forcelanguagePrefix");
          }
      },

      createOfferBand: function () {
          try {
              if (window.search_offers) {
                  var offerDiv = $("<div id='Flash' style='display:none' ></div>");
                  var offerPara = $("<p></p>");
                  if (search_offers.NODISPLAY) {
                      return false;
                  }
                  var offer_title = search_offers.HEADING;
                  var offer_desc = search_offers.DESC1;
                  var offer_link = search_offers.LINK1;
                  var offer_class = search_offers.CLASS1;
                  var offer_hasTracker = search_offers.HASTRACKER;
                  var offer_tracker = search_offers.TRACKER;
                  var offer_tracker_cat = search_offers.TRACKERCAT;
                  offerPara.html("<strong>" + offer_title + "</strong>" + offer_desc);
                  var offerlinkknwmore = $("<a title='" + offer_title + "' href='" + offer_link + "' target='_blank' >Know more &gt;&gt; </a>");
                  offerPara.append(offerlinkknwmore);
                  if (offer_hasTracker == "Y") {
                      //offerlinkknwmore.attr("onclick"," _gaq.push(['_trackEvent', '"+offer_tracker_cat+"', 'click', '"+offer_tracker+"'])");
                  }

                  $("#offerDisplay").append(offerDiv.addClass(offer_class).append(offerPara));
                  var isIE6 = (navigator.userAgent.indexOf("MSIE 6") >= 0) ? true : false;
                  if (!isIE6) {
                      offerDiv.attr('className', offer_class);
                  } else {
                      offerDiv.attr('className', offer_class + " " + "clearfix");
                  }
              }
          }
          catch (e) {
          }
      },
      /**
          refer: refer-domain
          param: page param

          page 1 (search)
          cookie: refer and page1-parms

          page 2 (spa: search results)
          cookie: refer and page2-parms

          page3 (book review: itinerary)
          cookie: page2 and page3-parms

          page4 (spa: book review: traveller)
          cookie: page2 and page4-parms

          page5 (spa: book review: payment)
          cookie: page2 and page5-parms

          page6 (confirmation)
          cookie: page5 and page6-parms
      **/
      storeUserReferer: (function () {
          var tracked = [];
          var store = function () {
              CT.utils.cookies.create("pagerf", (document.referrer || "direct"))
              CT.utils.cookies.create("pageprm", (window.location.search.substr(1) || "NA"))
          };


          return function () {

              if (tracked[tracked.length - 1] != window.location.href) {
                  store();
                  tracked.push(window.location.href);
              }
          };

      }()),
      storePaidChannelSource: (function () {
          var tracked = false;

          return function () {
              if (tracked)
                  return;
              var urlParamsObj, urlParams;
              tracked = true;
              urlParams = window.location.search.substring(1);
              if (urlParams.indexOf("&") == 0) { // if the params are incorrect do to the starting & sign.
                  urlParams = urlParams.substring(1);
              }
              if (urlParams) {
                  urlParamsObj = JSON.parse('{"' + decodeURI(urlParams).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
                  if (urlParamsObj.gclid) {
                      CT.utils.cookies.create("paidchnl", 'googlesem', 1);
                  } else if (urlParamsObj.utm_source) {
                      CT.utils.cookies.create("paidchnl", urlParamsObj.utm_source, 1);
                  } else if (!CT.utils.cookies.read("paidchnl") || CT.utils.cookies.read("paidchnl") === "NA") { // the second OR condition can be removed , doesn't make any effect.
                      CT.utils.cookies.create("paidchnl", "NA", 1);
                  }
              } else if (!CT.utils.cookies.read("paidchnl")) {
                  CT.utils.cookies.create("paidchnl", "NA", 1);
              }
          }
      }()),


      spotNonCleartripReferrer: function (isIframe, url) {
          // this method should function only on promotion, offer pages and hotel SRP.
          // in tuxedo this should be triggered in (search and SRP) pages since the pages are shtml
          // "SearchBanner" is the container of the search widget, which is present in all the promotion and offer pages.
          try {
              var domainName = window.location.hostname;
              domainName = domainName.substr(domainName.indexOf("."));
              if (url) {
                  //var urlHash = _.deserialize(url.split('results?')[1]);
                  var urlHash = _.deserialize(window.location.search.substring(1));
              }
              var refLoc = document.createElement('a');
              refLoc.href = (isIframe && parent.document.referrer) ? parent.document.referrer : document.referrer != "" ? document.referrer : (urlHash && urlHash.utm_source && urlHash.utm_source != "") ? url : "";

              // a day has 1440 mins.
              // so, 1440 -> 1day, 30 -> ?days => 30 / 1440.

              var expiryDate = 30 / 1440;
              CT.utils.cookies.create("r_referer", encodeURIComponent(refLoc.href), expiryDate, domainName);
              if (urlHash && urlHash.gclid) {
                  if (!urlHash.utm_source) {
                      urlHash.utm_source = "googlesem";
                  }
                  CT.utils.cookies.create("r_params", encodeURIComponent(_.serialize(urlHash)), expiryDate, domainName);
              } else {
                  if (CT.utils.cookies.read("utm_source") && CT.utils.cookies.read("utm_source").toLowerCase() != "googlesem") { //Maing a check for google paid service because here user can land on home/srp/detail/directory page
                      //if(refLoc.hostname.indexOf("cleartrip") == -1){
                      if (isIframe && parent.document.referrer) {
                          CT.utils.cookies.create("r_params", encodeURIComponent(parent.window.location.search.substr(1)), expiryDate, domainName);
                      } else if (document.referrer) {
                          CT.utils.cookies.create("r_params", encodeURIComponent(window.location.search.substr(1)), expiryDate, domainName);
                      } else if (urlHash && urlHash.utm_source && urlHash.utm_source != "") {
                          CT.utils.cookies.create("r_params", encodeURIComponent(window.location.search.substr(1)), expiryDate, domainName);
                      }
                      //}
                  }
              }


          } catch (e) {
              //console.log("unable to spot non cleartrip referer :"+e.message);
          }
      },

      setTrivagoReferrer : function(){
          //expieryDays = 7 days - after 7 days trivago reference should be expired
          var localStorage = window.localStorage;
          //create a item to store trv_refernce with 7 days of expirey date.
          if(localStorage){
              var ct_ref = {
                  trv_ref : encodeURIComponent(window.HD.paramsHashObj.trv_reference),
                  expDate : new Date().setDate(new Date().getDate() + 7)
              }
              localStorage.setItem("ct_trvref", JSON.stringify(ct_ref));
          }
      },
      setUtmParametersInSessionStorage: function () {
          var url = location.href;
          var urlParams = {};
          if (sessionStorage.getItem("UTM_PARAMETERS") != null) {
              urlParams = JSON.parse(sessionStorage.getItem("UTM_PARAMETERS"));
          }
          var utmParams = ["utm_source", "utm_medium", "utm_term", "utm_campaign", "utm_content", "user-agent"];
          url.replace(
              new RegExp("([^?=&]+)(=([^&]*))?", "g"),
              function ($0, $1, $2, $3) {
                  if (utmParams.indexOf($1) > -1) {
                      urlParams[$1] = $3;
                  }
              }
          );


          var jsonEncodedUtmParams = JSON.stringify(urlParams);
          if (CT.utils.helperFunctions.isLocalStorageNameSupported()) {
              sessionStorage.setItem("UTM_PARAMETERS", jsonEncodedUtmParams);
          }
      },
      getWorkPlusUserState: function (cb) {
          var userId = unescape(CT.utils.cookies.read('userid'));
          $.ajax({
              url: ('/workplus/user/state?userId=') + userId.split('|').reverse()[0],
              method: "GET",
              success: function (data, statusText, res) {
                  if (res && res.status == 200) {
                      CT.workPlusState = data
                  }
                  if (cb) {
                      cb(data, statusText, res)
                  }
              },
              error: function (err) {
                  console.log(err)
              }
          });
      },
      constructImageUrl : function (image, transformations){
          var defaultTransformation = 'f_auto,q_auto,c_fill,e_sharpen:80,g_auto,fl_progressive'
          if (window.location.pathname.indexOf("/hotels") === -1) {
              return 'https://res.cloudinary.com/cleartrip/image/fetch/'+(transformations?transformations+',':'')+defaultTransformation+'/'+image
          }
          return 'https://fastui.cltpstatic.com/image/fetch/'+(transformations?transformations+',':'')+defaultTransformation+'/'+image
      }
  },
  checkUnConfirmedUser: function () {
      return CT.utils.cookies.read('unconfirmed-email') != undefined;
  },

  readCTAuthCookie: function () {
      CT.settings = CT.settings || {};
      CT.settings.ctAuthCookieName = CT.settings.ctAuthCookieName || (/dp\.cleartirp\.com|vegas\.cleartrip\.com/.test(window.location.hostname) ? "dev-usermisc" : "usermisc");
      if (CT.utils.cookies.read(CT.settings.ctAuthCookieName) && unescape(CT.utils.cookies.read(CT.settings.ctAuthCookieName)).split("|")[0] == "SIGNED_IN") {
          return true;
      } else {
          return false;
      }
  },
  localStore: {
  // Function to check if browser supports the HTML5 localstorage
  localStoreSupport: function() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
  },
  set: function(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else {
        var expires = "";
    }
    if( this.localStoreSupport() ) {
        localStorage.setItem(name, value);
    }
    else {
        document.cookie = name+"="+value+expires+"; path=/";
    }
  },
  get: function(name) {
    if( this.localStoreSupport() ) {
        var ret = localStorage.getItem(name);
        //console.log(typeof ret);
        switch (ret) {
          case 'true':
              return true;
          case 'false':
              return false;
          default:
              return ret;
        }
    }
    else {
        // cookie fallback
        /*
         * after adding a cookie like
         * >> document.cookie = "bar=test; expires=Thu, 14 Jun 2018 13:05:38 GMT; path=/"
         * the value of document.cookie may look like
         * >> "foo=value; bar=test"
         */
        var nameEQ = name + "=";  // what we are looking for
        var ca = document.cookie.split(';');  // split into separate cookies
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];  // the current cookie
            while (c.charAt(0)==' ') c = c.substring(1,c.length);  // remove leading spaces
            if (c.indexOf(nameEQ) == 0) {  // if it is the searched cookie
                var ret = c.substring(nameEQ.length,c.length);
                // making "true" and "false" a boolean again.
                switch (ret) {
                  case 'true':
                      return true;
                  case 'false':
                      return false;
                  default:
                      return ret;
                }
            }
        }
        return null; // no cookie found
      }
    },
    del: function(name) {
        if( this.localStoreSupport() ) {
            localStorage.removeItem(name);
        }
        else {
            this.set(name,"",-1);
        }
    }

},

  //TODO: to move out of ct_utils , since these cookie util function will not be used in all pages.

  cookies: {
      /**
       * Creates a cookie on the user's system.
       * @param {String} name The name of the cookie to be created
       * @param {String} value The value of the cookie
       * @param {Number} days The number of days the cookie should exist before expiring.
       * @param {String} domain The domain in which the cookie should be set.
       * @memberOf CT.cookies
       */
      createWithSeconds: function (/* String */ name, /* String */ value, /* Number */ seconds, /* String */ domain) {
          var expires;
          var domainScope;
          if (seconds) {
              var date = new Date();
              date.setTime(date.getTime() + (seconds * 1000));
              expires = "; expires=" + date.toGMTString();
          } else {
              expires = "";
          }

          if (domain) {
              domainScope = "; domain=" + domain;
          } else {
              domainScope = "";
          }
          document.cookie = name + "=" + value + expires + domainScope + "; path=/";
      },

      /**
       * Creates a cookie on the user's system.
       * @param {String} name The name of the cookie to be created
       * @param {String} value The value of the cookie
       * @param {Number} days The number of days the cookie should exist before expiring.
       * @param {String} domain The domain in which the cookie should be set.
       * @memberOf CT.cookies
       */
      create: function (/* String */ name, /* String */ value, /* Number */ days, /* String */ domain) {
          var expires;
          var domainScope;
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toGMTString();
          } else {
              expires = "";
          }

          if (domain) {
              domainScope = "; domain=" + domain;
          } else {
              domainScope = "";
          }
          document.cookie = name + "=" + value + expires + domainScope + "; path=/";
      },

      /**
       * Reads a cookie if it exists.
       * @param {String} name The name of the cookie to be read.
       * @return {String} The value of the cookie. Returns null if the cookie doesn't exist.
       * @memberOf CT.cookies
       */
      read: function (/* String */ name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1, c.length);
              }
              if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length); }
          }
          return null;
      },

      /**
       * Erases a cookie if it exists.
       * @param {String} name Name of the cookie to be erased. If this name isn't found, no action is taken.
       * @param {String} domain The domain in which the cookie should be deleted.
       * @memberOf CT.cookies
       */
      erase: function (name, domain) {
          CT.utils.cookies.create(name, "", -1, domain);
      }
  },

  /**
  *App download and offer banner templates and conversion
  **/

  merchandisingBanner: {
      templates: {
          'appUpsell': function () {
              var template = '<div id="appDownloadBanner" class="row"><table width="100%"><tbody><tr><td><i class="AppDownloadIcon"></i></td><td><a id="floatingBanner" class="<%=class1%>" href="<%=link%>" target="_blank" onClick="<%=onclickEve%>" rel="nofollow"><strong class="<%=class1%>"><%=heading%></strong><%=text%></a></td><td><a href="<%=link%>" target="_blank" class="downloadBtn">Download</a></td></tr></tbody></table></div>';
              return template;
          },
          'offer': function () {
              var template = '<div class="mobileOffer"><a href="<%=link%>" onClick="<%=onclickEve%>" target="_blank"><i class="i24 offerIcon"></i><span><strong><%=heading%></strong><%=text%></span></div>';
              return template;
          }
      },

      createMarkup: function (bannerObj, type) {
          try {
              var obj = bannerObj[0] || {};
              var replacer = {
                  heading: obj.HEADING && obj.HEADING.trim() != "." ? obj.HEADING : "",
                  text: obj.DESC1 ? obj.DESC1 : "",
                  link: obj.LINK1 ? obj.LINK1 : "",
                  class1: obj.CLASS1 ? obj.CLASS1 : "",
                  onclickEve: ""
              }
              if ((obj.TRACKERCAT && obj.TRACKERCAT != null) || (obj.TRACKER && obj.TRACKER != null)) {
                  var cat = obj.TRACKERCAT && obj.TRACKERCAT != null ? obj.TRACKERCAT : "";
                  var action = obj.TRACKER && obj.TRACKER != null ? obj.TRACKER : "";
                  replacer['onclickEve'] = "_gaq.push(['_trackEvent', '" + cat + "', '" + action + "']);";
              }
              var templateMarkup = CT.utils.merchandisingBanner.templates[type]();
              var nodeTxt = _.template(templateMarkup, replacer);
              return nodeTxt;
          } catch (e) {
              return false;
          }
      },

      create: function (url, elem, type) {
          var type = type || "offer";
          try {
              $.ajax({
                  url: url,
                  type: 'GET',
                  success: function (response) {
                      var node = CT.utils.merchandisingBanner.createMarkup(response, type);
                      if (node) {
                          $.each(elem, function (i, val) {
                              if ($(val) && $(val).length) $(val).html(node);
                          });
                      }
                  },
                  error: function () { return false; }
              })
          } catch (e) { return false; }
      }
  },
  // Remarketing methods to be triggered
  remarketing: {
      /**
       * Creates a new script and attaches it to the page
       * @param {id} id of the gtm block
       * @param {tag_params} the google_tag params
       * @param {url} change the url if you want
       */
      triggerRmScript: function (id, tag_params, url) {
          window.google_conversion_id = +id;
          window.google_tag_params = window.google_tag_params || {};
          window.google_custom_params = _.extend(window.google_tag_params, tag_params);
          window.google_remarketing_only = true;
          $.getScript('https://www.googleadservices.com/pagead/conversion.js')
      }
  },

  /**
   * this namespace contains any functionality related to tracking (like carosel navigation,page view tracking, etc)
   * TODO: ga.js include should be moved here
   */
  trackers: {
      /**
       * This function is used to keep a track of page views with the help of cookies
       * cookieName: ct_ct
       * a page is tracked if the ct_ct_track variable is present in the page
       * ct_ct_track =  {n:"pageName", p:"productType"};
       * Eg: ct_ct_track = {n:"si", p:"ad"}; ct_ct="XXXXXX" (encrypted cookie value).
       */
      page_count: function (_ct_ct_track) {
          try {
              _ct_ct_track = _ct_ct_track || window.ct_ct_track;
              if (_ct_ct_track) {
                  var ctTrackUrl = "/common/ctct";
                  var cookieName = "ct_ct";
                  var cookieValue = CT.utils.cookies.read(cookieName) ? CT.utils.cookies.read(cookieName) : "";
                  var apacheCookieValue = CT.utils.cookies.read("Apache") ? CT.utils.cookies.read("Apache") : "";
                  var params = { "n": _ct_ct_track.n, /*--"s": cookieValue,--*/ "p": _ct_ct_track.p/*, "a": apacheCookieValue*/, "bd": _ct_ct_track.bd, "sr": "y" };

                  if (cookieValue && $.browser.msie != true) {
                      CT.utils.cookies.erase(cookieName, "." + window.location.hostname);
                  }

                  $.ajax({
                      url: ctTrackUrl,
                      type: 'POST',
                      headers: { "Pragma": "no-cache", "Cache-Control": "no-cache", "Expires": "0" },
                      data: params,
                      success: function (data) {
                          if (data) { // in FF browsers the response comes as a XML Document if the ContentType is not mentioned in the response headers
                              if (typeof data === "string") {
                                  data = JSON.parse(data);
                              }
                              var app = (_ct_ct_track.p === 'ad' || _ct_ct_track.p === 'ai') ? "air" : "hotel";
                              var respJson = data[_ct_ct_track.p];
                              CT["Yoptima_searchcount"] = 0;
                              CT["Yoptima_bookcount"] = 0;

                              if (respJson.ct)
                                  CT[app + "_dropoff"] = respJson.ct;

                              if (respJson.sr)
                                  CT[app + "_searchcount"] = respJson.sr;

                              if (respJson.c)
                                  CT[app + "_bookcount"] = respJson.c;

                              if (respJson.sd)
                                  CT[app + "_lastsearchdate"] = respJson.sd;

                              if (respJson.cd)
                                  CT[app + "_lastbookdate"] = respJson.cd;


                              if (app == 'air') {// for Yoptima tracking
                                  if (data["ad"] && data["ad"].sr) CT["Yoptima_searchcount"] = data["ad"].sr;
                                  if (data["ai"] && data["ai"].sr) CT["Yoptima_searchcount"] = CT["Yoptima_searchcount"] + data["ai"].sr;
                                  if (data["ad"] && data["ad"].c) CT["Yoptima_bookcount"] = data["ad"].c;
                                  if (data["ai"] && data["ai"].c) CT["Yoptima_bookcount"] = CT["Yoptima_bookcount"] + data["ai"].c;

                              }

                          }


                          /*CT.utils.cookies.create(cookieName,data);*/
                      },
                      error: function () {
                          //console.log("error in CT tracking call");
                      }
                  });
              }
          } catch (e) {
              //console.log("error in ct tracking");
          }
      },

      mixpanelTrackingData: {},
      clevertapGlobleData: {},
      ctanalyticsTrackingobj: {},

      analyticsTrackingError: function(ctobj, eventType,expiredSupplierList){
          var ctproduct = window.location.pathname.indexOf("hotels") != -1 ? "hotel" : CT.app == "hotel" ? "hotel" : "flight";
          var logingParams = {
              "emailID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]) : "N/A",
              "product": ctproduct,
              "eventType": eventType,
              "userID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|").slice(-1).pop()) : "N/A",
              //window.peopleId?String(window.peopleId):"N/A",
              "apacheCookie": CT.utils.cookies.read('Apache') ? CT.utils.cookies.read('Apache') : "N/A",
              "searchInstance": (CT.cache && CT.settings && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].sid) ? CT.cache[CT.settings.currentTab].sid : (window.ctsid ? window.ctsid : "N/A"),
              "domain": window.domainType || (window.countryCode || "N/A").toUpperCase(),
              "deviceType": 'Desktop',
              "flightType": (window.isInternational || window.isinternational || (CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab].searchType && CT.cache[CT.settings.currentTab].searchType.isIntl)) ? 'INTL' : 'DOM',
          };
          if(eventType === 'search_missing_airline' && expiredSupplierList.length > 0){
              logingParams.expiredSupplier = expiredSupplierList.toString();
          }

          if (ctobj && ctobj.searchData) {
              $.each(ctobj.searchData, function (key, value) {
                  logingParams[key] = value
                  if (typeof value !== 'string') {
                      window.console && console.error && console.error('Value for ' + key + ': must be a string. Developer needs to fix it');
                  }
              });
              var dataToBeSent = JSON.stringify(logingParams);
              if(CT.utils.getAbTestCookie('errorEvent') === 'a' && ctobj && ctobj.searchData){
                  CT.utils.helperFunctions.postAnalyticsErrorDataViaAJAX(dataToBeSent);
              }
          }

      },

      ctAnalyticsPageViewLogging: (function () {
          var tracked = [];



          return function (category, action, element, ctobj, eventType) {
              var ctproduct;
              if (tracked[tracked.length - 1] == window.location.href || CT.app == "air" || CT.app == "hotel") {
                  //console.log("..Already Logged this page..")
                  return;
              }
              tracked.push(window.location.href);
              if (arguments.length == 0) { // its default onload flow
                  category = "generic";
                  action = "Page_Viewed";
                  eventType = "page_load";
                  ctproduct = "generic";
                  element = window.location.path;
              } else {
                  ctproduct = window.location.pathname.indexOf("hotels") != -1 ? "hotel" : CT.app == "hotel" ? "hotel" : "flight";
              }

              var logParams = {
                  "emailID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]) : "N/A",
                  "product": ctproduct,
                  "eventType": eventType,
                  "userID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|").slice(-1).pop()) : "N/A",
                  "apacheCookie": CT.utils.cookies.read('Apache') ? CT.utils.cookies.read('Apache') : "N/A",
                  "searchInstance": (CT.cache && CT.settings && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].sid) ? CT.cache[CT.settings.currentTab].sid : (window.ctsid ? window.ctsid : "N/A"),
                  "category": category,
                  "events": [{
                      "action": "Page_Viewed",
                      "element": window.location.path, // make sure its a string.
                      "time": new Date().getTime()
                  }],
                  "searchData": {}
              };

              $.each(["pageprm", "pagerf", "paidchnl"], function (cookieName) {
                  if (CT.utils.cookies.read(cookieName))
                      logingParams.searchData[cookieName] = CT.utils.cookies.read(cookieName)
              })

              CT.utils.helperFunctions.postAnalyticsDataViaAJAX(logParams);


          };

      }()),







      ctanalyticsTrackingData: function (category, action, element, ctobj, eventType) {

          function addPageLoadInfo(dataToBeSent) {
              //create cookies if not created.
              CT.utils.helperFunctions.storeUserReferer();
              CT.utils.helperFunctions.storePaidChannelSource();

              dataToBeSent.searchData = dataToBeSent.searchData || {}
              $.each(["pageprm", "pagerf", "paidchnl"], function (i, cookieName) {
                  if (CT.utils.cookies.read(cookieName))
                      dataToBeSent.searchData[cookieName] = CT.utils.cookies.read(cookieName)
              });
          }




          var ctproduct = window.location.pathname.indexOf("hotels") != -1 ? "hotel" : CT.app == "hotel" ? "hotel" : "flight";
          var logingParams = {
              "emailID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]) : "N/A",
              "product": ctproduct,
              "eventType": eventType,
              "userID": CT.utils.cookies.read('userid') ? (decodeURIComponent(CT.utils.cookies.read('userid')).split("|").slice(-1).pop()) : "N/A",
              //window.peopleId?String(window.peopleId):"N/A",
              "apacheCookie": CT.utils.cookies.read('Apache') ? CT.utils.cookies.read('Apache') : "N/A",
              "searchInstance": (CT.cache && CT.settings && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].sid) ? CT.cache[CT.settings.currentTab].sid : (window.ctsid ? window.ctsid : "N/A"),
              "category": category,
              "domain": window.domainType || (window.countryCode || "N/A").toUpperCase(),
              "deviceType": 'Desktop',
              "flightType": (window.isInternational || window.isinternational || (CT.cache && CT.settings && CT.settings.currentTab && CT.cache[CT.settings.currentTab].searchType && CT.cache[CT.settings.currentTab].searchType.isIntl)) ? 'INTL' : 'DOM',
              "events": []
          };
          logingParams.events.push({
              "action": action,
              "element": element, // make sure its a string.
              "time": new Date().getTime()
          });
          var dataToBeSent = $.extend(true, {}, logingParams, ctobj);

          if (eventType == "page_load") {
              //TODO move out of this method.
              addPageLoadInfo(dataToBeSent);
          }
          dataToBeSent = JSON.stringify(dataToBeSent);
          /*VALIDATION*/
          //SearchData.
          if (ctobj && ctobj.searchData) {
              $.each(ctobj.searchData, function (key, value) {
                  if (typeof value !== 'string') {
                      window.console && console.error && console.error('Value for ' + key + ': must be a string. Developer needs to fix it');
                  }
              });
          }
          /*VALIDATION ENDS HERE*/

          CT.utils.helperFunctions.postAnalyticsDataViaAJAX(dataToBeSent);

      },

      includeMixPanel: function () {
          /*(function(e,b){if(!b.__SV){var a,f,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
          for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=e.createElement("script");a.type="text/javascript";a.async=!0;a.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";f=e.getElementsByTagName("script")[0];f.parentNode.insertBefore(a,f)}})(document,window.mixpanel||[]);
mixpanel.init("2e25e3e1418ebe5c9e22cc7542117c56");*/
          (function (e, b) {
              if (!b.__SV) {
                  var a, f, i, g;
                  window.mixpanel = b;
                  b._i = [];
                  b.init = function (a, e, d) {
                      function f(b, h) {
                          var a = h.split(".");
                          2 == a.length && (b = b[a[0]], h = a[1]);
                          b[h] = function () {
                              b.push([h].concat(Array.prototype.slice.call(arguments, 0)))
                          }
                      }
                      var c = b;
                      "undefined" !== typeof d ? c = b[d] = [] : d = "mixpanel";
                      c.people = c.people || [];
                      c.toString = function (b) {
                          var a = "mixpanel";
                          "mixpanel" !== d && (a += "." + d);
                          b || (a += " (stub)");
                          return a
                      };
                      c.people.toString = function () {
                          return c.toString(1) + ".people (stub)"
                      };
                      i = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
                      for (g = 0; g < i.length; g++) f(c, i[g]);
                      b._i.push([a, e, d])
                  };
                  b.__SV = 1.2;

                  var includeMixpanelJs = function () {
                      var e = document;
                      var a = e.createElement("script");
                      a.type = "text/javascript";
                      a.async = !0;
                      a.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
                      f = e.getElementsByTagName("script")[0];
                      f.parentNode.insertBefore(a, f)
                  }
                  // console.log("is window loaded ?");
                  if ($.isLoaded == true) {
                      includeMixpanelJs();
                  } else {
                      $(window).load(includeMixpanelJs);
                  }
              }
          })(document, window.mixpanel || []);
          if (window.mixpanelid) {
              function getQueryParam(url, param) {
                  param = param.replace(/[[]/, "\[").replace(/[]]/, "\]");
                  var regexS = "[\?&]" + param + "=([^&#]*)",
                      regex = new RegExp(regexS),
                      results = regex.exec(url);
                  if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
                      return '';
                  } else {
                      return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
                  }
              };

              function campaignParams() {
                  var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
                      kw = '',
                      params = {},
                      first_params = {};
                  var index;
                  for (index = 0; index < campaign_keywords.length; ++index) {
                      kw = getQueryParam(document.URL, campaign_keywords[index]);
                      if (kw.length) {
                          params[campaign_keywords[index] + ' [last touch]'] = kw;
                      }
                  }
                  for (index = 0; index < campaign_keywords.length; ++index) {
                      kw = getQueryParam(document.URL, campaign_keywords[index]);
                      if (kw.length) {
                          first_params[campaign_keywords[index] + ' [first touch]'] = kw;
                      }
                  }
                  //mixpanel.register(params);
              }


              if (window.mixpanelid === "0a226de2b3e76e79238ac2bd0905b2ee" || window.mixpanelid === "2c9ab7852e081744050665054208dc1d") { //following should be removed after some days.
                  if (CT.utils.cookies.read("mp_2c9ab7852e081744050665054208dc1d_mixpanel") != null) {
                      CT.utils.cookies.erase("mp_2c9ab7852e081744050665054208dc1d_mixpanel", '.cleartrip.com');
                  }
                  if (CT.utils.cookies.read("mp_1179ebc820df9415ed9b68de9d9fcffc_mixpanel") != null) {
                      CT.utils.cookies.erase("mp_1179ebc820df9415ed9b68de9d9fcffc_mixpanel", '.cleartrip.com');
                  }
                  if (CT.utils.cookies.read("mp_0a226de2b3e76e79238ac2bd0905b2ee_mixpanel") != null) {
                      CT.utils.cookies.erase("mp_0a226de2b3e76e79238ac2bd0905b2ee_mixpanel", '.cleartrip.com');
                  }
              }
              mixpanel.init(mixpanelid, {
                  "upgrade": true,
                  "persistence": "localStorage",
                  "cross_subdomain_cookie": false
              });
              campaignParams();
          }
      }
  },
  imgAdjust: function (applyOffset) {
      var $img = $(this);
      var $imgParent = $img.parent();

      if ($img.attr("src") == "" || $img.css("visibility") == "visible")
          return false;

      if ($imgParent.hasClass("loader")) {
          $imgParent.removeClass("loader");
      }
      //$imgParent.css("position", "relative");

      $img.css("position", "relative");
      if (applyOffset === undefined || applyOffset === false) {
          if ($img.width() <= $img.height()) {
              // portrait or square
              $img.css('width', "100%");
              // ie fix
              if ($img.height() > $imgParent.height()) {
                  var top = "-" + (($img.height() - $imgParent.height()) / 4) + "px";
                  $img.css("top", top);
              }
          } else {// landscape
              $img.css('height', "100%");
              // ie fix
              if ($img.width() > $imgParent.width()) {
                  var left = ($imgParent.width() - $img.width()) / 2 + "px";
                  $img.css("left", left);
              }

              if ($img.width() < $imgParent.width()) {
                  $img.css("width", "100%");
                  $img.css("height", "auto");
                  var top = "-" + (($img.height() - $imgParent.height()) / 4) + "px";
                  $img.css("top", top);
              }

          }
      }
      $img.css('opacity', 0).animate({ opacity: 1, visibility: 'visible' }, 0.5)

      return this
  },



  add: function (a, b) {
      return a + b;
  },
  subtract: function (a, b) {
      return a - b;
  },
  getType: function (obj) {
      return Object.prototype.toString.call(obj);
  },

  openPopup: function (opts) {
      this.showModalDialog(opts.url, opts.width, opts.height, true, true);
  },



  /**
   * Uses this for tuxedo and DP  flow - showModalDialog
   *
   * Commenting a scroll to top position for DP
   */
  showModalDialog: function (modalUrl, modalWidth, modalHeight, hideScrollbars, isChildWin, callback, modalFrameId, onEscapeClose, onDocumentClose, showStickyPin, preCloseCheck, closeCallbackObj, useFullScaleModalWindow) {

      if (modalUrl.search('refund-policy') != -1) {
          CT.utils.helperFunctions.trackGAEvent('Flights_TR', 'click', 'RefundPolicy', '100');
      }

      if (isChildWin) {
          var left = (screen.availWidth / 2) - (parseInt(modalWidth) / 2);
          var top = (screen.availHeight / 2) - (parseInt(modalHeight) / 2);
          var scrolling = hideScrollbars ? 0 : 1;
          var prop = "height=" + modalHeight + ",width=" + modalWidth + ",left=" + left + ",top=" + top + "screenX=" + left + ",screenY=" + top + ",status=yes,toolbar=no,scrollbars=" + scrolling + ",menubar=no,location=no,resizable=yes";
          window.open(modalUrl, 'window', prop);
          return false;

      }

      var yPos;
      var scrollTopPos = window.pageYOffset || document.documentElement.scrollTop || 0;
      var translucentLayer = $("<div/>", {
          "id": "TranslucentLayer"
      });
      if (modalFrameId == undefined) {
          modalFrameId = "ModalFrame";
      }
      if (closeCallbackObj === undefined || closeCallbackObj.callBackAttr == undefined) {
          closeAttrCallback = false;
      } else {
          closeAttrCallback = closeCallbackObj.callBackAttr
      }
      var modalFrame = $("<div/>", {
          "id": modalFrameId
      });
      var topBorder = $("<div/>");
      if (showStickyPin !== undefined && showStickyPin === true) {
          var pin = $("<span/>", { "class": "stickyPin" });
          topBorder.append(pin);
      }
      var close = $("<a/>", {
          "id": "close",
          "data-callback": closeAttrCallback,
          title: "Close window"
      });
      var onEscClose = "true";
      var onDocClose = (onDocumentClose == undefined) ? "true" : onDocumentClose;


      // Get the scroll
      if (modalUrl.search('guided-nav-modal') != -1) {
          yPos = 0;
      } else if (self.pageYOffset) {
          yPos = self.pageYOffset;
      } else if (document.documentElement && document.documentElement.scrollTop) {
          yPos = document.documentElement.scrollTop;
      } else if (document.body) {
          yPos = document.body.scrollTop;
      }

      // Prepare IE
      //Check mapVIew for tuxedo
      function prepareIE(height, overflow) {
          htm = window.top.document.getElementsByTagName('html')[0];
          body = window.top.document.getElementsByTagName('body')[0];
          htm.style.height = height;
          if ($(body).hasClass("mapView") != true) {
              htm.style.overflow = overflow;
          }

          body.style.height = height;
          if ($(body).hasClass("mapView") != true) {
              body.style.overflow = overflow;
          }


      }

      function toggleSelects(visibility) {
          selects = window.top.document.getElementsByTagName('select');
          for (i = 0; i < selects.length; i++) {
              selects[i].style.visibility = visibility;
          }
      }

      function resizeHandler() {
          if (!window.isMobileUA) {
              try {
                  if ($.browser.msie) {
                      $("#TranslucentLayer").css({
                          height: windowHeight + "px"
                      });
                  } else {
                      $("#TranslucentLayer").css({
                          height: (document.body.offsetHeight > windowHeight) ? document.body.offsetHeight + "px" : windowHeight + "px"
                      });
                  }
              } catch (e) {
              }
          }
          modalFrame.css({
              left: ((document.body.offsetWidth - modalFrame.offsetWidth) / 2) + "px"
          });
          modalFrame.css({
              top: (windowHeight - frameHeight) * 100 / (2 * windowHeight) + "%"
          });
      }

      function closePopup(e) {
          var closCeck = (preCloseCheck == undefined) ? true : preCloseCheck();
          if (closCeck === true) {
              window.top.scrollTo(0, yPos);
              if (!window.isMobileUA) {
                  prepareIE("auto", "auto");
              }
              toggleSelects("visible");
              $(document, window.frames['modal_window']).unbind('keyup.meals_modal_window click.meals_modal_window');
              if (!window.isMobileUA) {
                  $(document, window.frames['modal_window']).unbind('DOMMouseScroll.meals_modal_window mousewheel.meals_modal_window keydown.meals_modal_window');
                  window.top.$("#TranslucentLayer").remove();
              }
              if (window.isMobileUA) {
                  window.top.window.$('body').removeClass('noScroll');
              }
              $(window).unbind("resize.meals_modal_window", resizeHandler);
              window.top.$("#" + modalFrameId).remove();
              var myHtml = window.top.document.getElementsByTagName('html')[0];
              /*$(myHtml).css('overflow-y', 'scroll');
              if ($.browser.msie) {
                  window.scrollTo(0, scrollTopPos);
              }*/

              if ($("#FBmodal")) {
                  $("#FBmodal").remove();
              }
              //yPos added to scroll the parent window to previous position
              if (CT.app == 'dp')
                  callback && callback();
              else
                  callback && callback(yPos);


              if (e && $(e.target).attr("data-callback") && $(e.target).attr("data-callback") === "true") {
                  closeCallbackObj && closeCallbackObj.callBackFunc && closeCallbackObj.callBackFunc();
              }
              if (CT.app == "hotel" && CT.settings.currentTab && CT.cache[CT.settings.currentTab].guidedNav != null && CT.cache[CT.settings.currentTab].guidedNav == true) {
                  closeCallbackObj && closeCallbackObj.callBackFunc && closeCallbackObj.callBackFunc();
              }

              //hide spinner in modal while closing
              if ($(".updatingModal").length > 0) {
                  window.parent.$(".updatingModal").hide();
              }

          }
      }


      //prepareIE("100%", "hidden");
      //window.scrollTo(0, 0);
      toggleSelects("hidden");


      $(window).bind("resize.meals_modal_window", resizeHandler);



      /*
       * keyup has been moved to modal window
      document.onkeyup = function(e) {
          var e = window.event || e
          if (e.keyCode == 27) {
              CT.utils.hideModalDialog();
          }
      }
      keyUpHandler = function(e) {
          if (e.keyCode == 27 && onEscClose) {
              window.top.CT.utils.hideModalDialog();
          } // esc
      }

      $(document).keyup(keyUpHandler);
      $(window.frames['modal_window']).bind('keyup', keyUpHandler);

      */

      CT.utils.hideModalDialog = closePopup;

      if (!window.isMobileUA)
          $(document.body).append(translucentLayer);

      translucentLayer.bind("click", function () {
          if (onDocClose) {
              // if its hotel modal dialog then send a H_Modal_Close track ga event.
              if (/^(\/hotels\/info)/.test(modalFrame.find('iframe').attr('src'))) {
                  var m = modalFrame.find('iframe').attr('src').match(/^\/hotels\/info\/(\d+)\//),
                      hotelid = '';
                  if (m)
                      hotelid = m[1];
                  CT.utils.helperFunctions.trackGAEvent('Hotels_TR', 'H_Modal_Close', hotelid);
              }
              window.top.CT.utils.hideModalDialog();
          }
      });


      topBorder.append(close);

      modalFrame.append(topBorder);

      $("<iframe/>", {
          src: modalUrl,
          frameborder: 0,
          framespacing: 0,
          width: "100%",
          height: "100%",
          scrolling: hideScrollbars ? "no" : "auto",
          id: 'modal_window',
          name: 'modal_window',
          'class': 'spinnerMedium'
      }).appendTo(modalFrame);

      //var regEx = /^\/hotels\/info\/\d+\/modal/;
      var regEx = /^\/hotels\/api\/info\/\d+\/modal/
      if (window.CT && window.CT.app === 'hotel' && $('body').hasClass('srp') && modalUrl.match(regEx) || modalUrl.indexOf("abnb") > -1) {
          modalFrame.addClass('hotelDetailsModalFrame');
      }
      else {
          modalFrame.css({
              width: (modalWidth || "700px"),
              height: (modalHeight || "70%")
          });
      }

      $(document.body).append(modalFrame);

      var iframe = $("#" + modalFrameId).find("iframe")[0];
      $(iframe).bind("load", function () {
          if ($("#FBmodal")) {
              $("#FBmodal").remove();
          }
      });



      /* Hack: For IE6 modal close-textbox issue */
      close.bind("click.meals_modal_window", function (event) {
          window.top.CT.utils.hideModalDialog(event);
      });
      close.bind("mouseover.meals_modal_window", function () {
          close.addClass("over");
      });
      close.bind("mouseout.meals_modal_window", function () {
          close.removeClass("over");
      });
      if (!(window.CT && window.CT.app === 'hotel' && $('body').hasClass('srp') && useFullScaleModalWindow)) {
          var lf = (($(document.body).width() - modalFrame.width()) / 2) + "px";
          modalFrame.css({
              left: lf
          });

          var frameHeight = modalFrame.height();
          var windowHeight = $(window).height();
          modalFrame.css({
              top: (windowHeight - frameHeight) * 100 / (2 * windowHeight) + "%"
          });
      }

      if (!window.isMobileUA) {
          if ($.browser.msie) {
              translucentLayer.css({
                  height: windowHeight + "px"
              });
          } else {
              translucentLayer.css({
                  height: (document.body.offsetHeight > windowHeight) ? document.body.offsetHeight + "px" : windowHeight + "px"
              });
          }
      }

      this.bindModalEvents(onEscClose);
      if (!window.isMobileUA)
          this.preventParentScroll();
      //Modifying zindex of filters
      if (CT && CT.settings && CT.settings.currentTab && $("#ResultContainer_" + CT.settings.currentTab).length > 0) {
          $("#ResultContainer_" + CT.settings.currentTab).find(".filters").css({ "z-index": "1" });
      }

  },

  showModalDiv: function(modalUrl, modalWidth, modalHeight, hideScrollbars, isChildWin, modalFrameId, onEscapeClose, onDocumentClose, classes,callback) {

      if(isChildWin) {
          var left = (screen.availWidth/2) - (parseInt(modalWidth)/2);
          var top = (screen.availHeight/2) - (parseInt(modalHeight)/2);
          var scrolling =  hideScrollbars?0:1;
          var prop = "height="+modalHeight+",width="+modalWidth+",left=" + left +",top=" + top + "screenX=" + left + ",screenY=" + top +",status=yes,toolbar=no,scrollbars="+scrolling+",menubar=no,location=no,resizable=yes";
          CT.helperFunctions.hideChildWindow = window.open(modalUrl,'window',prop);
          return false;

      }

      var yPos;
      var scrollTopPos = window.pageYOffset || document.documentElement.scrollTop || 0;
          // Get the scroll
          if (self.pageYOffset) {
              yPos = self.pageYOffset;
          } else if (document.documentElement && document.documentElement.scrollTop){
              yPos = document.documentElement.scrollTop;
          } else if (document.body) {
              yPos = document.body.scrollTop;
          }

          // Prepare IE
          function prepareIE(height, overflow){
              htm = window.document.getElementsByTagName('html')[0];
              htm.style.height = height;
              htm.style.overflow = overflow;
              /*common accountv2 to be checked and removed if needed*/
              body = window.document.getElementsByTagName('body')[0];
              body.style.height = height;
              body.style.overflow = overflow;
         }

          function toggleSelects(visibility) {
              selects = window.document.getElementsByTagName('select');
              for(i = 0; i < selects.length; i++) {
                  selects[i].style.visibility = visibility;
              }
          }

          prepareIE("100%", "hidden");
          window.scrollTo(0,0);
          toggleSelects("hidden");

      function resizeHandler() {
          try {
              if($.browser.msie) {
                  $("#TranslucentLayer").css({ height : windowHeight + "px"});
              } else {
                  $("#TranslucentLayer").css({ height : (document.body.offsetHeight>windowHeight)?document.body.offsetHeight + "px" : windowHeight + "px" });
              }
          } catch(e){}
          modalFrame.css({left : ((document.body.offsetWidth - modalFrame.offsetWidth) / 2) + "px"});
          modalFrame.css({top: (windowHeight - frameHeight) * 100 / (2 * windowHeight) + "%"});
      }

      $(window).bind("resize", resizeHandler);

      if(modalFrameId == undefined) {
         modalFrameId = "ModalFrame";
         $("."+modalUrl).show();
      }

      var onEscClose = (onEscapeClose == undefined) ? "true" : onEscapeClose;
      var onDocClose = (onDocumentClose == undefined) ? "true" : onDocumentClose;
      document.onkeyup=function(e){
          var e = window.event || e
          if(e.keyCode == 27) {
              CT.utils.hideModalDialog();
          }
      }
      function closePopup() {
          window.scrollTo(0, yPos);
          prepareIE("auto", "auto");
          toggleSelects("visible");
          $(window).unbind("resize", resizeHandler);
          window.$("#TranslucentLayer").remove();
          var myHtml = window.document.getElementsByTagName('html')[0];
          $(myHtml).css('overflow-y','scroll');
          if($.browser.msie){
              window.scrollTo(0,scrollTopPos);
          }

          // move it back to where it came from.
          $("."+modalUrl).hide().appendTo($('body'));
          $("#"+modalFrameId).remove();
          callback && callback();
      }

      CT.utils.hideModalDialog = closePopup;

      var translucentLayer = $("<div/>", {"id": "TranslucentLayer"});

      $(document.body).append(translucentLayer);

      translucentLayer.bind("click", function() {
          if(onDocClose) {
              CT.utils.hideModalDialog();
          }
      });

      $(document).keyup(function(e) {
              if (e.keyCode == 27 && onEscClose) {CT.utils.hideModalDialog(); }   // esc
      });

      // check for modal windows existence.
      // unlike iframe where data is loaded(an external request is made) every time open
      // it, here we are moving a part of dom inside this div.
      // It is not a copy but a move operation, so if you overwrite this modal window, the content will be lost.
      // more comments will follow.

      var modalFrame, topBorder, close;
      if($('div#' + modalFrameId).length == 0) {
          modalFrame = $("<div/>", {
                                  "id": modalFrameId
                           });
          topBorder = $("<div/>");
          close = $("<a/>", {"id": "close", title: "Close window", style: 'z-index: 11'});
          topBorder.append(close);
          modalFrame.append(topBorder);
        }
        else {
            modalFrame = $('div#' + modalFrameId);
            close = $('a#close');
            topBorder = close.parent();

            // show the modal frame.
            modalFrame.show();
        }

      if ($("."+modalUrl)) {
          var $selectedDiv = $("."+modalUrl);
          $selectedDiv.show();
          $selectedDiv[0].id = "modal_window";
          $selectedDiv[0].name = "modal_window";
          $selectedDiv.appendTo(modalFrame);
      };

      modalFrame.css({
          width: (modalWidth || "700px"),
          height: (modalHeight || "70%")
      });

      if(classes && classes.length && classes.length > 0) {
          modalFrame.addClass(classes.join(' '));
      }

      $(document.body).append(modalFrame);

      /* Hack: For IE6 modal close-textbox issue */
      close.bind("click", function(){
          closePopup();
          return false;
      });
      close.bind("mouseover", function(){
          close.addClass("over");
      });
      close.bind("mouseout", function(){
          close.removeClass("over");
      });

      var lf = (($(document.body).width() - modalFrame.width()) / 2) + "px";
      modalFrame.css({left:lf});

      var frameHeight = modalHeight;
      var windowHeight = $(window).height();
      modalFrame.css({top: (windowHeight - frameHeight) * 100 / (2 * windowHeight) + "%"});

      if($.browser.msie) {
          translucentLayer.css({height: windowHeight + "px"});
      } else {
          translucentLayer.css({height : (document.body.offsetHeight>windowHeight)?document.body.offsetHeight + "px" : windowHeight + "px"});
      }
  },







  preventParentScroll: function () {
      // left: 37, up: 38, right: 39, down: 40,
      // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
      var noScrollKeys = [32, 33, 34, 35, 36, 37, 38, 39, 40];

      $(document).bind('DOMMouseScroll.meals_modal_window mousewheel.meals_modal_window', function (e) {
          e.preventDefault();
          return false;
      });
      $(document).bind('keydown.meals_modal_window', function (e) {
          if (noScrollKeys.indexOf(e.keyCode) != -1) {
              e.preventDefault();
              return false;
          }
      });
  },





  bindModalEvents: function (onEscClose, $modalDocument) {

      onEscClose = onEscClose || true;
      if (onEscClose) {
          keyUpHandler = function (e) {
              if (e.keyCode == 27 && onEscClose) {
                  window.top.CT.utils.hideModalDialog();
              }
          }

          $(document).bind('keyup.meals_modal_window', keyUpHandler);
          ($modalDocument ? $modalDocument : $($('#modal_window').get(0).contentWindow)).bind('keyup.meals_modal_window', keyUpHandler);
      }
  },











  /**
   * This function takes in a number ( hotel id ) converts it to string, and returns a stort-4 character string ( shortenID )
   * @params {string|number} hotel id.
   * @return {string} 4 character long shorten id
   */
  shortenID: function (id) {
      return $.trim(id.toString()).substring(0, 4);
  },


  /*
   * This function initiates the hotel booking.
   * This has been moved to utils as it is used in hotel info modal window
   */
  postHotelForm: function (hotelId, tripAdviseRating, bookingCode, roomTypeCode, toBook, dataItem) {
      var form = $("#FormFields").get(0);

      var frm_mapper = {
          'HChkIn': 'chk_in',
          'HChkOut': 'chk_out',
          'HDestCode': 'dest_code',
          'HState': 'state',
          'HCountry': 'country',
          'HAreaName': 'areaName',
          'HCity': 'city',
          'HNumRooms': 'num_rooms'
      };

      var searchParams = _.deserialize((window.location.search != '' ? window.location.search : window.location.hash).substr(1).replace(/\+/g, ' '), ['ca1', 'ca2', 'ca3', 'ca4']);
      var childrenCount = 0;
      var adultCount = 0;
      _.each(_.keys(searchParams), function (elem, idx) {
          melem = _.pascalCase("h_" + elem);
          if (typeof frm_mapper[melem] != 'undefined') {
              //TODO: quick fix added (typeof) remove it later - karthik
              $("#" + melem).val((typeof searchParams[frm_mapper[melem]] == 'string' ? searchParams[frm_mapper[melem]] : searchParams[frm_mapper[melem]][0]).replace(/\+/g, ' '));
          } else if (elem != 'from' && elem != 'hotelId' && elem != 'loc') {
              if (_.isArray(searchParams[elem])) {
                  _.each(searchParams[elem], function (eachElem) {
                      $('<input/>').attr({ type: 'hidden', id: _.capitalize(elem), name: elem, value: eachElem }).appendTo(form);
                  });
              } else {
                  $('<input/>').attr({ type: 'hidden', id: _.capitalize(elem), name: elem, value: searchParams[elem] }).appendTo(form);
              }

              if (elem.indexOf("children") != -1) {
                  childrenCount += Int(searchParams[elem]);
              }

              if (elem.indexOf("adult") != -1) {
                  adultCount += Int(searchParams[elem]);
              }
          }
      });

      form["num_children"].value = childrenCount;
      form["num_adults"].value = adultCount;
      form["star_rating"].value = tripAdviseRating;
      form["hotelid"].value = hotelId;
      form["bookingCode"].value = bookingCode;
      form["roomtypecode"].value = roomTypeCode;
      form["topLevelRateRules"].value = window.topLevelRateRules;
      if (CT.app == 'hotel' && window.product != 'B2B') {
          form.sct.value = window.countryCode.toUpperCase();
          form.scr.value = window.sell_currency.code.toUpperCase();
      }


      if (dataItem.emi) {
          form["emiJson"].value = dataItem.emi;
      }


      if (!$(form).hasClass("no-action-change")) {
          if (toBook) {
              var pHttps = window.pHttps;
              if (pHttps == undefined || pHttps == null)
                  pHttps = "https";
              if (window["productCode"]) {
                  form.action = pHttps + "://" + location.host + "/hotelBook";
              } else {
                  form.action = pHttps + "://" + location.host + "/hotels/multistep";
              }
          } else {
              form.action = "/hotels/info/" + hotelId;
          }
      }
      CT.utils.helperFunctions.trackGAEvent('Hotels_TR', 'H_Details_Book', CT.cache[CT.settings.currentTab].paramsForGA, '100');
      form.submit();
      return false;
  },




  /*
   * @DESC : update trust hotels with more room rates
   *          this is a common function among modal window and srp page
   * @PARAM : hotelObj - is an optional parameter
   */
  updateTrustHotelRoomRates: function (hotelId, hotelObj) {
      var searchParams, tmp = CT.cache[CT.settings.currentTab].searchParams;

      hotelObj = hotelObj || CT.masterJson.getHotel(hotelId);

      if (hotelObj.priceInfo && hotelObj.priceInfo.tc == 1 && hotelObj.priceInfo.rms && hotelObj.priceInfo.rms.length == 1) {
          searchParams = $.extend(true, tmp.all, tmp.defaults);
          url = CT.Mustache.to_html(CT.settings[CT.app].urls.trust, { pm: _.serialize(searchParams), hotelId: hotelId });
          url += '&tux=1';
          $.ajax({
              url: url,
              type: 'GET',
              success: function (respJson) {
                  //update hotelObj here
                  if (respJson.img)
                      hotelObj.img = respJson.img;

                  _.each(respJson.rms, function (rms) {
                      hotelObj.priceInfo.rms.push(rms);
                  });
              },
              error: function (respJson) {
                  L('trust ajax call failed');
              },
              async: false
          });
      }

      return hotelObj;
  },

  /**
   * This function calls from travellerInfoView.js, when doing dob validation.
   * --unchecks the the insurance check box.
   */
  unCheckInsuranceBox: function () {
      $('#insurance_box').attr('checked', false).trigger('click').attr('checked', false);
      $('.ageError').parents('dl.travellers').find('select').removeClass('ugly').end().end().html('');//removes the error message and ugly class for elems
      return true;
  },

  showActiveCurrMenu: function () {

      //default selection of country picker
      var $countryLi = $(".ctGlobalNav .countryMenu").find("i." + countryCode).closest("li");
      $countryLi.addClass("current").find("a").prepend("<i class='tickMark black'></i>");

      //default selection of currency picker
      var $currencyLi = $(".ctGlobalNav .currencyMenu").find("span." + CT.settings.countryCurrCode[countryCode].code).closest("li");
      $currencyLi.addClass("current").find("a").prepend("<i class='tickMark black'></i>");
      //To show currency based on utm_currency cookie if it is applicable in the menu bar
      if (CT.utils.utmCurrency.utmCheck()) {
          CT.utils.utmCurrency.utmCurrencyHeaderTabTickMark();
      }

      var $langLi = $(".ctGlobalNav").find(".languageMenu").find("li a");
      var $currentLang = $(".ctGlobalNav").find(".languageLink").attr("data-lang")
      var $langElem = _.filter($langLi, function (el) { return $(el).attr("data-lang") === $currentLang });
      $langLi.each(function (el) { $(el).removeClass("current").find(".tickMark").remove() })
      $langLi.removeClass("current").find(".tickMark").remove();
      $($langElem).addClass("current").prepend("<i class='tickMark black'></i>");

      CT.settings.countryCurrCode['current'] = CT.settings.countryCurrCode[countryCode].code//setting the selected currency picker value.


  },

  diffDates: function (t1, t2) {
      var one_day = 1000 * 60 * 60 * 24;
      var x = t1.split("/");
      var y = t2.split("/");
      var date1 = new Date(x[2], (x[1] - 1), x[0]);
      var date2 = new Date(y[2], (y[1] - 1), y[0])
      var month1 = x[1] - 1;
      var month2 = y[1] - 1;
      _Diff = Math.ceil((date2.getTime() - date1.getTime()) / (one_day));
      return _Diff;
  },

  timeTo12HrFormat: function (time) {
      var timeSuffix = 'a';
      if (time >= 12) { timeSuffix = 'p' }
      if (time > 12) { time = time - 12; }
      return time + timeSuffix;
  },

  getTodayDate: function () {
      var a = new Date()
      return a.getDate() + '/' + (a.getMonth() + 1) + '/' + a.getFullYear()
  },

  setCurrency: function (obj) {
      if (window.countryCode) {
          //code to check if utmCurrency is applicable
          window.utmCurrencyApplied = false;
          var isUtmApplicable = false;
          //obj.isUtmCurrencyEnabled==true when we are landing on the srp page
          if (obj && obj.isUtmCurrencyEnabled == true) {
              isUtmApplicable = CT.utils.utmCurrency.utmCheck1(obj);
              CT.utils.utmCurrency.utmFareConversion(obj);
          }
          else {
              isUtmApplicable = CT.utils.utmCurrency.utmCheck();
          }
          if (isUtmApplicable == true) {
              CT.utils.utmCurrency.utmCurrencyCookie(obj);
          }
          //set for one time
          var currency = CT.settings.countryCurrCode[countryCode].code;
          window.sell_currency = window.sell_currency || { "code": currency, "symbol": "" };

          var currencySymbol = obj && obj.symbol ? obj.symbol : CT.settings.dispCurrency[currency];
          window.disp_currency = { "code": CT.settings.countryCurrCode['current'] ? CT.settings.countryCurrCode['current'] : CT.settings.countryCurrCode[countryCode].code, "symbol": currencySymbol };
          //if utm currency is applicable setting the currency accordingly
          if (isUtmApplicable == true) {
              CT.utils.utmCurrency.setUtmCurrency();
          }
          this.resetCurrency();
      }
  },


  /**
   * This method resets the global selected currency value to INR, and erases all related cookies.
   * @param {Boolean} deleteCookie specifies if the currency-pref cookie should be deleted or not.
   */
  resetCurrency: function () {
      //Hack to set rupee symbol
      window.rupeeSymbol = $.parseHTML("&#8377;")[0].wholeText;
      if (window.disp_currency)
          CT.currentCurrency = (function () {
              var curr = null;
              if (window.currencies && window.currencies.all && window.sell_currency) {
                  //$A(window.currencies.all).each(function(_curr) {
                  _.forEach(window.currencies.all, function (_curr) {
                      if (_curr.code === window.disp_currency.code)
                          curr = _curr;
                  });
              } else {
                  curr = {};
                  curr.name = window.disp_currency.code;
                  curr.code = window.disp_currency.code;
                  curr.rate = 1;
                  curr.symbol = window.disp_currency.symbol;
                  if (window.disp_currency.ts && window.disp_currency.ds && window.disp_currency.gp) {
                      curr.ts = window.disp_currency.ts;
                      curr.ds = window.disp_currency.ds;
                      curr.gp = window.disp_currency.gp;
                  }
              }
              if (window.disp_currency.code === "INR") {
                  curr.symbol = window.rupeeSymbol;
              }
              return curr;
          })()

      if (CT.currentCurrency == null || CT.currentCurrency == undefined)
          CT.currentCurrency = {
              name: "Indian Rupees",
              code: "INR",
              rate: 1,
              symbol: window.rupeeSymbol,
              ts: ",",
              ds: ".",
              gp: "3,2"
          };

  },




  loadTrackers: function (pageType , loadOnlyCommon) {
      function appendTrackers(trackObj) {
          _.each(trackObj, function (func, index) {
              /*if(typeof(func) === 'object'){
                  _.each(func,function (func1,index1){
                      func1()
                  })
              }else
              func()*/

              func();
          })
      }

      function getPageTrackerScript() {
          var baseLink = window.staticBaseDomain || window.staticBaseLink || window.hotelBaseLink || window.airBaseLink || "//fastui.cltpstatic.com/raw/upload/resources";
          var trackerJsName = "";
          if (CT.app === 'air') {
              trackerJsName = 'airTrackers';
          } else if (CT.app === 'dp') {
              trackerJsName = "dpTrackers";
          } else {
              trackerJsName = 'hotelTrackers';
          }
          pageName = CT.app === 'air' ? pageName : 'home';//pageName is global variable
          // if(pageType=="details")
          //     appendTrackers(CT.commonTrackers.details);
          // else
          // {
          CT.getScript({ src: baseLink + '/javascripts/trackers/' + window.countryCode + '/' + trackerJsName + ((window.airTrackers_js_ver && window.airTrackers_js_ver[window.countryCode]) || (window.hotelTrackers_js_ver && window.hotelTrackers_js_ver[window.countryCode]) || window.dpTrackers_js_ver || '') + '.js' }, function () {
              if (pageType === 'results')
                  appendTrackers(CT.trackers.results)
              else
                  appendTrackers(CT.trackers[pageName])
          });
          // }
      }
      try {
          //if(window.countryCode && window.countryCode == "in"){
          var baseLink = window.staticBaseLink || window.hotelBaseLink || window.airBaseLink || "//fastui.cltpstatic.com/raw/upload/resources";
          if (!CT.commonTrackers) {
              var commonTrackerJsName = "";
              if (CT.app === 'air') {
                  commonTrackerJsName = 'commonAirTrackers';
              } else if (CT.app === 'dp') {
                  commonTrackerJsName = 'commonDpTrackers';
              } else {
                  commonTrackerJsName = 'commonHotelTrackers';
              }
              CT.getScript({ src: baseLink + '/javascripts/trackers/common/' + commonTrackerJsName + (window.commonAirTrackers_js_ver || window.commonHotelTrackers_js_ver || '') + '.js' }, function () {
                 if(!loadOnlyCommon){
                      getPageTrackerScript();
                  }
              });
          } else {
              if(!loadOnlyCommon){
                  getPageTrackerScript();
              }
          }
          CT.utils.helperFunctions.loadHeapTracking();
          //}
      } catch (e) {

      }
  },





  /**
   * This function takes in a number (or a number like string), and returns a string formatted for display as a currency amount.
   * @param {String|Number} amount The number that should be formatted as currency.
   * @param {Boolean} [showDecimals] Should the number show decimal places? Default = false
   * @param {Boolean} [json] return json object Default = false
   * @return {String} The string, formatted for currency.
   * @example: CT.stringFormatting.formatForCurrency(12345) returns "Rs. 12,345"
   * @see CT.stringFormatting.stripAlphaChars
   * @memberOf CT.stringFormatting
   */
  formatForCurrency: function (amount, showDecimals, hideSymbol, json, options) {
      options = options || {};
      var price = "", num, dec, currency_symbol = window.rupeeSymbol, currency_rate = 1, selling_rate = 1, orgPr = amount, format_options = {
          ds: ".",
          ts: ",",
          gp: [3, 2]
      };
      /*options.showPrecision = true;
      options.numberOfDecimalsFlights = 2;*/
      var currencyCls = '';
      function assignValues() {
          if (window.utmCurrencyApplied) {
              selling_rate = CT.utils.utmCurrency.setCurrencyItn(selling_rate);
          }
          if (CT.currentCurrency.symbol)
              currency_symbol = CT.currentCurrency.symbol;

          if (CT.currentCurrency.ds)
              format_options.ds = CT.currentCurrency.ds

          if (CT.currentCurrency.ts)
              format_options.ts = CT.currentCurrency.ts

          if (CT.currentCurrency.gp)
              format_options.gp = $(CT.currentCurrency.gp.split(",")).each(function (idx, _gp) {
                  _gp = parseInt(_gp, 10);
              });

          if (CT.currentCurrency.rate)
              currency_rate = CT.currentCurrency.rate

          if (window.sell_currency && window.currencies && window.currencies.all) {
              _.forEach(window.currencies.all, function (curr) {
                  if (curr.code === window.sell_currency.code)
                      selling_rate = curr.rate;
              });
          }
      }

      assignValues();

      if (selling_rate) { CT.currentCurrency.selling_rate = selling_rate }
      if (selling_rate != currency_rate)
          amount = (amount * selling_rate) / currency_rate;
      if (options.adjustDisplayPrice) {
          amount = amount + options.adjustDisplayPrice;
      }

      if (showDecimals) {
          num = parseFloat(amount);
          num = parseInt(amount * 100, 10) / 100 + "";
          dec = num.split(".").length > 1 ? num.split(".")[1] : "";
          num = num.split(".")[0];
          while (dec.length < 2) {
              dec += "0";
          }

          orgPr = parseFloat(orgPr);
      }
      else if (window.numberOfDecimalsFlights > 0) {
          // num = parseInt(amount*Math.pow(10,window.numberOfDecimalsFlights) , 10)/ Math.pow(10,window.numberOfDecimalsFlights) + '';
          // dec = num.split(".").length > 1 ? num.split(".")[1] : "";
          // num = num.split('.')[0];
          var strNum = ('' + amount).split('.');
          dec = strNum[1] && strNum[1].substr(0, window.numberOfDecimalsFlights) || "";
          num = strNum[0];
          while (dec.length < window.numberOfDecimalsFlights) {
              dec += "0";
          }
          orgPr = parseFloat(orgPr);
      }
      else {
          num = parseInt(Math.round(amount), 10) + "";
          orgPr = parseInt(Math.round(orgPr), 10) + "";
      }

      if (num.length > format_options.gp[0]) {
          price = num.substring(num.length - format_options.gp[0], num.length);
          num = num.substring(0, num.length - format_options.gp[0]);
          while (num.length > format_options.gp[format_options.gp.length - 1]) {
              price = num.substring(num.length - format_options.gp[format_options.gp.length - 1], num.length) + format_options.ts + price;
              num = num.substring(0, num.length - format_options.gp[format_options.gp.length - 1]);
          }
          num += format_options.ts + price;
      }

      if (showDecimals || window.numberOfDecimalsFlights > 0) {
          num += format_options.ds + dec;
      }

      currency_symbol = unescape(currency_symbol.replace('\\', '%'))
      if (json) {
          return {
              symbol: currency_symbol,
              fmtPrice: num,
              intPrice: orgPr,
              symCode: window.disp_currency.code,
              display: currency_symbol + num
          };
      } else {
          if (!_.contains(CT.settings.singleCurrencySymbol, window.disp_currency.code)) {
              currencyCls = ' currencyCode';
          }
          var symbolStr = "<span class='" + (window.disp_currency.code || "INR") + currencyCls + "'  data-pr='" + orgPr + "'>" + currency_symbol + "</span>";
          if (CT.app === "hotel" || CT.app === "shortlist") {
              return ((hideSymbol) ? "" : (currency_symbol + " ")) + (options && options.prWrap ? '<span class="' + options.prWrapClass.join(' ') + '" ' + _.map(options.attr, function (attr) { return attr.name + '="' + attr.value + '"' }).join(' ') + '>' + num + '</span>' : num);
          } else {
              return ((hideSymbol) ? "" : (symbolStr + "")) + (options && options.prWrap ? '<span class="' + options.prWrapClass.join(' ') + '" ' + _.map(options.attr, function (attr) { return attr.name + '="' + attr.value + '"' }).join(' ') + '>' + num + '</span>' : num);
          }

      }
  },


  // This is used in _.deserialize method - see below
  hashModifiers: {
      ca: function (key, val) {
          var arr;
          val = decodeURIComponent(val.replace(/\+/g, ' '))
          if (typeof this[key] === "undefined") arr = []
          else arr = this[key]
          arr.push(val)
          return [key, arr]
      }
  },

  // This is used in _.deserialize method - see below
  duplicateKeyToArray: function (key, val) {
      var arr;
      if (val)
          val = decodeURIComponent(val.replace(/\+/g, ' '))
      if (typeof this[key] === "undefined") arr = []
      else arr = this[key]
      arr.push(val)
      return [key, arr]
  },









  durToMins: function (t) {
      if (t.indexOf('h') >= 0 && t.indexOf('m') >= 0) {
          var s = t.split(' ');
          var hr = parseInt(s[0], 10);
          var mn = parseInt(s[1], 10);

          return (hr * 60) + mn;
      } else if (t.indexOf('h') >= 0) {
          return (parseInt(t, 10) * 60);
      } else if (t.indexOf('m') >= 0) {
          return parseInt(t, 10);
      }
  },



  /**
   * creates the currency drop down mustache template json
   * @dispObj eg: var dispObj = {DISPCURRENCY:[]};
   */
  createCurrencyConverterSelectBox: function (dispObj) {
      _.forEach(currencies.top, function (val) {
          dispObj.DISPCURRENCY.push({ "optVal": val.code, "title": val.name, "value": val.code + ' ' + val.symbol + ' - ' + val.name });
      });
      dispObj.DISPCURRENCY.push({ "optVal": "", "title": "", "value": "----------" });
      _.forEach(currencies.all, function (val) {
          dispObj.DISPCURRENCY.push({ "optVal": val.code, "title": val.name, "value": val.code + '-' + val.name });
      });

      return dispObj;
  },



  //app is used to differentiate between tuxedo and old format
  showLoader: function (msgType, app, context) {
      if (!app) {
          if (CT.utils.hideModalDialog) {
              CT.utils.hideModalDialog();
          }
      }


      if (typeof msgType === 'undefined') return false;

      var overlayTpl = $("#OverlayTpl").html();
      var $spinnerDiv, $overlayDiv
      var h, w

      $overlayDiv = !app ? $("#Overlay") : $(".updatingModal").first().clone();
      $overlayDiv.html(overlayTpl);
      $overlayDiv.css("position", "absolute");

      if (!app) {
          $spinnerDiv = $overlayDiv.find("#spinner");
      } else {
          $spinnerDiv = $overlayDiv.find(".spinner");
      }
      $spinnerDiv.append("<strong>Just a moment</strong><small>" + (!app ? CT.settings[CT.app].updatingMsgs[msgType].msg : CT.messages[CT.app][msgType]) + "</small>")

      h = $(context || window).height()
      w = $(context || document).width();

      $overlayDiv[context ? 'appendTo' : 'show'](context).show();
      if (!app) {
          $spinnerDiv.css({ left: w / 2 - $spinnerDiv.width() / 2, top: h / 2 - $spinnerDiv.height() / 2 });
      } else {

          $spinnerDiv.css({ position: 'absolute', left: w / 2 - $spinnerDiv.width() / 2, top: h / 2 - $spinnerDiv.height() / 2 });
      }
      if (!app) {
          setTimeout(function () {
              $overlayDiv.hide();
          }, 2000);
      }

  }

  /**storeFlightValuesForVizury : function(page, product) {
      var encryptedKey = CT.utils.cookies.read('ct_ct');
      var ctTrackUrl = window.location.protocol+"//"+window.location.host + "/common/crypt?s="+encryptedKey;
      $.ajax({
          url: ctTrackUrl,
          type: 'GET',
          success: function (data) {
              CT.air_dropoff = '';
              CT.hotel_dropoff = '';
              CT.air_searchcount = '';
              CT.hotel_searchcount = '';
              CT.air_bookcount ='';
              CT.hotel_bookcount ='';
              CT.air_lastsearchdate ='';
              CT.hotel_lastsearchdate ='';
              CT.air_lastbookdate ='';
              CT.hotel_lastbookdate '';
          },
          error: function(){
          }
      });
},*/


});


/* ========================= exposing Mustache through CT.Mustache and Mutastache dependant util functions =========================== */
!function (module) {
  if (typeof window.define !== "undefined") define('ct_utils',['vendor/mustache'], module)
  else if (window.Mustache) module(Mustache);
  else module(null);
}(function (Mustache) {
  CT.Mustache = Mustache;
  /**
   * utils to generate generic blocks
   */
  CT.utils.genericBlocks = {
      /**
       * Generates MyAccount Links in header
       */
      createUserAccountNav: function ($node) {
          var tmpl, data, $AccountMenu, $AccountLink;
          $node = $node || $('#userAccountNav');

          function openUserMenu(evt) {

              function frequentFlyerProfileSuccess(data) {
                  try {
                      if (typeof data == "string") {
                          data = JSON.parse(data);
                      }
                      $patronProfileNode[0].frequentFlyerProfile = data;

                      if (data.isFF) {
                          var enrolledDateObj = moment(data.enrolledDate, "DD/MM/YYYY");
                          var enrolledDateDisplay = enrolledDateObj.format("MMM YYYY");
                          //$patronProfileNode.find(".patron-widget--icons").show();
                          //$patronProfileNode.find(".patronProfileInfo .patronName h2").css("width","140px")
                          
                          $patronProfileNode.find(".patron-widget--icons").show();
                          $patronProfileNode.find('.patronImage').css('display','block')
                          $patronProfileNode.find(".patronProfileInfo .patronName h2").css("width", "140px")
                          $patronProfileNode.find(".ffEnrolledDate").html("One member since " + enrolledDateDisplay).show();
                          
                          if (data.totalPoints > 0) {
                              $($patronProfileNode.find(".patronPoints").show().find("p")[1]).html(data.totalPoints)
                          } else {
                              $patronProfileNode.find(".patronPoints").hide();
                          }
                          $patronProfileNode.show();
                      }
                  } catch (e) { }
              }

              function WPUserProfileSuccess(data, statusText, fullResponse){
                  try{
                      if(fullResponse && fullResponse.status == 204){
                          checkFrequentFlyerProfile();
                          return;
                      }
                      function appendWPLogo(){
                          $CTOneLogo = $patronProfileNode.find('.patronImage')
                          $CTOneLogo.addClass('hide')
                          $patronProfileNode.find('.patronName').append('<span class="WPLogo pt5"><img src="/images/work_plus/bizliteWorkPlus.svg" height="12"></span>')
                      }
                      if(data && (window.WPValidStatus || ['TRIAL', 'TRIAL_NCB', 'VERIFIED', 'UNVERIFIED']).indexOf(data) > -1){
                          var userId = unescape(CT.utils.cookies.read('userid'));
                          var emailId = userId.split('|')[0]
                          var $WPLogo = $patronProfileNode.find('.WPLogo')
                          $WPLogo.length ? $WPLogo.removeClass('hide') : appendWPLogo()
                          $patronProfileNode[0].frequentFlyerProfile = emailId
                      }
                  }catch(e){
                      L(e)
                  }
              }

              var $patronProfileNode = $AccountMenu.find(".patronProfile").first();
              $AccountMenu.toggle();
              $AccountLink[(($AccountMenu.get(0).style.display != "none") ? "add" : "remove") + "Class"]("current");

              if($patronProfileNode[0]){
                  $patronProfileNode.find('.patronImage').css('display','none')
                  var userId = unescape(CT.utils.cookies.read('userid'));
                  $.ajax({
                      url: (window.getWPStatus || '/workplus/user/state?userId=')+userId.split('|').reverse()[0],
                      method: "GET",
                      success: WPUserProfileSuccess,
                      error: function () { 
                          checkFrequentFlyerProfile()
                      }
                  });
              }

              function checkFrequentFlyerProfile(){
                  if ($patronProfileNode[0] && !$patronProfileNode[0].frequentFlyerProfile) {
                      $patronProfileNode.hide();
                      $.ajax({
                          url: "/freqFlyerService/v1/profile",
                          //url:"/testpage/account/response/frequent_flyer",
                          method: "GET",
                          success: frequentFlyerProfileSuccess,
                          error: function () { }
                      });
                  }
              }
          }


          try {
              if ($node[0]) {
                  if (window.isHandlebars) {
                      tmpl = App.templateAdapter.getTemplate('common/userAccountNav');
                  } else {
                      tmpl = $('#userAccountNavTmpl');
                  }
                  data = {};

                  CT.settings = CT.settings || {};
                  CT.settings.ctAuthCookieName = CT.settings.ctAuthCookieName || (/dp\.cleartirp\.com|vegas\.cleartrip\.com/.test(window.location.hostname) ? "dev-usermisc" : "usermisc");
                  if (CT.utils.cookies.read(CT.settings.ctAuthCookieName) && unescape(CT.utils.cookies.read(CT.settings.ctAuthCookieName)).split("|")[0] == "SIGNED_IN") {
                      data.isSignedIn = true;
                      data.info = unescape(CT.utils.cookies.read("userid")).split("|");
                      data.screen_name = unescape(CT.utils.cookies.read("userid") || "Your account").split("|");
                      data.screen_name = data.screen_name[1] || data.screen_name[0];
                      if (data.info[2]) {
                          if ((data.info[2] == "M")) {
                              data.gender = "man_24";
                              data.genderOnly = "man";
                          } else {
                              data.gender = "woman_24";
                              data.genderOnly = "woman";
                          }
                      }
                      if (data.info[3])
                          data.profileLink = data.info[3];
                      if (CT.utils.cookies.read('ct_rt') == "E")
                          data.elite = true;

                  } else if (CT.utils.cookies.read("unconfirmed-email")) {
                      data.isUnConfirmed = true;
                      data.user_id = unescape(CT.utils.cookies.read("unconfirmed-email"))
                      data.isSignedIn = true;
                      data.screen_name = "Guest" + (CT.utils.cookies.read("unconfirmed-email")) ? (" (" + unescape(CT.utils.cookies.read("unconfirmed-email")) + ")") : "";
                  } else {
                      data.isUnSignedIn = true;
                  }
                  if (window.countryCode == "in")
                      data.india = true;
                  data.show_currency_converter = window.load_currency_converter || false;


                  if (window.enableTranslation) {
                      //data.showLang = (window.countryCode == "qa" || window.countryCode == "sa" || window.countryCode == "ae" );
                      data.showLang = (window.countryCode == "ae" || window.countryCode == "sa" || window.countryCode == "kw");
                  } else {
                      data.showLang = false;
                  }
                  data.isShortlistEnabled = true; // Make shortlist in menu by default true - Mahipat
                  if (tmpl.length > 0) {
                      if (window.isHandlebars) {
                          $node.html(tmpl(data));
                      } else {
                          $node.html(CT.Mustache.to_html(tmpl.html(), data));
                      }
                  }
                  $.userNavReady = true;
                  CT.utils.helperFunctions.forceHttpsLinks($node);

                  //if(CT.app != 'dp' && CT.app != null) { //this flow should work only for tuxedo pages.
                  //added here because userAccountNav dropdown was not working in smallworld. Because CT.app somehow was getting set into 'undefined'.
                  CT.app = CT.app || "global";
                  if (CT.app != null) {
                      $AccountMenu = $node.find("#userAccountMenu");
                      $AccountLink = $node.find("#userAccountLink");

                      if ($AccountLink[0]) { //TODO: make sure that the events are bind only onces.
                          $AccountLink.on("click", openUserMenu);
                      }

                      $("#global_signout").on("click", function (e) {
                          e.preventDefault();
                          var usersid = decodeURIComponent(CT.utils.cookies.read('userid')).split('|')[4];
                          if (window._gaq) {
                              _gaq.push(['_trackEvent', 'account_users', 'signout', usersid]);
                          }
                          if (window.Moengage && Moengage.destroy_session) { Moengage.destroy_session(); };
                          if (window.cleverTapEnabled && CT.utils.helperFunctions.tpTrack) { CT.utils.helperFunctions.tpTrack({ 'tp': 'clevertap', 'logout': true }) }
                          if (CT.utils.cookies.read('fb')) {
                              FB.getLoginStatus(function (response) {
                                  if (response.status == "connected") {
                                      FB.logout(function (response) {
                                          window.location.href = "/signout";
                                      });
                                  }
                                  else
                                      window.location.href = "/signout";
                              });
                          }
                          else
                              window.location.href = "/signout";

                      })
                  }

                  // this will execute the functions which are required
                  // to be executed after userNav is created.
                  if (CT.userAccountNavOnReady) { // Call back
                      _.each(CT.userAccountNavOnReady, function (cb) {
                          cb();
                      }, {});
                  }

              }
          } catch (e) { }
      },

      displayLanguagePrefBanner: function () {

          //$(document.body).prepend('<div id="languagePrefBanner" class="floatingMessageContainer animated bounceInDown" ><div class="floatingMessage" style="width:510px"><div class="info relative clearFix"><a class="fRight icon close" style="display:none;"></a><h3 class="icon32 info">Language</h3><p style="font-size:17px;padding-left:3.75em">Want to see the Arabic site?</p></div><div class="actionBar"><p><input type="button" class="default button" value="English is fine" id="english_site_pref">&nbsp;&nbsp;<input type="button" class="default primary" value="Take me to Arabic site" id="arabic_site_pref"></p></div></div></div>');
          $(document.body).prepend('<div id="languagePrefBanner" class="floatingMessageContainer animated bounceInDown" ><div class="floatingMessage" style="width:510px"><div class="info relative clearFix"><a class="fRight icon close" style="display:none;"></a><h3 class="" style="text-align:center;font-size:2.0em">Choose your language &nbsp;&nbsp;<span style="font-size: 1.4em;vertical-align: text-top;">&#1575;&#1582;&#1578;&#1585; &#1604;&#1594;&#1578;&#1603;&lrm;</span></h3><p style="font-size:17px;padding-left:3.75em"></p></div><div class="actionBar"><p style="text-align:center;padding:0px;"><input type="button" class="default button" value="English" id="english_site_pref">&nbsp;&nbsp;<input type="button" class="default button" value="&#1575;&#1604;&#1593;&#1585;&#1576;&#1610;&#1577;" id="arabic_site_pref"></p></div></div></div>');
          $("#languagePrefBanner").center().addClass("animated bounceInDown");
          var windowHeight = $(window).height();
          var translucentLayer = $("<div/>", {
              "id": "TranslucentLayer",
              "style": "background-color:transparent"
          });
          if ($.browser.msie) {
              translucentLayer.css({
                  height: windowHeight + "px"
              });
          } else {
              translucentLayer.css({
                  height: (document.body.offsetHeight > windowHeight) ? document.body.offsetHeight + "px" : windowHeight + "px"
              });
          }

          $(document.body).append(translucentLayer);

          $("#arabic_site_pref").click(function () {
              CT.utils.cookies.create("lp", "ar", 365);
              window.location.href = "/ar/";
          });
          $("#english_site_pref").click(function () {
              CT.utils.cookies.create("lp", "en", 365);
              $("#languagePrefBanner").hide();
              $("#TranslucentLayer").remove();
          });


      },

      displayNonArabicBanner: function () {
          if (window.CT.langUrlPrefix && window.CT.langUrlPrefix.indexOf("ar") != -1) {
              $("a").on("click", function (ev) {
                  // get href
                  if (ev.currentTarget.href
                      && ev.currentTarget.href != "javascript:void(0)"
                      && ev.currentTarget.href != "javascript:void(0);"
                      && ev.currentTarget.href != "#") {

                      var href = ev.currentTarget.href;

                      if (href.indexOf("/ar/") != href.length - 4
                          && href.indexOf("/flights") == -1
                          && href.indexOf("/account") == -1
                          && href.indexOf("/ticket") == -1
                          && href.indexOf("/faq") == -1
                          && href.indexOf("/support") == -1
                          && href.indexOf("/flight-schedule/") == -1
                          && href.indexOf("/flight-tickets/") == -1
                          && href.indexOf("/flight-booking/") == -1) {

                          var alteredHref = href;
                          //alteredHref = alteredHref.replace("/ar/","/");

                          ev.preventDefault();
                          ev.stopPropagation();
                          $(document.body).prepend('<div id="nonArabicPageBanner" class="floatingMessageContainer animated bounceInDown" ><div class="floatingMessage" style="width:510px"><div class="info relative clearFix"><a class="fRight icon close" style="display:none;"></a><h3 class="icon32 info">Going to the English site</h3><p style="font-size:17px;padding-left:3.75em">Arabic is coming soon ...</p></div><div class="actionBar"><p><input type="button" class="default primary" value="Proceed to English site" id="nonArabicPageBannerProceed"></p></div></div></div>');

                          $("#nonArabicPageBanner").center().addClass("animated bounceInDown");
                          $("#nonArabicPageBannerProceed").click(function () {
                              $("#nonArabicPageBanner").hide();
                              window.location.href = alteredHref;
                          })
                          setTimeout(function () {
                              $("#nonArabicPageBanner").hide();
                              window.location.href = alteredHref;
                          }, 3000);
                      }

                  }


              })
          }
      },
      displayLanguagePrefToolTip: function () {
          if (window.isHomePage && window.CT.countryCode == 'sa') {

          } else {
              return;
          }
          var showToolTip = function () {
              setTimeout(function () {
                  $(".currencyMenuContainer, .countryMenuContainer, .userAccountMenuContainer").css('opacity', '.3');
                  var languageClass = (window.CT.langUrlPrefix) ? window.CT.langUrlPrefix.substring(1) : "en";
                  $("#langDropDownToolTip .tipsyInner." + languageClass).show();
                  $("#langDropDownToolTip").fadeToggle();

                  $(".languageMenuContainer").addClass("highlight")
                  $(".languageMenuContainer .languageLink").css("font-weight", "bold");
                  setTimeout(function () {
                      $(".currencyMenuContainer, .countryMenuContainer, .userAccountMenuContainer").css('opacity', '1');

                  }, 4000);
              }, 2000)
          }



          var lpToolTipCount = parseInt(CT.utils.cookies.read("lp_ttc"));

          if (lpToolTipCount) {
              if (lpToolTipCount <= 5) {
                  CT.utils.cookies.create("lp_ttc", lpToolTipCount + 1);
                  showToolTip();
              }
          } else {
              CT.utils.cookies.create("lp_ttc", 1)
              showToolTip();
          }
      },
      hideLanguagePrefToolTip: function () {
          //Hide Lang Dropdown Tooltip
          if ($("#langDropDownToolTip")[0]) {
              $("#langDropDownToolTip").hide();
              $(".languageMenuContainer").removeClass("highlight");
              $(".languageMenuContainer .languageLink").css("font-weight", "normal");
          }
      }
  };


  $.extend((CT.utils.helperFunctions) || (CT.utils.helperFunctions = {}), {
      /**
       * This converts a overflow  horizontal div to a scrollable div with next and prev scroll bars.
       *
       */
      createSlideView: function ($node /*legsContainer*/, columnWidth, columnsPerPage, totalColumns, $linksContainer) {

          var navLinkTmp = '<div class="disclosureFade {{divCls}}" style="display:none;"><a class="{{linkCls}}" href="javascript:void(0);"></a></div>'
          var $links = { prev: {}, next: {} };
          var shiftValue = totalColumns - columnsPerPage;
          var slideOffset = (totalColumns == 4) ? 50 : 285;
          $linksContainer = ($linksContainer || $node);

          function createNavLinks() {
              _.each([{ "linkCls": "scrollLeft", "divCls": "left", "name": "prev" },
              { "linkCls": "scrollRight", "divCls": "right", "name": "next" }], function (linkData) {
                  $linksContainer.append($links[linkData.name] = $(CT.Mustache.to_html(navLinkTmp, linkData)));
              });
          }


          function slide(direction, amount) {
              var existingLeftValue = parseInt($node.css("left").replace("px", ""), 10);
              if (direction == "left") {
                  amount = -(columnWidth * amount) + slideOffset;
              } else {
                  amount = (columnWidth * amount) - slideOffset;
              }
              amount = existingLeftValue + amount;
              $node.css("left", (amount + "px"));
          }

          function init() {
              createNavLinks();
              $links.next.show();
              $node.css("left", "0px");
              $links.next.on('click', function () {
                  slide("left", shiftValue);
                  $links.next.hide();
                  $links.prev.show();
              });
              $links.prev.on('click', function () {
                  slide("right", shiftValue);
                  $links.next.show();
                  $links.prev.hide();
              });

          }


          init();

      }
  });





  $(document).ready(function () {
      try {
          //language base url prefixing done here.
          $(document).ajaxSend(function (xhr) {
              var _args = arguments;
              function prefixLanguage() {
                  var tempAnchorNode = document.createElement("a");
                  tempAnchorNode.href = _args[2].url;
                  var _url = tempAnchorNode;
                  if(!_args[2].dontConvertUrl)
                  {
                      if (_url.pathname.indexOf("/ar/") != 0) {
                          //the additiona slash is for IE 11 as pathname doesnt start with the slash
                          _url.pathname = "/ar" + _url.pathname;
                      }
                      _args[2].url = _url.pathname + _url.search;
                      window.console && console.log("Altered URL >>", _args[2].url);
                  }
              }

              if (window.CT.langUrlPrefix && window.CT.langUrlPrefix.indexOf("ar") != -1) {
                  prefixLanguage();
              }

          });

          try {
              if ((window.isMobileUA || window.isMobileRequest) && window.location.pathname.indexOf("hotels") > 0 && CT.utils.merchandisingBanner && typeof (CT.utils.merchandisingBanner.create) == "function") {
                  if (window.enableAppBannerAutomationMob && window.appDownloadBannerJson && $("#merchandisingAppBanner")) {
                      CT.utils.merchandisingBanner.create(window.appDownloadBannerJson, $("#merchandisingAppBanner"), "appUpsell");
                  }
                  // Commenting below line of code as this banner not required on itinerary page - ASC-308 - Mahipat.
                  // if(window.enableOfferAutomationMob && window.hotelOfferJson && $("#itineraryOfferBanner")){
                  //     CT.utils.merchandisingBanner.create(window.hotelOfferJson, $("#itineraryOfferBanner"), "offer");
                  // }
              }
          } catch (e) { }

          // temp code to remove the old ct-auth cookie , whne the user is in home page.
          try {


              if (window.location.pathname == "/") {
                  if (window.productCode === 'CP' || window.productCode === 'AG') {

                  } else {
                      if (CT.utils.cookies.read("ct-auth") && !CT.utils.cookies.read("usermisc")) {
                          CT.utils.cookies.erase("ct-auth", ("." + window.location.host.split(".").splice(1, 2).join(".")));
                          CT.utils.cookies.erase("userid", ("." + window.location.host.split(".").splice(1, 2).join(".")));
                          CT.utils.cookies.erase("ct-auth", window.location.host);
                          CT.utils.cookies.erase("userid", window.location.host);
                      }
                  }

              }
          } catch (e) { }

          /*if(window.isInternalUser){*/
          //CT.utils.abTest();
          /*}*/

          if (CT.app && (CT.app === "hotel" || CT.app === "air" || CT.app === "dp" || CT.app === "bus")) {
              var isIpad = navigator.userAgent.match(/iPad/i) != null;
              if (isIpad == true && $(".tempFilter").css('visibility') == 'hidden') {
                  $(".tempFilter").css('visibility', 'visible');
              }
          }
          CT.utils.genericBlocks.createUserAccountNav();





          if (CT.app && (CT.app === "hotel" || CT.app === "air" || CT.app === "dp" || CT.app === "shortlist")) { // to be executed only if the page is Air or Hotel SRP.
              if ($('.ctGlobalNav')[0]) {
                  var currSymbol = CT.settings.countryCurrCode[countryCode].symbol;
                  var currCode = CT.settings.countryCurrCode[countryCode].code;
                  var currSybStr = "";
                  if (currCode !== currSymbol) {
                      currSybStr = "<span class='" + currCode + "'>&nbsp;" + currSymbol + "</span>";
                  }
                  $('.ctGlobalNav .currencyLink').html("<strong>Currency</strong>&nbsp;&nbsp;" + currCode + "" + currSybStr);//setting the currency picker value in footer
                  //To show currency based on utm_currency cookie if it is applicable in the currency header tab
                  if (CT.utils.utmCurrency.utmCheck()) {
                      CT.utils.utmCurrency.utmCurrencyHeaderTab(currSybStr);
                  }
                  $('.ctGlobalNav .countryLink .flagIcon').text(CT.settings.countryCurrCode[countryCode].name).addClass(countryCode);//setting the country picker value in footer.
              }
          }

          //in cleartrip.sa's home-page; if language pref cookie(lp) is not present display language switcher popup.
          if ((window.CT.countryCode == "sa" || window.CT.countryCode == "kw")
              && !CT.utils.cookies.read("lp")
              && window.location.pathname == "/"
              && window.location.search == "") {
              CT.utils.genericBlocks.displayLanguagePrefBanner();
          }

          CT.utils.helperFunctions.forceLanguagePrefix();
          CT.utils.genericBlocks.displayNonArabicBanner();
          CT.utils.helperFunctions.storeUserReferer();
          CT.utils.helperFunctions.storePaidChannelSource();

      } catch (e) {
          window.ct_debug && L(e);
      }

      CT.utils.helperFunctions.setUtmParametersInSessionStorage();


      try{
          if(window.top == window
              && CT.utils.helperFunctions.isB2CFlow()
              && window.location.search.length > 0){

              var urlHash = _.deserialize(window.location.search.substring(1))
              CT.utils.helperFunctions.paidChannelTracker(urlHash);
              CT.utils.helperFunctions.paidAffiliateTracker(urlHash);
          }
      }catch(e){

      }

  });


});











/* ========================= Utils in jQuery prototype ($.fn) namespace =========================== */
jQuery.fn.extend(jQuery.fn, {

  // Returns itself 'duh!
  identity: function () {
      return this
  },


  /**
   * @desc callback to run after images finish loading
   * @usage $('img').setLoad(function(){ //do something to process image })
   * @usage To center image: $('img').setLoad(CT.utils.imgAdjust)
   * @return jQuery object
   */
  setLoad: function (callback) {
      function _set() {
          //$(this).closest('.spinner_medium').removeClass("spinner-medium").end().parent().css("visibility", "visible").end().fadeIn('slow');
          $(this).closest('.loader').removeClass("loader").end().parent().css("visibility", "visible").end().fadeIn('slow');
      }

      callback = callback || _set;
      return this.each(function () {
          if (this.complete || this.readyState === 4) callback.call(this);
          else $(this).load(callback)
      })
  },

  /*
   * @usage $('.parentDiv').showLoader('Updating...', 'tuxedo')
   */
  showLoader: function (msgType, app) {
      return this.each(function () {
          CT.utils.showLoader(msgType, app, this)
      })
  },

  hideLoader: function () {
      var $modals = this.find('.updatingModal')
      $modals.length === 1 ? $modals.css('display', 'none') : $modals.last().remove()
      $('#Overlay').hide()
      return this
  },

  center: function () {
      this.css("position", "absolute");
      this.css("top", (($(window).height() - this.outerHeight()) / 2) +
          $(window).scrollTop() + "px");
      this.css("left", (($(window).width() - this.outerWidth()) / 2) +
          $(window).scrollLeft() + "px");
      return this;
  }

})

/**
* @desc Swaps the day and month values so that it can be read by the native Date method i.e convert dd/mm/yyyy to mm/dd/yyyy
*/
CT.utils.tweakDate = CT.utils.swapDayMonth;












/*=========================== Onload function triggers for any util fuctions or common code ================================*/
$(window).load(function () {
  try {
      $.isLoaded = true;
      var testuiBuildSh = true;
      var baseLink = window.staticBaseDomain || window.staticBaseLink || window.hotelBaseLink || window.airBaseLink || "//fastui.cltpstatic.com/raw/upload/resources";
      if ($.inArray(CT.app, ["hotel", "air", "dp", "bus", "collections", "local"]) != -1) {
          if (CT.app !== "collections") {
              if ((CT.app != "air") || (CT.app == "air" && window.countryCode == "sa")) {
                  //CT.utils.helperFunctions.includeGAjs();
                  $.getScript(baseLink + "/javascripts/libs/oldga.js", function () {
                      CTGA.includeGAjs();
                  });
              }
          }

          CT.utils.helperFunctions.includeComScoreTracking();
      }
      /*if(window.isHomePage && window.CT.countryCode != "sa"){
          CT.utils.helperFunctions.setUserHomeCity();
      }*/
      if (window.isMobileRequest) {
          CT.utils.helperFunctions.inspectLetJsForBranchIo();
      }
      if (false && CT.app === "hotel") {
          //CT.utils.helperFunctions.includeGATagManager();
          //This is used to create cookie from backend for funnel
          if (window.location.pathname == "/hotels")
              CT.utils.helperFunctions.triggerFunnelCall();
      }

      /* Facebook Remarketing Pixel */ //TODO move to seperate function.
      if (CT.app && (window.countryCode == "in" || window.countryCode == "ae") && (CT.app == 'air' || CT.app == 'hotel')) {
          (function () {
              var _fbq = window._fbq || (window._fbq = []);
              if (!_fbq.loaded) {
                  var fbds = document.createElement('script');
                  fbds.async = true;
                  fbds.src = '//connect.facebook.net/en_US/fbds.js';
                  var s = document.getElementsByTagName
                      ('script')[0];
                  s.parentNode.insertBefore(fbds, s);
                  _fbq.loaded = true;
              }
              _fbq.push(['addPixelId', '551295824981249']);
          })();
          window._fbq = window._fbq || [];
          window._fbq.push(['track', 'PixelInitialized', {}]);
      }

      CT.utils.genericBlocks.displayLanguagePrefToolTip();

      //CT.utils.trackers.ctAnalyticsPageViewLogging();
  } catch (e) {
      window.ct_debug && L(e);
  }

  var offersMsg = window.offersAvailable && window.offersAvailable.map(function (offer) {
  return offer.offerMessage[0]
  })
  var cfwCasbackRegex = /10% Cashback.{1,}Cleartrip for work/i
  window.cfwCasbackMsg = offersMsg && offersMsg.find(function (msg){
      return cfwCasbackRegex.test(msg)
  })

  if (CT.app === "hotel" &&
      CT.utils.helperFunctions.isLoggedInUser() &&
      CT.utils.helperFunctions.getWorkPlusUserState &&
      !(window.product === "B2B" || window.companyConfig) && (window.countryType && window.countryType === "in")
  ) {
     CT.utils.helperFunctions.getWorkPlusUserState(function () {
         if (window.cfwCasbackMsg && CT.utils.helperFunctions.isLoggedInUser() && CT.app === 'hotel' &&
             (CT.workPlusState === 'TRIAL' ||
             CT.workPlusState === 'TRIAL_NCB' ||
             CT.workPlusState === 'VERIFIED')) {
             var continueBtn = $('.totalFareBlock dd:last')
             var cfwMsg = '<dd class="pt0 pb0">' +
                 '<p class="cfwMessage addditional-note-flexifly mt15 mb0 pr30 flex flex-column flex-inline" style="color: #1a1a1a">' +
                 '<span><img src="/images/bizlite/bizliteWorkPlus.png" align="top" width="127px"></span>' +
                 '<span class="fs-12">Get 10% cashback in your Cleartrip Wallet once you check-in</span></p></dd>'
                 window.partpay_enabled ? $('.totalFareBlock').append($(cfwMsg)) : $(cfwMsg).insertBefore(continueBtn)
         }
     })
  }
});

$(document).ready(function () {
  $scroll_count = 0;
  try {
      $(window).bind('scroll', function () {
          $scroll_count += 1;
      });
  } catch (e) {

  }

});

$(window).load(function () {
  try {
      window.eventList = window.eventList || [];
      $('body').append('<div id="fb-root"></div>');
      $.ajaxSetup({ cache: true });

      $.getScript('//connect.facebook.net/en_UK/all.js', function () {
          if (typeof FB != "undefined") {
              FB.init({
                  appId: '293814704002168'
              });
              FB.getLoginStatus(function (response) {
                  if (response.authResponse && typeof (response.authResponse) != "undefined" && !(CT.utils.cookies.read('userid'))) {
                      var userid = response.authResponse.userID;
                      $.ajax({
                          url: '/fb/auto_login',
                          data: { 'caller': 'fblogin', 'id': userid, 'access_token': response.authResponse.accessToken, 'service': window.location.pathname },
                          success: function (data) {
                              if (data.url)
                                  window.location.href = data.url;
                          }
                      });
                  }
                  else
                      window.fbLog = false;
              });
          }
      });


      // for security fixes PRM-11243 to prevent clickjacking
      // changed for ART-1871 only for preventing amex for clickjacking
      (function () {
          try {
              if (window.isWL && (top.location.hostname !== window.location.hostname)) {
                  top.location.hostname = window.location.hostname;
              }
          } catch (e) {
              if (e.name === "SecurityError") {
                  window.document.write('Oops!!');
              }
          }
      })();

      // initialize _gaq when the js file is loading to avoid _gaq variable errors.
      //window._gaq = window._gaq || [];
      if (window.navigator.userAgent.indexOf("iPad") == -1 && CT.app === "hotel") {
          window._gaq = window._gaq || [];
      }
      CT.utils.trackers.page_count();
      CT.utils.helperFunctions.forceHttpsLinks();

      if (window.isMobileUA != true) { CT.utils.helperFunctions.createOfferBand(); }
      //CT.utils.helperFunctions.trackGAEvent();

      if (window._errs) {
          window._errs.meta = {
              email: (unescape(CT.utils.cookies.read("userid") || "un-signed-user"))
          };
      }
      if (window.enableOldFlashSaleFlow) {
          CT.utils.helperFunctions.showFlashSaleTag();
      }
      // check if any unsent events left.
      var store = CT.utils.helperFunctions.store;
      if (store) {
          try {
              var unsentEvents = store().getItem('events');
              if (unsentEvents) {
                  if (unsentEvents.indexOf("Bus") === -1)
                      store().removeItem('events');
              }
          }
          catch (e) {
              // do nothing.
          }
      }
      CT.utils.helperFunctions.initLogger();

      $(document).bind('click', function (e) {
          if ($(e.target).css('display') !== 'none') {
              if (e.target.id != 'smallWorldApp' && !$('.smallWorldApp').find(e.target).length) {
                  $(".moreProducts").hide();
              }

              if (!$(e.target).hasClass('languageLink') && !$('.languageLink').find(e.target).length) {
                  $(".languageLink").removeClass('current');
                  $(".languageMenu").hide();
              }

              if (!$(e.target).hasClass('currencyLink') && !$('.currencyLink').find(e.target).length) {
                  $(".currencyLink").removeClass('current');
                  $(".currencyMenu").hide();
              }

              if (!$(e.target).hasClass('countryLink') && !$('.countryLink').find(e.target).length) {
                  $(".countryLink").removeClass('current');
                  $(".countryMenu").hide();
              }

              if (!$(e.target).hasClass('otherCharges') && !$(".farePopover").find(e.target).length && !$(e.target).hasClass('fareBreakUpLink') && !$('.fareBreakUpLink').find(e.target).length) {
                  $(".farePopover").hide();
              }
              if (!$(e.target).hasClass('openRateDetails') && !$(".hotelFarePopover").find(e.target).length && !$(e.target).hasClass('agToolTip') && !$('.agToolTip').find(e.target).length) {
                  $(".hotelFarePopover").hide();
              }


              if (!$(".baggagePopover").find(e.target).length && !$(e.target).hasClass('baggageLink') && !$('.baggageLink').find(e.target).length) {
                  $(".baggagePopover").hide();
              }

              if (!$(".refundPopOver").find(e.target).length && !$(e.target).hasClass('farePolicyLink') && !$('.farePolicyLink').find(e.target).length) {
                  $(".refundPopOver").hide();
              }

              if (CT.settings && CT.settings.currentTab) {
                  var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                  if ($currentTab) {
                      $currentTab.removeClass('comboTabsFirstRun');
                      CT.utils.cookies.create("comboTabsFirstRun", true, 1);
                  }
              }

              $AccountMenu = $('#userAccountNav').find("#userAccountMenu");
              $AccountLink = $('#userAccountNav').find("#userAccountLink");
              if (e.target.id !== 'userAccountLink' && !$AccountLink.find(e.target).length) {
                  $AccountMenu.hide();
                  $AccountLink.removeClass("current");
              }
              if (!$(e.target).hasClass('bookingDropDown') && !$('.bookingDropDown').find(e.target).length) {
                  $(".bookingDropDownMenu").hide();
              }
          }
      });

      // close dropdown menus on Esc. Key
      $(document).bind('keypress', function (e) {
          if (e.keyCode == 27) {
              $(".languageLink").removeClass('current');
              $(".languageMenu").hide();

              $(".currencyLink").removeClass('current');
              $(".currencyMenu").hide();


              $AccountMenu = $('#userAccountNav').find("#userAccountMenu");
              $AccountLink = $('#userAccountNav').find("#userAccountLink");
              $AccountMenu.hide();
              $AccountLink.removeClass("current");

          }
      });
  } catch (e) {
      window.ct_debug && L(e);
  }
});

/*
*Set CT.countryCode;
*/
(function () {
  if (!window.CT)
      window.CT = {};
  if (window.CT.countryCode == undefined) {
      window.CT.countryCode = (function () {
          var dmn = "";
          var hn = window.location.hostname;
          if (hn.match(/(.).ae$/)) {
              dmn = "ae";
          } else if (hn.match(/^om((.)*).cleartrip.com$/)) {
              dmn = "om";
          } else if (hn.match(/^me((.)*).cleartrip.com$/)) {
              dmn = "me";
          } else if (hn.match(/^bh((.)*).cleartrip.com$/)) {
              dmn = "bh";
          } else if (hn == "qa2.cleartrip.com") {
              dmn = "in";
          } else if (hn.match(/^qa((.)*).cleartrip.com$/)) {
              dmn = "qa";
          } else if (hn.match(/^kw((.)*).cleartrip.com$/)) {
              dmn = "kw";
          } else if (hn.match(/^sa((.)*).cleartrip.com$/)) {
              dmn = "sa";
          } else if (hn.match(/(.).sa$/)) {
              dmn = "sa";
          } else {
              dmn = "in";
          }
          return dmn;
      })();
  }
})();


/*
* Set CT.langUrlPrefix
*/
(function () {
  var arabicEnabledDomains = ["ae", "sa", "kw"];
  if (!window.CT)
      window.CT = {};
  if (window.CT.langUrlPrefix == undefined) {
      window.CT.langUrlPrefix = (function () {
          var languagesEnabled = ["ar"],
              _langUrlPrefix = "",
              languagesEnabledLength = languagesEnabled.length;

          for (var i = 0; i < languagesEnabledLength; i++) {
              var lang = languagesEnabled[i];
              if (window.location.pathname.split("/")[1] == lang) {
                  _langUrlPrefix = "/" + lang;
              }
          }
          return _langUrlPrefix;
      })();
  }
  // set cookie as "ar"only if the page is in arabic
  //"en will be set only when english is chosen through the language dropdown"
  if (window.CT.langUrlPrefix.indexOf("ar") != -1) {
      if (arabicEnabledDomains.indexOf(window.CT.countryCode) != -1) {
          CT.utils.cookies.create("lp", "ar", 365);
      }
  } else if (window.CT.countryCode == "sa"
      && (window.location.search.indexOf("utm_source=") != -1 || window.location.search.indexOf("gclid=") != -1)) {
      CT.utils.cookies.create("lp", "en"); //for SEM flow defult it to english-site. so the preference is set to english.
  }

})();



/*
* file include trigger block
*/
(function () {
  if (window.mixpanelswitch && ((CT && CT.app == "hotel") || window.location.pathname.indexOf("/hotels") != -1)) {
      CT.utils.trackers.includeMixPanel();
      $(window).bind('beforeunload', CT.utils.helperFunctions.trackScroll);
  }
  if (window.isMobileUA == true && CT.subProd == "wg") {
      dataLayer = CT.settings.GATagManager;
      dataLayer[0]['Date-Search'] = moment().format("DD/MM/YYYY");
      dataLayer[0]['Day-Search'] = moment().format("dddd");
      CT.utils.helperFunctions.includeGATagManager();
  }
  if (window.moengageEnabled && window.moengageId) {
      CT.utils.helperFunctions.tpTrack({ 'tp': 'moengage' });
  }
})();
/*==========================================================================================================*/

//GA fix for pageload
(function () {
  if ($.inArray(CT.app, ["hotel", "air", "dp", "bus", "collections", "local"]) != -1) {
      if (CT.app !== "collections") {
          window._gaq = window._gaq || [];
      }
  }
})();
CT.utils.initCleverTap = function () {
  if (!window.clevertap) {
      window.clevertap = { event: [], profile: [], account: [], onUserLogin: [], notifications: [{ skipDialog: true }] };
      window.clevertap.account.push({ "id": (window.cleverTapAccId || "W8R-KK8-W74Z") });
      window.clevertap.enablePersonalization = true; // enables Personalization
      (function () {
          var wzrk = document.createElement('script');
          wzrk.type = 'text/javascript';
          wzrk.async = true;
          wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(wzrk, s);
      })();
  } else if (!window.clevertapChromePushNotification) {
      // Install desktop service worker
  }
}
CT.utils.initCleverTap();
CT.utils.checkMobileDevice = function () {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
  }
  else {
      return false;
  }
};
CT.utils.zendeskChat = {};
CT.utils.zendeskChat.setName = function (zd_name, zd_email) {
  zE(function () {
      zE.identify({
          name: zd_name,
          email: zd_email
      });
  });
};
CT.utils.zendeskChat.initializeWidget = function (name, emailId, tripId) {
CT.utils.zendeskChat.CTChat.storeConnection(name, emailId, tripId);
$(".visitormsg").off();
$('.visitormsg').keypress(function (e) {
  var key = e.which;
  var flag;
  if(key == 13)  {
    CT.utils.zendeskChat.CTChat.visitorToServer();
    flag = 0;
  } else if (key == 8 && $('.visitormsg').val() === "") {
    flag = 0;
  }
  else {
    flag = 1;
  }
  CT.utils.zendeskChat.CTChat.setVisitorTyping(flag);
});
$(".send_button").off();
$('.send_button').click(function () {
  CT.utils.zendeskChat.CTChat.visitorToServer();
});

$('.minimize_chat').click(function(){
  $(".floating_support__icon").removeClass("hide");
  console.log('Minimized');
  $(".trips").removeClass("pushOverlay");
  $(".pushLeft").removeClass('pushLeft');
  callClevertapEvent('chat_minimise_button_clicked');
  window.notification = 0;
})

$(".floating_support__icon").click(function(){
  $(".trips").addClass("pushOverlay");
  $(".floating_support__icon").addClass("hide");
  $(".tripsSupport__widget").addClass('pushLeft');
  console.log('Maximized');
  $(".notification-count").addClass('hide');
  window.notification = 0;
})
};
CT.utils.zendeskChat.checkWidgetAlreadyInitialized = function () {
  return window.zE ? true : false;
}
CT.utils.zendeskChat.showWidget = function () {
  window.zE && window.zE.show();
}
CT.utils.zendeskChat.isChatting = function () {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              return $zopim.livechat.isChatting() ? true : false;
          });
      });
  });
}
CT.utils.zendeskChat.showWindow = function () {
  window.zE && window.zE.activate();
}
CT.utils.zendeskChat.addTag = function (str) {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.addTags(str)
          });
      });
  });
};
CT.utils.zendeskChat.setNote = function (str) {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.setNotes('');
              $zopim.livechat.setNotes("_________________________\n" + str + "\n_________________________\n");
          });
      });
  });
};
CT.utils.zendeskChat.resetNotes = function () {
  window.zE && window.zE(function () {
      $zopim(function () {
          $zopim.livechat.setNotes('')
      });
  });
};
CT.utils.zendeskChat.formatJSON = function (stringorjson) {
  stringorjson = (typeof stringorjson == 'string') ? stringorjson : JSON.stringify(stringorjson)
  return stringorjson.replace(/["{}]/g, '').replace(/,/g, '\n').replace(/:/g, '->')
};
CT.utils.zendeskChat.showCall = function () {
  var zC = document.createElement('div');
  zC.id = "zendeskCall";
  zC.classList = 'mt10 mb10 mr20 ml20 icon phone';
  zC.setAttribute('style', 'position:fixed;bottom:0;left:0;width: 48px;height: 48px;background:rgb(100,255,100);z-index:999998;border-radius:100%;cursor:pointer;');
  var zCpopup = document.createElement('div');
  zCpopup.setAttribute('style', 'position:absolute;background:rgb(255,255,0);top: -70px;left: 50px;font-size: 1.2em;border:1px solid black;');
  var zCpopupfield1 = document.createElement('div');
  zCpopupfield1.innerHTML = 'Name'
  var zCpopupfield2 = document.createElement('input');
  var zCpopupfield3 = document.createElement('div');
  zCpopupfield3.innerHTML = 'Phone-Number'
  var zCpopupfield4 = document.createElement('input');
  var zCpopupfield5 = document.createElement('button');
  zCpopupfield5.classList = 'mt10 mb10 mr10 ml10'
  zCpopupfield5.setAttribute('style', 'border:1px solid black;');
  zCpopupfield5.innerText = 'Push To Zendesk'
  zCpopup.appendChild(zCpopupfield1)
  zCpopup.appendChild(zCpopupfield2)
  zCpopup.appendChild(zCpopupfield3)
  zCpopup.appendChild(zCpopupfield4)
  zCpopup.appendChild(zCpopupfield5)
  zCpopup.hidden = true;
  zC.appendChild(zCpopup)
  document.body.appendChild(zC)
  zC.addEventListener('click', function () {
      zCpopup.hidden = !zCpopup.hidden;
  })
  zCpopup.addEventListener('click', function (e) {
      e.stopPropagation();
  })
  zCpopupfield5.addEventListener('click', function () {
      $.ajax({
          url: 'https://cleartripcare.zendesk.com/api/v2/tickets.json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify({ "ticket": { "subject": 'Please call me back on' + zCpopupfield4.innerText, "comment": { "body": 'hi' } } })
      })
          .done(function (data) {
              window.console && console.log(data.ticket);
          });
  });
};
CT.utils.zendeskChat.hideChat = function () {
  $(document).ready(function () {
      if ($(".zopim").is(":visible")) {
          zE(function () {
              $zopim(function () {
                  $zopim.livechat.hideAll()
              });
          });
      }
  });
};
CT.utils.zendeskChat.removeTag = function (str) {
  $(document).ready(function () {
      window.zE && window.zE(function () {
          $zopim(function () {
              $zopim.livechat.removeTags(str)
          });
      });
  });
};
CT.utils.zendeskChat.clevertapOnWidgetShown = function (clevertapData) {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.setOnConnected(function () {
                  setTimeout(function () {
                      if ($('.zopim').is(':visible')) {
                          CT.utils.helperFunctions.tpTrack({
                              "tp": "clevertap",
                              "category": "Chat widget shown",
                              "values": clevertapData
                          });
                      }
                  }, 2000);
              });
          });
      });
  });
};



CT.utils.zendeskChat.clevertapOnClick = function (clevertapData) {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.window.onShow(function () {
                  CT.utils.helperFunctions.tpTrack({
                      "tp": "clevertap",
                      "category": "Chat icon clicked",
                      "values": clevertapData
                  });
              });
          });
      });
  });
};
CT.utils.zendeskChat.clevertapOnMinimize = function (clevertapData) {
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.window.onHide(function () {
                  CT.utils.helperFunctions.tpTrack({
                      "tp": "clevertap",
                      "category": "Chat window minimized",
                      "values": clevertapData
                  });
              });
          });
      });
  });
};
// CT.utils.zendeskChat.checkIfAgentsOffline = function(departmentName) {
//  $(document).ready(function(){
//      zE(function() {
//          $zopim(function() {
//              $zopim.livechat.setOnConnected(function() {
//                  // var departmentName = "Trip Support";
//                  // var departmentName = "Product Tech";
//                  $zopim.livechat.departments.setVisitorDepartment(departmentName);
//                  var chatDepartment = $zopim.livechat.departments.getDepartment(departmentName);
//                  if(chatDepartment.status === "offline") {
//                      return true;
//                  }
//              });
//          });
//      });
//  });
//  return false;
// }
CT.utils.zendeskChat.hideOnAllAgentsOffline = function (departmentName) {
  // if(window.zE) {
  //  if(CT.utils.zendeskChat.checkIfAgentsOffline(departmentName)) {
  //      $zopim.livechat.hideAll();
  //  }
  //  else {
  //      $zopim.livechat.isChatting() ? window.zE.activate() : $zopim.livechat.button.show();
  //  }
  // }
  $(document).ready(function () {
      zE(function () {
          $zopim(function () {
              $zopim.livechat.setOnConnected(function () {
                  // var departmentName = "Trip Support";
                  // var departmentName = "Product Tech";
                  $zopim.livechat.departments.setVisitorDepartment(departmentName);
                  var chatDepartment = $zopim.livechat.departments.getDepartment(departmentName);
                  if (!chatDepartment || chatDepartment.status === "offline") {
                      $zopim.livechat.hideAll();
                  }
                  else {
                      $zopim.livechat.isChatting() ? window.zE.activate() : $zopim.livechat.button.show();
                  }
              });
          });
      });
  });
};
CT.utils.zendeskChat.tripDetailsChat = function (tripId, Tag) {
  // if(!window.zendeskTripChatEnabled || CT.countryCode != 'in') return;
  // if(CT.utils.zendeskChat.checkWidgetAlreadyInitialized()) {
  //     CT.utils.zendeskChat.showWidget();
  //     CT.utils.zendeskChat.isChatting() && CT.utils.zendeskChat.showWindow();
  // }
  // else {
  //     var userid = unescape(CT.utils.cookies.read('userid'));
  //     var zd_name = userid.split('|')[1] || '';
  //     var zd_email = userid.split('|')[0] || '';
  //     CT.utils.zendeskChat.initializeWidget(zd_name.replace(/\+/g,' '), zd_email);
  // }
  // CT.utils.zendeskChat.hideOnAllAgentsOffline("Trip Support");
  // tripId && CT.utils.zendeskChat.setNote('TripId->' + tripId);
  // Tag && CT.utils.zendeskChat.addTag(Tag);
  if (!window.zendeskTripChatEnabled || CT.countryCode != 'in') return;

  var userid = unescape(CT.utils.cookies.read('userid'));
  var name = userid.split('|')[1] || '', emailId = userid.split('|')[0] || '';
  CT.utils.zendeskChat.initializeWidget(name, emailId, tripId);
};

CT.utils.zendeskChat.CTChat = {
showChatWindow:function(){
  $(".chat_content__block").removeClass('hide');
  if(!window.isAndroidApp && !window.isIosApp){
    $(".minimize_chat").removeClass('hide');
  }
  $(".callback").addClass('hide');
  $(".support__title").text('Chat');
  if ($(".selected_booking__block").hasClass('hide')) {
    // if((navigator.userAgent.indexOf("Android")!= -1) || (navigator.userAgent.indexOf("CriOS")== -1 && window.isIosApp && !window.isIosApp() && !window.isAndroidApp())){
    //   $(".chat_content__block").css('height', 'calc(100vh - 185px)');
    // } else {
    //   $(".chat_content__block").css('height', 'calc(100vh - 130px)');
    // }

    if(getDeviceType() === "android"){
      if(window.isAndroidApp && isAndroidApp()){
        $(".chat_content__block").css('height', 'calc(100vh - 185px)');
      } else {
        $(".chat_content__block").css('height', 'calc(100vh - 125px)');
      }
    } else {
      if(getBrowserType() === 'chrome'){
        $(".chat_content__block").css('height', 'calc(100vh - 130px)');
      } else {
        if(window.isIosApp && isIosApp()){
          $(".chat_content__block").css('height', 'calc(100vh - 130px)');
        } else {
          $(".chat_content__block").css('height', 'calc(100vh - 192px)');
        }
      }
    }

  } else {
    if($(".selected_subissue__block").hasClass('hide')){
      // if((navigator.userAgent.indexOf("Android")!= -1) || (navigator.userAgent.indexOf("CriOS")== -1 && window.isIosApp && !window.isIosApp() && !window.isAndroidApp())){
      //   $(".chat_content__block").css('height', 'calc(100vh - 290px)');
      // } else {
      //   $(".chat_content__block").css('height', 'calc(100vh - 235px)');
      // }
      if(getDeviceType() === "android"){
        if(window.isAndroidApp && isAndroidApp()){
          $(".chat_content__block").css('height', 'calc(100vh - 290px)');
        } else {
          $(".chat_content__block").css('height', 'calc(100vh - 225px)');
        }
      } else {
        if(getBrowserType() === 'chrome'){
          $(".chat_content__block").css('height', 'calc(100vh - 235px)');
        } else {
          if(window.isIosApp && isIosApp()){
            $(".chat_content__block").css('height', 'calc(100vh - 235px)');
          } else {
            $(".chat_content__block").css('height', 'calc(100vh - 297px)');
          }
        }
      }
    } else {
      // if((navigator.userAgent.indexOf("Android")!= -1) || (navigator.userAgent.indexOf("CriOS")== -1 && window.isIosApp && !window.isIosApp() && !window.isAndroidApp())){
      //   $(".chat_content__block").css('height', 'calc(100vh - 334px)');
      // } else {
      //   $(".chat_content__block").css('height', 'calc(100vh - 280px)');
      // }
      if(getDeviceType() === "android"){
        if(window.isAndroidApp && isAndroidApp()){
          $(".chat_content__block").css('height', 'calc(100vh - 334px)');
        } else {
          $(".chat_content__block").css('height', 'calc(100vh - 265px)');
        }

      } else {
        if(getBrowserType() === 'chrome'){
          $(".chat_content__block").css('height', 'calc(100vh - 280px)');
        } else {
          if(window.isIosApp && isIosApp()){
            $(".chat_content__block").css('height', 'calc(100vh - 280px)');
          } else {
            $(".chat_content__block").css('height', 'calc(100vh - 341px)');
          }
        }
      }
    }
  }

  if(sessionStorage.getItem('chatHistory')){
    var chatHistory = JSON.parse(sessionStorage.getItem('chatHistory'));
    for (var i = 0; i < chatHistory.length; i++) {
      CT.utils.zendeskChat.CTChat.log(chatHistory[i]);
    }
  }
},
connectWS: function(){
  if (window.WebSocketURL) {
    ws = new WebSocket(new URL(window.WebSocketURL));
    ws.onopen = function() {
      console.log("--Websocket is connected");
      sessionStorage.setItem('timeStamp', Date.now());
      CT.utils.zendeskChat.CTChat.showChatWindow();
    }
    ws.onmessage = function(message) {
      var response = JSON.parse(message.data);
      switch (response["method"]) {
        case "connect":
          ws.send('{"method":"connect","params":[{"LastMessageID":"0"}],"id":null}');
          if(window.wsExists){
            ws.send('{"method":"updateBusy", "params":[{"ChatKey":"' + ChatKey + '"}]}');
          } else{
            $(".chat_wait").removeClass('hide');
          }
          break;
        case "heartbeat":
          ws.send('{"result":{"Response":"ack"},"error": null,"id":null}');
          console.log("--Heartbeat responded");
          break;
        default:
          CT.utils.zendeskChat.CTChat.setChat(message.data);
          console.log("--Message From Server: \n" + message.data);
      }
    }
    ws.onerror = function(error) {
      console.log('--Error detected: ' + error.data);
      console.log(error);
      console.log(error.data);
    }
    ws.onclose = function() {
      sessionStorage.removeItem('chatConfigs');
      sessionStorage.removeItem('chatHistory');
      window.wsExists = false;
      console.log("--Websocket is closed");
    }
  }
},
storeConnection: function(name, emailId, tripId){
  if(sessionStorage.getItem('chatConfigs')){
    var chatConfigs = JSON.parse(sessionStorage.getItem('chatConfigs'));
    if((Date.now() - parseInt(JSON.parse(sessionStorage.getItem('timeStamp')))) > 1800000 ){
      CT.utils.zendeskChat.CTChat.showChatWindow();
      $(".chat-typebox").addClass('hide');
      var temp = '<div class="end_chat_message flex flex-left"><p class="chat-support-message mt30 fSemibold">' + (CTSupport.currentAgent || 'Agent') +' has ended the chat</p></div>';
      $(".chat_content__child").append(temp);
      CT.utils.zendeskChat.CTChat.scrollToBottom(".chat_content__child");
    } else{
      window.ChatKey = chatConfigs.ChatKey;
      window.WebSocketURL = chatConfigs.WebSocketURL;
      window.ClientID = chatConfigs.ClientID;
      window.ChatID = chatConfigs.ChatID;
      window.wsExists = true;
      CT.utils.zendeskChat.CTChat.connectWS();
    }
  } else {
    window.firstMsg = true;
    var createChatParams = {
      "skipPreChat": false,
      "data": {
        "name": name,
        "email": emailId,
        "information": "",
        "custom_trip_id": tripId,
        "custom_platform": CT.utils.checkMobileDevice ? "Desktop" : "mweb"
      }
    }
    if(window.isAndroidApp && window.isAndroidApp()){
      createChatParams.data.custom_platform = "Android";
    }

    if(window.isIosApp && window.isIosApp()){
      createChatParams.data.custom_platform = "iOS";
    }

    if(CTSupport.reason && CTSupport.reason.value){
        createChatParams.data.custom_cause = "Cancellation";
        createChatParams.data.custom_sub_cause = CTSupport.reason.value;
        CTSupport.reason = {};
    } else {
      createChatParams.data.custom_cause = CTSupport.cause;
      CTSupport.cause = "";
    }
    createChatParams.data.custom_information = CTSupport.message ? CTSupport.message.chatInfo : "";

    if(CTSupport.message){
      CTSupport.message.chatInfo = "";
    }
    var headers = { "Content-type": "application/json", "dataType": "json" };
    createChatParams = JSON.stringify(createChatParams);
    document.getElementsByClassName('loader_block')[0].style.background = "url('https://ui.cltpstatic.com/images/animations/spinner_medium.gif') center 20% no-repeat rgba(248,248,248,0.5);";
    $("#loader_block").removeClass('hide');
    $.ajax({
      url: "/communication/selfcare/api/createChat",
      type:"POST",
      data: createChatParams,
      headers:headers,
      success: function(result){
        $("#loader_block").addClass('hide');
        if(checkKeyExists(result, "UnavailableReason")){
          var msg = result.Message;
          $('.error_alert')[0].style = "";
          if(result && result.UnavailableReason === "outside_hours"){
            msg = "For assistance with your booking please reach us on the following numbers :- <br><br>India Support (+91 9595 333 333) <br>UAE (04875 4545) - Toll Free from UAE <br>KSA (+966 1122 46 311) - Toll Free from Saudi Arabia";
            $('.error_alert').css('height', 'auto');
            $('.error_alert').css('top', '26%');
          }
          CT.utils.zendeskChat.CTChat.displayErrorOverlay(msg);
          return;
        }
        if(checkKeyExists(result, "Status") && result.Status == "error"){
          CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, we are facing some technical issue at our end. For assistance with your booking please reach us on the following numbers :- <br><br> India Support (+91 9595 333 333) <br> UAE (04875 4545) - Toll Free from UAE <br> KSA (+966 1122 46 311) - Toll Free from Saudi Arabia ");
          return;
        }
        window.ChatKey = result.ChatKey;
        window.WebSocketURL = result.WebSocketURL;
        window.ClientID = result.ClientID;
        window.ChatID = result.ChatID;
        var chatConfigs = {
          "ChatKey" : window.ChatKey,
          "WebSocketURL" : window.WebSocketURL,
          "ClientID" : window.ClientID,
          "ChatID" : window.chatID
        }
        sessionStorage.setItem('chatConfigs', JSON.stringify(chatConfigs));
        CT.utils.zendeskChat.CTChat.connectWS();
        $(".chat-typebox").addClass('hide');
        $(".end_chat_message").remove();
      },
      error: function (err) {
        $("#loader_block").addClass('hide');
        $(".issue_list__block").removeClass('hide');
        CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, we are facing some technical issue at our end. For assistance with your booking please reach us on the following numbers :- <br><br> India Support (+91 9595 333 333) <br> UAE (04875 4545) - Toll Free from UAE <br> KSA (+966 1122 46 311) - Toll Free from Saudi Arabia ");
      }
    });
  }
},
visitorToServer:function(){
  var messagetext;
  var userid = unescape(CT.utils.cookies.read('userid'));
  var name = userid.split('|')[1] || 'You';
  if($("#trip_detail").css('display') == "block"){
    if($('.visitormsg')[1]){
      messagetext = JSON.stringify($('.visitormsg')[1].value);
      $('.visitormsg')[1].value = "";
    } else {
      messagetext = JSON.stringify($('.visitormsg')[0].value);
      $('.visitormsg')[0].value = "";
    }
  } else {
    messagetext = JSON.stringify($('.visitormsg')[0].value);
    $('.visitormsg')[0].value = "";
  }

  // if((screen.orientation && screen.orientation.type.indexOf('landscape') > -1) || (window.matchMedia("(orientation: landscape)").matches)){
  //   var field = document.createElement('input');
  //   field.setAttribute('type', 'text');
  //   document.body.appendChild(field);
  //
  //   setTimeout(function() {
  //       field.focus();
  //       setTimeout(function() {
  //           field.setAttribute('style', 'display:none;');
  //   		field.parentNode.removeChild(field);
  //       }, 50);
  //   }, 50);
  // }

  CT.utils.zendeskChat.CTChat.sendmsg('{"method":"sendMessage", "params":[{"ChatKey": ' + ChatKey + ', "ChatMessageID":"' + CT.utils.zendeskChat.CTChat.getRand(89999999999, 10000000000) + '", "Name":"' + name + '", "Message":' + messagetext + '}],"id":null}');
},
sendmsg: function(txt){
  if(!window.ws){
    CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, we are facing some technical issue at our end. For assistance with your booking please reach us on the following numbers :- <br><br> India Support (+91 9595 333 333) <br> UAE (04875 4545) - Toll Free from UAE <br> KSA (+966 1122 46 311) - Toll Free from Saudi Arabia");
    return;
  } else if (window.ws.readyState == 3) {
    CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, we are facing some technical issue at our end. For assistance with your booking please reach us on the following numbers :- <br><br> India Support (+91 9595 333 333) <br> UAE (04875 4545) - Toll Free from UAE <br> KSA (+966 1122 46 311) - Toll Free from Saudi Arabia");
    return;
  }
  if (txt != "") {
    ws.send(txt);
    console.log("--Message Sent To Agent: " + txt);
  }
},
setVisitorTyping: function(flag){
    CT.utils.zendeskChat.CTChat.sendmsg('{"id":' + CT.utils.zendeskChat.CTChat.getRand(8999999999999999999, 1000000000000000000) + ', "method":"visitorTyping", "params":[{"ChatKey": ' + ChatKey + ', "IsTyping": ' + flag + '}');
},
displayErrorOverlay:function(msg){
  $('.error_alert').removeClass('hide');
  $('.tripsSupport__widget').addClass('alertOverlay');
  if ((window.isIosApp && window.isIosApp()) || (window.isAndroidApp && window.isAndroidApp())) {
    $('.tripsSupport__widget').addClass('fullscreenAlertOverlay');
  } else {
    $('.tripsSupport__widget').addClass('alertOverlay');
  }
  $('.error_alert .alert_subHeading').html(msg);
  $('.error_alert').css('height', 'auto');
  $('.error_alert').css('top', '26%');
  if(CTSupport.currentAPICall === "trips_401"){
    $(".alert_actions > li").text("Sign In");
  }
},
hideErrorOverlay: function(){
  $('.error_alert').addClass('hide');
  if($('.tripsSupport__widget').hasClass("fullscreenAlertOverlay")){
    $('.tripsSupport__widget').removeClass('fullscreenAlertOverlay');
    $('.tripsSupport__widget').removeClass('alertOverlay');
  } else {
    $('.tripsSupport__widget').removeClass('alertOverlay');
  }

  if(!window.wsExists){
    closeOverlay();
  }

  if(CTSupport.currentAPICall === "trips_401" && !window.noredirect){
    window.noredirect = false;
    var url = window.location.origin + "/signin?service=" + window.location.pathname;
    window.location.href = url;
  }
},
endChat: function(){
  CT.utils.zendeskChat.CTChat.sendmsg('{"method":"finishChat", "params":[{"ChatKey":' + ChatKey + ', "ClientID":' + ClientID + '}]}');
  $(".message").remove();
  $(".end_chat_message").remove();
  $(".start_chat_message").addClass('hide');
  ws.close();
},
setChat:function(data){
  var msg = JSON.parse(data), val;
  if(msg.params && msg.params.length){
    val = msg.params[0].Values;
  }
  $(".dots-container").remove();
  if(window.firstMsg && val && val.PersonType === "operator"){
    window.firstMsg = false;
    $(".queue_message").remove();
    $(".agent_name").text(val.Name);
    CTSupport.currentAgent = val.Name;
    $(".chat_wait").addClass('hide');
    $(".start_chat_message").removeClass('hide');
    $(".chat-typebox").removeClass('hide');
    if($('.visitormsg')[1]){
      $('.visitormsg')[1].focus();
    } else {
      $('.visitormsg')[0].focus();
    }
  } else if (window.firstMsg && val && val.PersonType === "visitor"){
    window.PersonID = msg.params[0].PersonID;
  }
  if(msg.method == "addMessage") {
    window.validChat = true;
    CT.utils.zendeskChat.CTChat.log(msg.params[0]);
  } else if(msg.method == "closed"){
      window.wsExists = false;
      $(".chat-typebox").addClass('hide');
      var temp = '<div class="end_chat_message flex flex-left"><p class="chat-support-message mt30 fSemibold">' + (CTSupport.currentAgent || 'Agent') +' has ended the chat</p></div>';
      $(".chat_content__child").append(temp);
      CT.utils.zendeskChat.CTChat.scrollToBottom(".chat_content__child");
  } else if(msg.method == "updateTyper"){
    window.validChat = true;
      CT.utils.zendeskChat.CTChat.showLoadingDots();
  } else if(msg.method == "updateChat"){
    window.validChat = true;
      // $(".chat_wait").addClass('hide');
  } else if (msg.method == "updateBusy") {
    $(".queue_message").remove();
    if(msg && msg.Params && msg.Params.length){
      var temp = '<div class="queue_message flex flex-left"><p class="chat-support-message mt30 fSemibold"> Queue position: ' + msg.Params[0].Position +'</p></div>';
      $(".chat_content__child").append(temp);
    }
  }

  if(msg.result){
    if(checkKeyExists(msg.result, 'UnavailableReason') || !window.validChat){
      $(".chat_wait").addClass('hide');
      $(".end_chat_message").remove();
      window.wsExists = false;
      $('.error_alert')[0].style = "";
      var msg = "For assistance with your booking please reach us on the following numbers :- <br><br>India Support (+91 9595 333 333) <br>UAE (04875 4545) - Toll Free from UAE <br>KSA (+966 1122 46 311) - Toll Free from Saudi Arabia";
      if(msg && msg.result && msg.result.UnavailableReason === "outside_hours"){
        $('.error_alert').css('height', 'auto');
        $('.error_alert').css('top', '26%');
        msg = "For assistance with your booking please reach us on the following numbers :- <br><br>India Support (+91 9595 333 333) <br>UAE (04875 4545) - Toll Free from UAE <br>KSA (+966 1122 46 311) - Toll Free from Saudi Arabia";
      }
      CT.utils.zendeskChat.CTChat.displayErrorOverlay(msg);
    }
  }

},
log:function(params){
  if(!params || !params.Values || !params.Values.Text || params.Values.Text=="null"){
    return;
  }
  var chatHistory = [];
  if(sessionStorage.getItem('chatHistory')){
    chatHistory = JSON.parse(sessionStorage.getItem('chatHistory'));
  };
  if(checkKeyExists(params, "MessageID")){
    window.messageStored = false;
    for (var i = 0; i < chatHistory.length; i++) {
      if(chatHistory[i].MessageID == params.MessageID){
        window.messageStored = true;
      }
    }
  }
  if(!window.messageStored){
    chatHistory.push(params);
  }
  sessionStorage.setItem('chatHistory', JSON.stringify(chatHistory));
  var val = params.Values;
  var time = "--", message_class, sent_msg_class='';
  if(val && val.Created){
    time = (new Date(val.Created)).toString().substr(16,5);
    time = CT.utils.zendeskChat.CTChat.formatTime(time);
  }
  if(val.PersonType == "visitor"){
    message_class = "chat-message-right fRegular tLeft mt10 mb10 pt10 pb10 pl10 pr10 mr20 fRight";
    sent_msg_class = "sent_msg";
  } else {
    message_class = "chat-message-left fRegular tLeft mt10 mb10 pt10 pb10 pl10 pr10 ml20 fLeft";
    if(!$(".floating_support__icon").hasClass("hide")){
      window.notification++;
      $(".notification-count").removeClass('hide');
      $(".notification-count").text(window.notification);
    }

    sessionStorage.removeItem('timeStamp');
    sessionStorage.setItem('timeStamp', Date.now());
  }

  var temp = "<div class = 'message "+ message_class +"'><div class = ''>" + time + " " + val.Name+"</div><div class = '" + sent_msg_class + "'>" + val.Text + "</div></div>";

  $(".chat_content__child").append(temp);
  CT.utils.zendeskChat.CTChat.scrollToBottom(".chat_content__child");
},
scrollToBottom:function(val){
  var messageBody = document.querySelectorAll(val);

  if(messageBody.length > 0){
    for (var i = 0; i < messageBody.length; i++) {
      messageBody[i].scrollTop = messageBody[i].scrollHeight - messageBody[i].clientHeight;
    }

  } else {
    messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight;
  }
},
getRand:function(low, high){
  return Math.floor(Math.random() * low + high);
},
formatTime:function(str){
  var hr = parseInt(str.substr(0,2)), time;
  if(hr > 12){
   hr = hr - 12;
   time = hr+str.substr(2,3)+" PM";
 } else if (hr == 12) {
   time = '12'+str.substr(2,3)+" PM";
 } else if (hr == 0) {
   time = '12'+str.substr(2,3)+" AM";
 } else {
   time = str+" AM";
 }
 time.length < 8 ? time = "0"+time : '';
 return time;
},
showLoadingDots:function(){
 var temp = '<div class = "dots-container"><div class="chat-message-left fRegular tLeft pt10 pb10 pl10 pr10 ml20 fLeft loading-dots "><div class="loading-dots--dot"></div><div class="loading-dots--dot"></div><div class="loading-dots--dot"></div></div></div>';
 $(".chat_content__child").append(temp);
 CT.utils.zendeskChat.CTChat.scrollToBottom(".chat_content__child");
},
triggerUpload:function(node){
 var fileUploaded = node.files[0], fileData;
 // var fileData = new FormData(fileUploaded);
 if(fileUploaded){
   fileData = {
     "chatId": ChatID,
     "clientId": ClientID,
     "fileName": fileUploaded.name,
     "fileSize": fileUploaded.size,
     "fileType": 1,
     "personId": PersonID,
     "personType": "VISITOR"
   }
 }
 CT.utils.zendeskChat.CTChat.getUploadUrl(fileData, fileUploaded);
},
getUploadUrl:function(fileData, fileUploaded){
 $.ajax({
   url: "https://upload.boldchat.com/aid/794130127792834009/account-id/794130127792834009/v1/files",
   method:"POST",
   data:fileData,
   // url: "/api/connectToAgent/",
   success: function(result){
     if(result.uploadUrl && result.token){
       var formData = new FormData();
       formData.append('user_file', fileUploaded);
       CT.utils.zendeskChat.CTChat.uploadFile(formData, result.uploadUrl, result.token);
     }
   },
   error: function (err) {
     // $(".issue_list__block").removeClass('hide');
     CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, file upload is failing currently. Please try in sometime");
   }
 });
},
uploadFile:function(formData, uploadUrl, token){
 $.ajax({
   url: uploadUrl,
   data: formData,
   type: 'POST',
   contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
   processData: false, // NEEDED, DON'T OMIT THIS
   success: function(result){
     CT.utils.zendeskChat.CTChat.uploadFileFollowup(token);
   },
   error: function (err) {
     CT.utils.zendeskChat.CTChat.displayErrorOverlay("Sorry, file upload is failing currently. Please try in sometime");
   }
 });
},
uploadFileFollowup:function(token){
 $.ajax({
   url: "https://upload.boldchat.com/aid/794130127792834009/account-id/794130127792834009/v1/files/" + token,
   type: 'PUT',
   success: function(result){

   },
   error: function (err) {
     // displayErrorOverlay("Sorry, file upload is failing currently. Please try in sometime");
   }
 });
}

}

//This piece of code is to show the currency according to user preference
CT.utils.utmCurrency = {
  //Code to set,update cookie;
  utmCurrencyCookie: function (obj) {
      var cookieValue = CT.utils.cookies.read('utm_currency');
      var value, currSymbol;
      var srpUrl = window.location.href;//"https://www.cleartrip.com/flights/results?utm_currency=USD";
      var utm_loc = srpUrl.search('utm_currency');
      if (cookieValue == null || cookieValue == undefined) {
          if (obj.code != null && obj.code != undefined) {
              currSymbol = CT.utils.utmCurrency.encodingValue(obj.symbol);
              // value = obj.code + "|" + obj.symbol;
              value = obj.code + "|" + currSymbol;
              CT.utils.cookies.create('utm_currency', value, 365 * 50);
          }
          else if (utm_loc !== -1) {
              CT.utils.utmCurrency.utmCurrencyParams();
          }
          else {
              currSymbol = CT.utils.utmCurrency.encodingValue(obj.displayCurrencyText);
              // value = obj.disp_currency + "|" + obj.displayCurrencyText;
              value = obj.disp_currency + "|" + currSymbol;
              CT.utils.cookies.create('utm_currency', value, 365 * 50);
          }
      }
      else {
          if (obj.code != null && obj.code != undefined) {
              currSymbol = CT.utils.utmCurrency.encodingValue(obj.symbol);
              // value = obj.code + "|" + obj.symbol;
              value = obj.code + "|" + currSymbol;
              CT.utils.cookies.create('utm_currency', value, 365 * 100);
          }
          else {
              if (utm_loc !== -1) {
                  CT.utils.utmCurrency.utmCurrencyParams();
              }
          }
      }
  },
  //code to check if utm currency is applicable when coming from airservice
  utmCheck1: function (obj) {
      if ((CT.app == "air" || window.productType == "FLIGHT") && window.location.href.indexOf("/m/") == -1 && obj.isUtmCurrencyEnabled == true) {
          return true;
      }
      return false;
  },
  //code to check if utm currency is applicable
  utmCheck: function () {
      var utmCurrencyEnabled = true;
      if ((CT.app == "air"|| window.productType == "FLIGHT") && window.location.href.indexOf("/m/") == -1 && utmCurrencyEnabled) {//&& obj.isUtmCurrencyEnabled==true){
          return true;
      }
      return false;
  },
  //changing the display cuurency as per user preference
  setUtmCurrency: function () {
      var cookie = CT.utils.cookies.read('utm_currency');
      cookie = CT.utils.utmCurrency.decodingValue(cookie);
      if (cookie != null && cookie != undefined) {
          var cookieValue = cookie.split("|");
          window.disp_currency["code"] = cookieValue[0];
          window.disp_currency["symbol"] = cookieValue[1];
      }

  },
  //encoding the cookie value
  encodingValue: function (obj) {
      var value = obj.split("");
      var i;
      var string = "";
      var len = value.length;
      for (i = 0; i < value.length; i++) {
          if (i < value.length - 1)
              string = string + value[i].charCodeAt() + "-";
          else
              string = string + value[i].charCodeAt();
      }
      return string;
  },
  //decoding the cookie value
  decodingValue: function (obj) {

      var value = obj.split("|");
      var currSymbol = value[1].split("-");
      var i;
      var string = "";
      for (i = 0; i < currSymbol.length; i++) {
          string = string + String.fromCharCode(currSymbol[i]);
      }
      string = value[0] + "|" + string;
      return string;

  },
  //code to change currency on itinerary page when the user selects meal,seat or baggage
  setCurrencyItn: function (selling_rate) {
      /* CT.currentCurrency.symbol=JSON.parse(currency_options).symbol;
       CT.currentCurrency.rate=JSON.parse(currency_options).rate;
       window.disp_currency.code=JSON.parse(currency_options).code;*/
      if (window.utmSelectedCurrency) {
          //To make a cookie
          currSymbol = CT.utils.utmCurrency.encodingValue(utmSelectedCurrency.symbol);
          value = utmSelectedCurrency.code + "|" + currSymbol;
          CT.utils.cookies.create('utm_currency', value, 365 * 100);
          //Updating values to be shown in utm currency on itn
          CT.currentCurrency.symbol = utmSelectedCurrency.symbol;
          CT.currentCurrency.rate = utmSelectedCurrency.rate;
          window.disp_currency.code = utmSelectedCurrency.code;
          window.disp_currency.symbol = utmSelectedCurrency.symbol;
          //This piece of code is to set the selling_rate
          selling_rate = utmSelectedCurrency.selling_rate;
          return selling_rate;

      }
      else {
          if (window.disp_currency) {
              currSymbol = CT.utils.utmCurrency.encodingValue(window.disp_currency.symbol);
              value = window.sell_currency.code + "|" + currSymbol;
              CT.utils.cookies.create('utm_currency', value, 365 * 100);
          }
          return 1;
      }
  },
  //This is to set the utm_currency cookie when the user is coming for the first time on the page
  utmCurrencyParams: function () {
      var PageUrl = window.location.href;//"https://www.cleartrip.com/flights/results?utm_currency=USD";
      var utm_loc = PageUrl.search('utm_currency');
      if (utm_loc != -1) {
          var utm_curr = PageUrl.substr(utm_loc + 13, 3);
          var i;
          if (window.currencies) {
              _.forEach(window.currencies.all, function (item) {
                  if (utm_curr === item.code) {
                      currSymbol = CT.utils.utmCurrency.encodingValue(item.symbol);
                      value = utm_curr + "|" + currSymbol;
                      CT.utils.cookies.create('utm_currency', value, 365 * 100);
                  }
              })
          }
      }
      CT.utils.utmCurrency.utmUpdateCurrencyTab();

  },
  utmShowCurrencySymbol: function () {
      //This piecec of code is to change the price on the header after itinerary page
      //if(CT.paymentBlock && CT.paymentBlock.getTotalFare())
      //$('#totFareCV #counter').html(CT.stringFormatting.formatForCurrency(CT.paymentBlock.getTotalFare(), '', true));
      $('#totFareCV #counter').html(CT.stringFormatting.formatForCurrency(window.totalfare, '', true));
      //This piece of code is for changes on the itinerary page
      $('#totalFare #counter').html(CT.stringFormatting.formatForCurrency(window.totalfare, '', true));
      //To remove insurance in case internationa users,As mentioned in AIRGROW-20
      if (disp_currency.code != sell_currency.code) {
          $('#insurance_box').removeAttr('checked');
          $('#insuranceBG').hide();
          $("#insurance_fare_block").hide();
          window.insuranceHandler(undefined);
      }
      //$('#utmCurrencyPopup').hide();

  },
  //This function is to show the default currency in the currency header tab as the one set in the cookie
  utmCurrencyHeaderTab: function (currSybStr) {
      var cookie = CT.utils.cookies.read('utm_currency');
      currSybStr="";
      if (cookie)
          cookie = CT.utils.utmCurrency.decodingValue(cookie);
      if (cookie != null && cookie != undefined) {
          var cookieValue = cookie.split("|");
          if(cookieValue[0]!=cookieValue[1])
          currSybStr = "<span class='" + cookieValue[0] + "'>&nbsp;" + unescape(cookieValue[1].replace('\\', '%')) + "</span>";
          $('.ctGlobalNav .currencyLink').html("<strong>Currency</strong>&nbsp;&nbsp;" + cookieValue[0] + "" + currSybStr);//setting the currency picker value in footer
      }
  },
  //This function is to show the default tick marked currency inside the currency menu bar as the one set in the cookie
  utmCurrencyHeaderTabTickMark: function () {
      var cookie = CT.utils.cookies.read('utm_currency');
      if (cookie)
          cookie = CT.utils.utmCurrency.decodingValue(cookie);
      if (cookie != null && cookie != undefined) {
          var cookieValue = cookie.split("|");
          $(".currencyMenu").find("li").removeClass("current");
          $(".currencyMenu").find("li").find("i.tickMark").remove()
          var currencyLi = $(".ctGlobalNav .currencyMenu").find("span." + cookieValue[0]).closest("li");
          currencyLi.addClass("current").find("a").prepend("<i class='tickMark black'></i>");
      }
  },
  //Code to show converted amount on payments page
  utmCurrencyConvertedAmount: function (balancePayable) {
      var convertedText = "<span>'" + sell_currency.code + " "+ balancePayable + "'</span>"
      $('#utmConvertedPrice').html(convertedText);
  },
  utmUpdateCurrencyTab: function () {
      var currSymbol = CT.settings.countryCurrCode[countryCode].symbol;
      var currCode = CT.settings.countryCurrCode[countryCode].code;
      var currSybStr = "";
      if (currCode !== currSymbol) {
          currSybStr = "<span class='" + currCode + "'>&nbsp;" + currSymbol + "</span>";
      }
      if (CT.utils.utmCurrency.utmCheck()) {
          CT.utils.utmCurrency.utmCurrencyHeaderTab(currSybStr);
          CT.utils.utmCurrency.utmCurrencyHeaderTabTickMark();
      }
      CT.utils.utmCurrency.hotjarEvent();
  },
  //To change the currencies inside fare breakup
  utmFareBreakup: function () {
      if (!CT.utils.utmCurrency.utmCheck())
          return;
      var values = $('.utm_curr_value');
      var tags = $('.utm_curr');
      var coupons = $('.utm_curr_coupons');
      var i = 0;
      _.forEach(values, function (item) {
          var number = item.innerText.split(",");
          var sum = "";
          var number = item.getAttribute('data-pr').replace(/,/g, '');
          var value = CT.stringFormatting.formatForCurrency(parseFloat(number), '', true);
          tags[i].className = "utm_curr " + disp_currency.code;
          tags[i].innerText = disp_currency.symbol;
          values[i].innerText = value;
          i++;
      });
      _.forEach(coupons, function (item) {
          item.className = "utm_curr_coupons " + disp_currency.code;
          item.innerText = disp_currency.symbol;
      })
  },
  //This method is to set the right selling rate and also to append the currency if currency.js file is not loaded(To avoid race condition)
  utmFareConversion: function(obj) {
      //window.isUtmCurrencyEnabled = obj.isUtmCurrencyEnabled;
      window.utmCurrencyApplied = obj.isUtmCurrencyEnabled;
      window.utmSelectedCurrency = JSON.parse(obj.utmCurrencyObject);
      //Setting the currencies object in case the file has not loaded
      if (!window.currencies && obj.utmCurrencyObject) {
          window.currencies = {
              all: [JSON.parse(obj.utmCurrencyObject)]
          }
      }
  },
  utmClevertapEvent: function() {
      var cookie = CT.utils.cookies.read('utm_currency');
      if (cookie)
          cookie = CT.utils.utmCurrency.decodingValue(cookie);
      if (cookie) {
          var cookieValue = cookie.split("|");
      return cookieValue[0];
  }
},
  hotjarEvent: function() {
      if(typeof window.hj == "function"){
          window.hj('trigger', 'UTM-Currency');

      }
  }

}
;
